<template>
<div id="explorer_main_component">
  <head>
    <meta charset="utf-8">
    <link rel="shortcut icon" type="image/png" />
    <title>FUSION</title>
  </head>
  <!-- <component :is="selectedModalComponent" v-bind="currentProperties" :basicAssetInfo="basicAssetInfo" :selectedPlugin="selectedExternalPluginInfo" :uploadDetails="uploadDetails" v-if="isModalVisible" @close="closeModal" :ref="'modal'+selectedModalComponent"></component> -->
  <router-view 
    v-if="isModalVisible" 
    :name="selectedModalComponent"
    v-bind="currentProperties" 
    :basicAssetInfo="basicAssetInfo" 
    :selectedPlugin="selectedExternalPluginInfo" 
    :closeModalComponent=closeModal
    @closeModal="closeModal" 
    :ref="'modal'+selectedModalComponent">
  </router-view>
  <div style="position:relative;" :style="licenseExpMess && licenseExpMess.trim().length?'height:calc(100vh - 30px)':'height:100vh'" ref="fadeWhenModelOpen">
      <header class="navbar navbar-expand navbar-dark DAM-navbar" style="height:64px">
              <!-- <a class="navbar-brand" href="#"></a> -->
              <div>
                <div style="height:40px;width:40px">
                  <img v-if="landingPageLogo && landingPageLogo.length > 0" :src="getProxyConvertedURL(landingPageLogo)" alt='logo' style="height:100%;width:100%;object-fit: contain;">
                  <img v-else-if="logo" :src="getProxyConvertedURL(logo)" alt='logo' style="height:100%;width:100%;object-fit: contain;">
                </div>
              </div>
              
              <div class="navbar-header container-fluid" style="margin-inline-start:32px !important;width:calc(60% - 60px)">
                <div v-if="(
                              SearchBarSupportedList.includes(isActive) &&
                              !(selectedMainComponent === 'packages-display' && 'package_id' in $route.query)
                          ) || ['media-pipeline-stage','media-pipeline','bins-browse'].includes(selectedMainComponent)" 
                     class="search-bar-autocomplete-wrapper" 
                     :class="{ 'is-smart-active': isNLPSearchMode, 'has-sparkle': allStartUpData.enable_nlp_search && selectedMainComponent == 'catalogs-display'}"
                     style="position:relative;width:75%">
                  
                  <template v-if="allStartUpData.enable_nlp_search && selectedMainComponent == 'catalogs-display'">
                    <button type="button" class="sparkle-btn-inner" title="Enable or Disable semantic search" @click="isNLPSearchMode = !isNLPSearchMode, setNLPSearchStateInLocalStorage()">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="#ddd" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2l1.2 4.2L17.4 7.4l-4.2 1.2L12 12.8l-1.2-4.2L6.6 7.4l4.2-1.2L12 2z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
                        <path d="M19 13l.7 2.4L22 16l-2.3.6L19 19l-.7-2.4L16 16l2.3-.6L19 13z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" opacity="0.85"/>
                      </svg>
                    </button>
                    <span class="sparkle-v-divider"></span>
                  </template>
              
                  <input v-if="['review-display', 'ticket-display', 'remoteEdit-display', 'edit_pro', 'projects-display'].includes(selectedMainComponent) || ['projects-display'].includes(enabledComponent)"
                         autocomplete="off" 
                         :placeholder="$t('Search')"
                         type="text" 
                         v-model="keywordFilter" 
                         ref="globalSearch"
                         @keyup.enter="keywordSearchParameters();" 
                         class="search-bar bg-transparent border border-dark rounded" 
                         name="search" 
                         id="search_bar" 
                         :style="{
                           height: '40px',
                           margin: '0px !important',
                           paddingRight: '60px',
                           paddingLeft: allStartUpData.enable_nlp_search && selectedMainComponent == 'catalogs-display' ? '45px' : '12px'
                         }">
                            <span style="width:100%;" @keyup.enter="keywordSearchParameters()">  
                              <Multiselect
                                ref="globalSearch"
                                v-if="(this.selectedMainComponent != 'review-display' && this.enabledComponent != 'projects-display' && this.selectedMainComponent != 'ticket-display' && this.selectedMainComponent != 'remoteEdit-display' && this.selectedMainComponent != 'projects-display')"
                                v-model="keywordFilter"
                                :options="searchKeywordListFromAutocomplete"
                                :key="keywordUniqeId"
                                :clear-on-select="false"
                                :custom-label="selectionLabelCallback"
                                :placeholder="(selectedMainComponent == 'bins-display')?$t('Search bins'):(selectedMainComponent == 'catalogs-display' && isNLPSearchMode && allStartUpData.enable_nlp_search)?$t('Semantic search'):$t('Search')"
                                :preserve-search="true"
                                :show-no-results="false"
                                :noOptions="true"
                                :multiple="false"
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                :allowEmpty="false"
                                :clearOnSelect="false"
                                :showNoOptions="false"
                                :searchable="true"
                                @hook:mounted ="setAutocompleteOff()"
                                @open="open"
                                @close="closed"
                                @keyup.enter="keywordSearchParameters()"
                                @search-change="getSearchKeywordsOnKeyup($event)"
                                @select="keywordOptionsOnSelectCallback($event)"
                                @input="updateEnteredKeyword($event)"
                                @remove="SearchKeywordOptionsOnRemoveCallback()"
                                :class="['search-bar', 'bg-transparent', 'border', 'border-dark', 'rounded', allStartUpData.enable_nlp_search ? 'sparkle-multiselect-adjust' : '']" 
                                :name="$t('search')" 
                                id="search_bar">
                                <!-- <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                  <span style="margin-inline-start:12px;">{{scope.option }}</span>
                                </div> -->
                                <!-- <span slot="noResult">No results.</span> -->
                              </Multiselect>
                            </span>  
                  
                  <svg v-if="keywordFilter != ''" v-on:click.prevent="clearSearchBarTextOnly()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16" style="position:absolute;inset-inline-end:32px;bottom:12px;z-index:111;color: #a5a4a4;">
                    <path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"/>
                    <path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"/>
                  </svg>
                  <svg @click.stop.prevent="triggerClickTheEnterbutton()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16" style="position:absolute;inset-inline-end:7px;bottom:12px;z-index:111">
                    <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"/>
                    <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                  </svg>
                   <svg v-if="checkContext() || enableAdvancedSearch" @click="enableAdvancedSearchFunc()" :style='enableAdvancedSearch?"fill:#0779fb":""' xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-sliders slider-icon" viewBox="0 0 16 16">
                    <title>{{enableAdvancedSearch?('Hide Advanced Search'):$t('Show Advanced Search')}}</title>
                    <path fill-rule="evenodd" d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z"/>
                  </svg>
                  <span v-if="isSearchKeyMessageShown" class="tooltip-box" :style="tooltipStyle"> {{$t("Press '/' to continue to search")}} <span class="tooltip-arrow"></span></span>
                </div>
              </div>
              <ul class="navbar-nav" style="position:relative;inset-inline-start:15px;width:40%;justify-content:flex-end">  
                <li v-if="checkIsNewButtonDropdownIsShowing()" id="DAM-explorer_global_new_button" class="nav-item" style="position: relative;display: inline-flex;align-items: center;">
                  <a id="global_new_button_div" class="nav-item nav-link d-inline-flex  dropdown-toggle pl-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="width: 100%;min-height: 38px;height: 38px;margin: 0px !important;padding: 0px 10px  !important;align-items: center;">
                    <button-with-arrow :buttonName="$t('New')" style="height:38px !important"></button-with-arrow>
                  </a>
                  <div class="dropdown-menu dropdown-menu-md-right p-0" ref="globalButtonDropdown" aria-labelledby="global_new_button_div" style="inset-inline-start:0px;"> <!-- :style="checkIsNewButtonDropdownIsShowing()?{'border':'1px solid #4a4a4a !important'}:{'border':'0px solid #4a4a4a !important'}" -->
                    <template v-if="rootPathPermission.asset_state && rootPathPermission.asset_state == 'READY'">
                    <a class="dropdown-item p-2" v-on:click="uploadFileThroughGlobalButton(false)"
                     v-if="isEnabled('Upload') && ['Catalogs', 'Bins'].includes(isActive) && ['bins','catalogs-display'].includes(createLabelName) && ['full-control','read-write'].includes(rootPathPermission.permission)"
                     style="    word-break: break-word;display: inline-flex;align-items: center;">
                     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-file-earmark-arrow-up mr-1" viewBox="0 0 16 16">
                      <path d="M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707V11.5z"/>
                      <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                    </svg>
                      <span style="word-break: break-word;display: inline-block;width: 84%;text-wrap: wrap;">{{$t('Upload File')}}</span></a>
                    <a class="dropdown-item p-2" v-if="createLabelName == 'catalogs-display' && isEnabled('manage-catalogs') && ['full-control','read-write'].includes(rootPathPermission.permission)" v-on:click="createFolderFromGlobalButton()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-folder-fill mr-1" viewBox="0 0 16 16">
                        <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                      </svg>
                      {{$t('Create Catalog')}}
                      </a>
                      <a class="dropdown-item p-2" v-else-if="createLabelName == 'bins' && permissionCheck() && isEnabled('CreateFolder') && ['full-control','read-write'].includes(rootPathPermission.permission)" v-on:click="createFolderFromGlobalButton()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-folder-fill mr-1" viewBox="0 0 16 16">
                        <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                      </svg>
                      {{$t('Create Folder')}}
                      </a>
                    </template>
                      <!-- <a class="dropdown-item p-2" v-if="isEnabled('Projects')"  v-on:click="handleNewTaskOrIssueActionClick('Task')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16" class="bi bi-ui-checks-grid mr-1"><path d="M2 10h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm9-9h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm0 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3zm0-10a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-3zM2 9a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H2zm7 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3zM0 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.354.854a.5.5 0 1 0-.708-.708L3 3.793l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0l2-2z"></path></svg>
                      {{$t('Task/ Issue')}}
                      </a> -->
                      <a class="dropdown-item p-2" v-if="isEnabled('Ticket')"  v-on:click="handleNewTaskOrIssueActionClick('Ticket')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-ticket-detailed mr-1" viewBox="0 0 16 16"><path d="M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5ZM5 7a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H5Z"/><path d="M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6V4.5ZM1.5 4a.5.5 0 0 0-.5.5v1.05a2.5 2.5 0 0 1 0 4.9v1.05a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-1.05a2.5 2.5 0 0 1 0-4.9V4.5a.5.5 0 0 0-.5-.5h-13Z"/></svg>
                      {{$t('Ticket')}}
                      </a>

                      <!--<a class="dropdown-item p-2" v-if="isEnabled('Import Assets CSV') && ['Catalogs', 'Bins'].includes(isActive) && ['full-control','read-write'].includes(rootPathPermission.permission)" v-on:click="uploadFileThroughGlobalButton(false,true)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-file-earmark-arrow-up mr-1" viewBox="0 0 16 16">
                          <path d="M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707V11.5z"/>
                          <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                        </svg>
                        {{$t('Import CSV file')}}
                      </a> -->
                      
                     <template v-for="globalNewButton in getRegisteredGlobalNewButtons()">
                        <a class="dropdown-item p-2" 
                            :ref="globalNewButton.plugin_name+'_'+globalNewButton.globalButtonMenuName"  
                            :key="globalNewButton._id" 
                            v-if="globalNewButton.conditionEvalCallback(explorerComponentThis)" 
                            v-on:click="globalNewButton.callback(globalNewButton,explorerComponentThis)">  <!-- :style="(globalNewButton.globalButtonMenuName == 'Task' || globalNewButton.globalButtonMenuName == 'Issue')?'display:none':''" -->
                            <span v-html="globalNewButton.svgIcon()"></span>
                            {{$t(globalNewButton.globalButtonMenuName)}}
                          </a>
                      </template> 

                  </div>
                </li>
                <li v-if="checkIsLanguageDropdownIsShowing()" id="dam_explorer_global_language_button" class="nav-item" style="position:relative;display:inline-flex;align-items:center">
                  <Multiselect
                      :value="getLanguageMap(selectedLanguage)"
                      :options="languagesList"
                      label="name"
                      track_by="_id"
                      :placeholder="$t('Language')"
                      :hideSelected="false"
                      :close-on-select="true"
                      deselectLabel=""
                      selectLabel=""
                      selectedLabel=""
                      :showNoOptions="false"
                      class="align-input-field"
                      @select="handleLanguageSelection($event)"
                      ref="languagesDropdown"
                      >
                      <span slot="noResult">No results.</span>
                  </Multiselect>
                </li>
                <li v-show="!isClientUser()" class="nav-item" style="position: relative;inset-inline-start :4px;display: inline-flex;align-items: center;margin-inline-start:4px;">
                  <a class="nav-item nav-link" v-on:click="handleUserNotificationDisplayState()" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-bell-fill" viewBox="0 0 16 16" style="    position: relative;">
                    <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z"/>
                  </svg>
                  </a>
                  <div v-if="enableUserNotificationBadge" title="New notification !!" class='notification-badge'></div>
                </li>
                <li v-if="['Catalogs','Bins'].includes(isActive) && ['full-control','read-write','read-modify','read'].includes(rootPathPermission.permission) && isEnabled('Share')">
                  <a class="nav-item nav-link"  v-on:click.prevent="openShareWindow()" id="bd-versions"  aria-haspopup="true" aria-expanded="true" style="padding:11px;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#C5c0c0" class="bi bi-share-fill" viewBox="0 0 16 16">
                    <title>{{$t('Share')}}</title>
                    <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                  </svg>
                  </a>
                </li>
                <li v-if="['Catalogs','Bins'].includes(isActive)" id="view_type" ref="catalogViewSelector" class="nav-item catalog-view-selector" @keydown.esc.stop="closeCatalogViewMenu">
                      <button type="button" class="catalog-view-trigger" @click.stop="catalogViewMenuOpen = !catalogViewMenuOpen" :aria-expanded="catalogViewMenuOpen" aria-haspopup="true" :title="isMetadataView && isActive === 'Catalogs' ? $t('Metadata view') : (gridView ? $t('Thumbnail view') : $t('List view'))" :aria-label="$t('View options')">
                        <template v-if="isMetadataView && isActive === 'Catalogs'"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M1 1h14v14H1zm1 1v12h3V2zm4 0v12h4V2zm5 0v12h3V2z" fill-rule="evenodd"/></svg></template>
                        <template v-else-if="gridView"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M1 1h6v6H1zm8 0h6v6H9zM1 9h6v6H1zm8 0h6v6H9z"/></svg></template>
                        <template v-else><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M1 2h2v2H1zm4 0h10v2H5zM1 7h2v2H1zm4 0h10v2H5zM1 12h2v2H1zm4 0h10v2H5z"/></svg></template>
                        <svg class="catalog-view-chevron" viewBox="0 0 16 16" aria-hidden="true"><path d="m4 6 4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      </button>
                    <div v-if="catalogViewMenuOpen" class="catalog-view-menu" @click.stop>
                      <div class="catalog-view-menu-label">{{ $t('View') }}</div>
                      <div class="catalog-view-options view-icons" role="group" :aria-label="$t('View')">
                        <button type="button" :title="$t('Thumbnail view')" :aria-label="$t('Thumbnail view')" :class="{ selected: gridView && !(isMetadataView && isActive === 'Catalogs') }" :aria-pressed="gridView && !(isMetadataView && isActive === 'Catalogs')" @click="selectCatalogView('thumbnail')"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M1 1h6v6H1zm8 0h6v6H9zM1 9h6v6H1zm8 0h6v6H9z"/></svg></button>
                        <button type="button" :title="$t('List view')" :aria-label="$t('List view')" :class="{ selected: !gridView && !(isMetadataView && isActive === 'Catalogs') }" :aria-pressed="!gridView && !(isMetadataView && isActive === 'Catalogs')" @click="selectCatalogView('list')"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M1 2h2v2H1zm4 0h10v2H5zM1 7h2v2H1zm4 0h10v2H5zM1 12h2v2H1zm4 0h10v2H5z"/></svg></button>
                        <button v-if="isActive === 'Catalogs'" type="button" :title="$t('Metadata view')" :aria-label="$t('Metadata view')" :class="{ selected: isMetadataView }" :aria-pressed="isMetadataView" @click="selectCatalogView('metadata')"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M1 1h14v14H1zm1 1v12h3V2zm4 0v12h4V2zm5 0v12h3V2z" fill-rule="evenodd"/></svg></button>
                      </div>
                      <template v-if="isActive === 'Catalogs' && gridView && !(isMetadataView && isActive === 'Catalogs')">
                        <div class="catalog-view-menu-label size-label">{{ $t('Card size') }}</div>
                        <input class="thumbnail-size-slider" type="range" min="160" max="300" step="10" :value="thumbnailSize" :style="{ '--slider-progress': ((thumbnailSize - 160) / 140 * 100) + '%' }" :aria-label="$t('Thumbnail size')" @input="setThumbnailSize($event.target.value)">
                        <div class="catalog-view-menu-label size-label">{{ $t('Aspect ratio') }}</div>
                        <div class="catalog-view-options view-icons" role="group" :aria-label="$t('Aspect ratio')">
                          <button v-for="ratio in ['landscape', 'square', 'portrait']" :key="ratio" type="button" :title="ratio === 'landscape' ? '16:9' : ratio === 'square' ? '1:1' : '9:16'" :aria-label="ratio === 'landscape' ? '16:9' : ratio === 'square' ? '1:1' : '9:16'" :aria-pressed="thumbnailAspectRatio === ratio" :class="{ selected: thumbnailAspectRatio === ratio }" @click="setThumbnailAspectRatio(ratio)"><span class="ratio-icon" :class="ratio"></span></button>
                        </div>
                        <div class="catalog-view-menu-label size-label">{{ $t('Thumbnail scale') }}</div>
                        <div class="catalog-view-options" role="group" :aria-label="$t('Thumbnail scale')">
                          <button v-for="scale in ['fit', 'fill']" :key="scale" type="button" :class="{ selected: thumbnailScale === scale }" :aria-pressed="thumbnailScale === scale" @click="setThumbnailScale(scale)">{{ $t(scale === 'fit' ? 'Fit' : 'Fill') }}</button>
                        </div>
                      </template>
                    </div>
                </li>
                <li v-if="['Ticket'].includes(isActive) || $route.name == 'issues-projects' ||  $route.name == 'tasks-projects'" id="view_type" class="nav-item" style="display: inline-flex;align-items: center;margin-inline-start:4px;">
                  <div id="project_view_type" class="nav-item" style="width: 48px;float: inline-end;position: relative;display: inline-flex;justify-content: center;height: 100%;align-items: center;">
                      <a class="nav-item nav-link"  v-on:click="changeTaskIssueViewTypes()" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="padding: 5px;width: 100%;height: 100%;display: inline-flex;align-items: center;justify-content: center;">
                      <!-- <svg xmlns="http://www.w3.org/2000/svg" v-if="isIssueDetailsWindowShow" width="2em" height="2em" fill="#C5c0c0" class="bi bi-grid-3x3-gap-fill" viewBox="0 0 16 16">
                          <title>{{$t('Switch to Grid view')}}</title>
                          <path d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2z"/>
                      </svg> -->
                      <svg xmlns="http://www.w3.org/2000/svg" v-if="taskIssueListView" width="1.5rem" height="1.5rem" fill="currentColor" class="bi bi-layout-text-sidebar-reverse" viewBox="0 0 16 16">
                          <title>{{$t('Switch to Details view')}}</title>
                          <path d="M12.5 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm.5 3.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m-.5 2.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"/>
                          <path d="M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM4 1v14H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm1 0h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5z"/>
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" v-if="!taskIssueListView" width="2em" height="2em" fill="#C5c0c0" class="bi bi-list-task" viewBox="0 0 16 16">
                          <title>{{$t('Switch to Table view')}}</title>
                          <path fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z"/>
                          <path d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z"/>
                          <path fill-rule="evenodd" d="M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z"/>
                      </svg>
                      </a>
                  </div> 
                </li>  

                <li class="nav-item dropdown show">
                  <a id="DAM-my_preferences_explorer" class="nav-item nav-link dropdown-toggle profile-img-option" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <div v-if="Object.keys(getLoggedInUserInfo).includes('profile_image') && !['undefined',null].includes(getLoggedInUserInfo.profile_image) && getLoggedInUserInfo.profile_image" class='user-name-or-image' style="margin-top:0px">
                          <img :src="getProxyConvertedURL(getLoggedInUserInfo.profile_image)" @error="replaceWithUserIcon($event)" style="max-width: 100%;
                              max-height: 100%;
                              border-radius: 6px;
                              object-fit: contain;
                              width: 100%;
                              height: 100%;
                              border-radius: 9px;
                          ">
                      </div>
                      <div v-else class="user-name-or-image user-name" :style="style(getLoggedInUser)">{{ getLoggedInUser.split("")[0] }}</div>
                  </a>
                  <div  class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="DAM-my_preferences_explorer">
                    <a class="dropdown-item p-2 d-flex">
                      <div v-if="Object.keys(getLoggedInUserInfo).includes('profile_image') && !['undefined',null].includes(getLoggedInUserInfo.profile_image) && getLoggedInUserInfo.profile_image" class='user-name-or-image' style="margin-inline-end: 9px;">
                          <img :src="getProxyConvertedURL(getLoggedInUserInfo.profile_image)" @error="replaceWithUserIcon($event)" style="max-width:100%;max-height: 100%;
                              border-radius: 6px;
                              object-fit: contain;
                              width: 100%;
                              height: 100%;
                              border-radius: 9px;">
                      </div>
                      <div v-else class="user-name-or-image user-name" :style="style(getLoggedInUser)" style="margin-inline-end:10px">{{ getLoggedInUser.split("")[0] }}</div>
                      <!-- <svg width="20" height="20" viewBox="0 0 16 16" class="bi bi-person-circle"  style="margin-inline-end: 4px;"  fill="#c5c0c0" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.468 12.37C12.758 11.226 11.195 10 8 10s-4.757 1.225-5.468 2.37A6.987 6.987 0 0 0 8 15a6.987 6.987 0 0 0 5.468-2.63z"/>
                        <path fill-rule="evenodd" d="M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                        <path fill-rule="evenodd" d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8z"/>
                      </svg> -->
                      <div style="display: flex;align-items: center;font-size: 18px;">{{getLoggedInUser}}</div></a>
                    <a class="dropdown-item p-2" v-on:click="changeModalComponent('user-info')">
                            <svg width="20" height="20" viewBox="0 0 16 16" class="bi bi-pencil-square" style="margin-inline-end: 8px;"  fill="#c5c0c0" xmlns="http://www.w3.org/2000/svg">
                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                              <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                            </svg>
                      <span>{{$t('My Preferences')}}</span></a>
                    <a class="dropdown-item p-2" v-on:click="changeModalComponent('terms_of_service')">
                        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96.17 122.88" style="margin-inline-end: 7px;margin-inline-start:2px;" fill="#c5c0c0"><title>terms-and-conditions</title>
                            <path d="M62.74,110.31,84.22,87.73H62.74v22.58ZM22.57,45.94V26H16V19.86H35.94V26H29.38v20Zm48.59.21a13.82,13.82,0,0,1-4-.53,6.52,6.52,0,0,1-3-1.93,9.48,9.48,0,0,1-1.93-4,29.06,29.06,0,0,1-.66-6.85,26.2,26.2,0,0,1,.7-6.67,9.71,9.71,0,0,1,2-4,6.71,6.71,0,0,1,3-2,13,13,0,0,1,3.86-.54,27.32,27.32,0,0,1,3.84.23,23,23,0,0,1,2.84.54,12.74,12.74,0,0,1,1.88.63v5.3c-.44-.09-1-.19-1.72-.28s-1.5-.17-2.4-.23-1.88-.09-2.93-.09a7.27,7.27,0,0,0-2,.25,2.35,2.35,0,0,0-1.32,1,5.6,5.6,0,0,0-.72,2.16,25.12,25.12,0,0,0-.23,3.77,28.25,28.25,0,0,0,.18,3.51,6.08,6.08,0,0,0,.63,2.2,2.55,2.55,0,0,0,1.32,1.12,6.28,6.28,0,0,0,2.23.33c1.77,0,3.22,0,4.33-.09s2-.13,2.65-.22V45a12.35,12.35,0,0,1-2,.59,24.09,24.09,0,0,1-2.76.39c-1,.09-2.3.14-3.75.14Zm-25.11.19a10.57,10.57,0,0,1-4.72-1,7.29,7.29,0,0,1-3-2.6,6.46,6.46,0,0,1-1.06-3.6,5.58,5.58,0,0,1,.55-2.54,6.92,6.92,0,0,1,1.53-2,17.25,17.25,0,0,1,2.3-1.82l5.79-3.59a3.23,3.23,0,0,0,1.18-1.14A2.32,2.32,0,0,0,48.89,27a1.57,1.57,0,0,0-.44-1.08,1.81,1.81,0,0,0-1.4-.46,2.25,2.25,0,0,0-1,.21,1.6,1.6,0,0,0-.65.61,1.7,1.7,0,0,0-.24.92,3,3,0,0,0,.43,1.5C47.89,32.94,57.14,42,60.76,45.94H53.88L43.51,35c-.51-.54-1.07-1.2-1.69-2a12.63,12.63,0,0,1-1.58-2.66,7.69,7.69,0,0,1-.67-3.23,7,7,0,0,1,.93-3.55A7.1,7.1,0,0,1,43.12,21a7.92,7.92,0,0,1,3.93-1,7.33,7.33,0,0,1,3.69.89,6.38,6.38,0,0,1,2.4,2.35A6.45,6.45,0,0,1,54,26.5a6.57,6.57,0,0,1-.88,3.32,8.68,8.68,0,0,1-2.51,2.71c-1.51,1.06-5.32,3.42-6.34,4.71a2.15,2.15,0,0,0-.44,1.42,2.2,2.2,0,0,0,.34,1.24,2.12,2.12,0,0,0,1,.78,3.57,3.57,0,0,0,1.45.27,5.63,5.63,0,0,0,2.54-.62,7.73,7.73,0,0,0,2.34-1.73,8.54,8.54,0,0,0,2.35-6h5.43a19.27,19.27,0,0,1-.46,4.27,12.73,12.73,0,0,1-1.48,3.77,9.58,9.58,0,0,1-2.69,2.88l-1,.49-1,.5a10.38,10.38,0,0,1-3.2,1.39,13.9,13.9,0,0,1-3.28.41ZM18.93,90H38.16v5.53H18.93V90Zm0-14H46.22v5.53H18.93V76Zm0-14h58.3v5.53H18.93V61.94ZM96.17,84.85a3.58,3.58,0,0,1-2.61,3.45L61.93,121.56a3.55,3.55,0,0,1-2.76,1.32H6.43A6.42,6.42,0,0,1,0,116.45V6.43A6.42,6.42,0,0,1,6.43,0H89.74a6.44,6.44,0,0,1,6.43,6.43V84.85ZM89,80.55V7.18H7.18V115.73H55.56V84.16a3.61,3.61,0,0,1,3.61-3.61Z"/>
                        </svg>
                        <span>{{$t('Terms of Service')}}</span>
                    </a>
                    <a class="dropdown-item p-2" v-on:click="changeModalComponent('privacy_policy')">
                        <svg width="20" height="20" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 116.42 122.88" style="margin-inline-end: 7px;margin-inline-start:2px;" fill="#c5c0c0"><title>privacy-policy</title>
                            <path class="cls-1" d="M88.08,60.79c10.53,6.67,20,9.83,28.22,9.09,1.42,28.85-9.23,45.89-28.11,53-18.24-6.66-29-23-28.23-53.44a40.39,40.39,0,0,0,28.12-8.65ZM62.9,12.13l20.72,19.4H62.9V12.13ZM21.27,56H63.14c2.74,0,3.1,3.75,1.32,5-.83.15-1.65.28-2.48.39H21.3c-3.22,0-3.22-5.33,0-5.38Zm0,16.74H50.46c.08,1.84.21,3.63.37,5.38H21.3c-3.24,0-3.2-5.38,0-5.38Zm0,16.74H52.48c.38,1.85.81,3.65,1.29,5.38H21.3c-3.24,0-3.2-5.38,0-5.38Zm0-50.22H45.36c3.24,0,3.2,5.37,0,5.37H21.3c-3.24,0-3.21-5.37,0-5.37Zm0-15.57H34.52c3.19,0,3.23,5.37,0,5.37H21.3c-3.24,0-3.2-5.37,0-5.37ZM95.15,34.32A3.44,3.44,0,0,0,92.64,31L62.12,1.27A3.43,3.43,0,0,0,59.45,0H6.2A6.2,6.2,0,0,0,0,6.2V112.35a6.21,6.21,0,0,0,6.2,6.2H66a51.93,51.93,0,0,1-5.08-6.93h-54V6.89H56V35a3.47,3.47,0,0,0,3.47,3.48H88.22V50.33q3.52,2.22,6.93,4.05V34.32ZM88.3,70.66c7.19,4.55,13.68,6.71,19.25,6.2,1,19.68-6.3,31.3-19.17,36.14a2.34,2.34,0,0,1-.24-.09V70.79l.16-.13Zm-.21-6.31c9.32,5.91,17.75,8.71,25,8.05,1.26,25.54-8.17,40.62-24.89,46.91C72,113.42,62.49,99,63.2,72a35.74,35.74,0,0,0,24.89-7.66Z"/>
                        </svg>
                        <span>{{$t('Privacy Policy')}}</span>
                    </a>
                    <a class="dropdown-item p-2" v-on:click='logout()'>
                      <svg width="20" height="20" viewBox="0 0 16 16" class="bi bi-box-arrow-right"  style="margin-inline-end: 7px;margin-inline-start:2px;" fill="#c5c0c0" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"/>
                        <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>
                      </svg>
                      <span>{{$t('Logout')}}</span>
                    </a>
                  </div>
                </li>
                <li v-show="!isClientUser()" class="nav-item dropdown show">
                  <a class="nav-item nav-link dropdown-toggle" @mouseover="showHelp=false,showBookmark=false" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#c5c0c0" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                    </svg>
                  </a>
                  <div class="dropdown-menu dropdown-menu-md-right p-0"  aria-labelledby="bd-versions">
                    <a class="dropdown-item p-2" @mouseover="showHelp=false,showBookmark=false" v-for="panelOverfowMenu in getRegisteredOverFlowMenu()" :key="panelOverfowMenu.label" @click="getEventHandler(panelOverfowMenu,'onClick',panelOverfowMenu.onEvents)">
                      <div v-html="panelOverfowMenu.iconSvgCallback($t(panelOverfowMenu.label))"></div></a>
                      <a class="dropdown-item p-2" v-on:click="openAssetFavouriteAdmin()" v-if="isEnabled('manage-favorites')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="bi bi-star" viewBox="0 0 16 16" fill="currentColor" style="margin-inline-end: 4px;">
                          <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z"/>
                        </svg>
                        <span style="position: relative;top: 3px;">{{$t("Assets Favourites")}}</span>
                     </a>
                     <a class="dropdown-item p-2" @mouseover="showBookmark=true,showHelp=false" style="position:relative">
                      <svg xmlns="http://www.w3.org/2000/svg" style="position: relative;inset-inline-start :2px;bottom: 0px;" width="16" height="16" fill="currentColor" class="bi bi-bookmark" viewBox="0 0 16 16">
                        <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z"/>
                      </svg>
                      <span class="p-2">{{$t("Bookmarks")}}
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-chevron-right comm-icon-rtl" style="position: absolute;inset-inline-end :10px;top: 11px;" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                        </svg>
                      </span>
                        <div class="help-menu p-0" v-if="showBookmark">
                          <a @click="addBookmark = true" class="dropdown-item p-2">
                            <span>{{$t('Add Bookmarks')}}</span>
                          </a>
                          <a v-on:click="changeToManageFavourites('user-info')" class="dropdown-item p-2">
                            <span>{{$t('Manage Bookmarks')}}</span>
                          </a>
                          <a v-on:click="showBookMarks = !showBookMarks" class="dropdown-item p-2">
                            <span>{{showBookMarks?$t('Hide Bookmarks'):$t('Show Bookmarks')}}</span>
                          </a>
                          <hr style="border-top: 1px solid #353535;margin: 6px;">
                          <a v-for="fav in getOnlyBookMarks" :key="fav._id" @click="loadSelectedFavourite(fav)" class="dropdown-item p-2" style="display:flex;align-items:center">
                                <div v-if="getfavThumbnail(fav)" style="height: 20px;width: 20px;">
                                  <img :src="getfavThumbnail(fav)" style="height:100%;width:100%;border-radius: 7px;">
                                </div>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="15" fill="currentColor" class="bi bi-bookmark" viewBox="0 0 16 16">
                                  <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z"/>
                                </svg>
                                <div class="ml-2">{{fav.name}}</div>
                          </a>
                        </div>
                      </a>
                    <a class="dropdown-item p-2" @mouseover="showHelp=true,showBookmark=false" style="position:relative">
                        <svg xmlns="http://www.w3.org/2000/svg" style="position: relative;inset-inline-start :2px;bottom: 2px;" width="16" height="16" fill="currentColor" class="bi bi-question-circle-fill" viewBox="0 0 16 16">
                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
                        </svg>
                        <span class="p-2">{{$t("Help")}} <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-chevron-right comm-icon-rtl" style="position: absolute;inset-inline-end :10px;top: 11px;" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                        </svg></span>
                      <div class="help-menu p-0" v-if="showHelp">
                        <a class="dropdown-item p-2" v-on:click="openAboutDAM()">
                          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-app" viewBox="0 0 16 16">
                            <path d="M11 2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h6zM5 1a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4H5z"/>
                          </svg> -->
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                          </svg>
                          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill" viewBox="0 0 16 16">
                            <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.93 4.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
                          </svg> -->
                          <span class="p-2" style="position: relative;top: 2px;">{{$t('About FUSION')}}</span></a>
                        <!-- <a class="dropdown-item p-2" v-on:click="openHelpManual()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                              <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                            </svg>
                            <span class="p-2" style="position: relative;top: 2px;">Help Manual</span></a> -->
                        <a class="dropdown-item p-2" v-on:click="openReportAnIssue()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                            </svg>
                            <span class="p-2" style="position: relative;top: 2px;">{{$t('Report an Issue')}}...</span></a>
                      </div>
                    </a>
                  </div>
                </li>
              </ul>
          </header>
      <div class="container-fluid sidenav">
          <!-- <component v-if="externalPluginComponent != null"  v-bind="currentProperties" :is="externalPluginComponent" @close="closeExternalPlugin"></component> 
          <div  v-else style="height:inherit;display:inline-flex;width:100%">  commented after conflict 08-12-21 -->
          
          <div v-if="enabledComponent != null">
              <router-view :name="enabledComponent"
                @closeExternalPlugin="closeExternalPlugin"
                :ref="'fullScreencomponent'+enabledComponent"
                @clearSearchData="clearSearchData"
                @retainSearchedKeywordToExplorer="retainSearchedKeywordToExplorer"
                :taskIssueListView="taskIssueViewType"
                @taskIssueListViewChangeinExporer="taskIssueListViewChangeinExporer">
              </router-view>
          </div>
          <div v-else style="height:100%;display:inline-flex;width:100%"> 
            <quickAccessPanel ref="quickAccessPanelRef" :newMessageNotificationTagVisible="newMessageNotificationTagVisible" @unsetComponent="unsetComponent" @navigateToSelectedPanel="getEventHandler" :selectFirstMenu="selectFirstMenu" :isActive="isActive"></quickAccessPanel>
            <!-- <div class="sidebar-main p-0" style="width:6%;position:relative">
              <nav class="sidebar-wrapper" id="home_page_sidemenu" style="height:100%;overflow:auto;overflow-x: hidden;">
              <ul class="sidebar-menu move-center-vertically" style="list-style-type:none;padding:4px;position:relaive">
                <template v-for="panel in getSortedQuickAccessPanel.filter(op=> op.pluginName != 'Favorites')">
                  <template v-if="panel.quick_access_registry && panel.quick_access_registry.length">
                    <li v-for="multiPanel in panel.quick_access_registry" class="sidebar text-leftd-inline-block w-100"
                      :key="multiPanel._id" :id="multiPanel.name" :class="{activePanel: isActive === multiPanel._id}"
                        @click="getEventHandler(panel,'onClick',panel.onEvents,multiPanel)" style="position:relative">
                      <div v-html="panel.iconSvgCallback('','2em','1.5em')" class="text-center" style="position:relative">
                      </div>
                      <span>{{$t(multiPanel.name)}}</span>
                    </li>
                  </template>
                  <li v-else class="sidebar text-leftd-inline-block w-100"
                    :key="panel.label" :id="panel.pluginName" :class="{activePanel: isActive === panel.label ||
                    (isActive === 'Chat' && panel.label === 'Chat Pro') ||
                    (![undefined,null].includes(isActive) && isActive.toLowerCase() === panel.pluginName.toLowerCase())}"
                      @click="getEventHandler(panel,'onClick',panel.onEvents)" style="position:relative">
                    <div v-html="panel.iconSvgCallback('','2em','1.5em')" class="text-center" style="position:relative">
                    </div>
                    <span>{{$t(panel.label)}}</span>
                    <div v-if="(panel.label == 'Chat' || panel.label === 'Chat Pro') && newMessageNotificationTagVisible" class='new-tag-styles'>New</div>
                  </li>
                </template>
                <li class="sidebar text-leftd-inline-block w-100"  v-for="panel in getSortedQuickAccessPanel.filter(op=>op.pluginName == 'Favorites')"
                  :key="panel.label" :id="panel.pluginName" :class="{activePanel: isActive === panel.label ||
                   (isActive === 'Chat' && panel.label === 'Chat Pro') ||
                   (![undefined,null].includes(isActive) && isActive.toLowerCase() === panel.pluginName.toLowerCase())}"
                    @click="getEventHandler(panel,'onClick',panel.onEvents)" style="position:relative"  :title="panel.label">
                  <div v-if="panel.iconUrl" style="height: 35px;width: 35px;">
                    <img :src="panel.iconUrl" style="height:100%;width:100%;border-radius: 7px;">
                  </div>
                  <div v-else v-html="panel.iconSvgCallback('','2em','1.5em')" class="text-center" style="position:relative">
                  </div>
                  <span style="white-space: nowrap;width: 64px;overflow: hidden;text-overflow: ellipsis;">{{panel.label}}</span>
                  <div v-if="(panel.label == 'Chat' || panel.label === 'Chat Pro') && newMessageNotificationTagVisible" class='new-tag-styles'>New</div>
                </li>


              
                <template v-if="getMediaPipelineStagesFromStartupdata.length > 0">
                  <li class="sidebar text-leftd-inline-block w-100"  v-for="panel in getMediaPipelineStagesFromStartupdata"
                    :key="panel.name" :id="panel._id" :class="{activePanel: isActive === panel._id ||
                      (isActive === 'Chat' && panel.label === 'Chat Pro') ||
                      (![undefined,null].includes(isActive) && isActive.toLowerCase() === panel._id.toLowerCase())}"
                      @click="getEventHandler(panel,'onClick')" style="position:relative"  :title="panel.label">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-layout-text-window-reverse" viewBox="0 0 16 16" style="min-width: 16px;min-height: 16px;">
                        <path d="M13 6.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5m-.5 2.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"/>
                        <path d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM2 1a1 1 0 0 0-1 1v1h14V2a1 1 0 0 0-1-1zM1 4v10a1 1 0 0 0 1 1h2V4zm4 0v11h9a1 1 0 0 0 1-1V4z"/>
                      </svg>
                    <span style="overflow-wrap: break-word;">{{panel.name}}</span>
                  </li>
                </template>
                <template v-if="getMediaPipelinesFromStartupData.length > 0">
                  <li class="sidebar text-leftd-inline-block w-100" v-for="panel in getMediaPipelinesFromStartupData" :key="panel.pipeline_name" :class="{activePanel: isActive === panel._id ||
                      (![undefined,null].includes(isActive) && isActive.toLowerCase() === panel._id.toLowerCase())}"
                      @click="getEventHandler(panel,'onClick')" style="position:relative"  :title="panel.pipeline_name">
                      <svg xmlns="http://www.w3.org/2000/svg" style="transform: rotate(90deg);" width="16" height="16" fill="currentColor" class="bi bi-kanban" viewBox="0 0 16 16">
                        <path d="M13.5 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm-11-1a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                        <path d="M6.5 3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm-4 0a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1zm8 0a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1z"/>
                      </svg>
                    <span style="overflow-wrap: break-word;">{{panel.pipeline_name}}</span>
                  </li>
                </template> 
              </ul>
              </nav>
              <div style="position: absolute;bottom: 0px;width: 100%;background: #15171b;inset-inline-end :5px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-three-dots" viewBox="0 0 16 16">
                  <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/>
                </svg>
                <div class="dropdown-menu dropdown-menu-md-right p-0">
                  <a @click="enableConfigMode = true" class="dropdown-item p-2">
                      <span>{{$t('Edit')}}</span>
                  </a>
              </div>
              </div>
            </div> -->
            <div class="p-0 d-inline-flex h-100" style="width:93%">
                <div class="h-100 p-0 w-100" :class="{unhideMetaDockComponent : 'col-md-8', getIsAssetsDetailsPanelVisible : 'col-md-12'}" style="overflow:auto">
                  <bookmarksbar v-if="showBookMarks" :favoritesList="favoritesList" @loadSelectedFavourite="loadSelectedFavourite" @showFavouriteEditWindow="showFavouriteEditWindow" @hideBookmarksBar="showBookMarks = false" @showFavouritesInMyPreferences="changeToManageFavourites"></bookmarksbar>
                  <config-advanced-search :key="$route.fullPath" v-if="['Catalogs'].includes(isActive) && checkIfAdvancedSearchEnabled()" @loadSelectedFavourite="loadSelectedFavourite" :isNLPSearchMode="isNLPSearchMode" :searchContext="createLabelName" compType="mainComp"
                  @advancedSearchData="advancedSearchData" @hideAdvancedSearch="enableAdvancedSearch = false" @showFavouriteEditWindow="showFavouriteEditWindow" @showFavouritesInMyPreferences="changeToManageFavourites" :favoritesList="favoritesList" ref="advanceSearchRef"></config-advanced-search>
                  <advanced-search :key="$route.fullPath" v-else-if="enableAdvancedSearch"  :searchContext="createLabelName" compType="mainComp"
                  @advancedSearchData="advancedSearchData" ref="advanceSearchRef" class="global-advanced-search-bar"></advanced-search>

          <!--         <iframe 
                    id="workspace-plugin-iframe"
                    style="width:0px;height:0px;border:0px;display: none;"
                    ref="iframeExternalPluginDialog" 
                    frameBorder="0"></iframe>

                  <iframe 
                    id="media-share-externalplugin"
                    style="width:0px;height:0px;border:0px;display: none;"
                    ref="iframeExternalPluginDialog" 
                    frameBorder="0"></iframe> -->
                  <router-view
                    :basicAssetInfo="basicAssetInfo" 
                    class="resized-component"
                    :name="selectedMainComponent"
                    :isMetadataView="isMetadataView" 
                    :view-type="viewType"
                    :thumbnail-size="thumbnailSize"
                    :thumbnail-aspect-ratio="thumbnailAspectRatio"
                    :thumbnail-scale="thumbnailScale"
                    :transcriptPlayObject="transcriptPlayObject" 
                    :autoPlay='autoPlay' 
                    @hook:beforeDestroy="subclipAssetDetails = {}; transcriptPlayObject = {};"
                    :subclipDetails="subclipAssetDetails"
                    :taskIssueListview="taskIssueViewType"
                    @taskIssueListViewChangeinExporer="taskIssueListViewChangeinExporer"
                    :style="{'height':resizedHeight}"
                    :ref="'maincomponent'+selectedMainComponent"
                    :refreshFileInfoAndShowAsset="refreshFileInfoAndShowAsset"
                    :getCookieValueOfJobPanel='getCookieValueOfJobPanel'
                    :enableAdvancedSearch='enableAdvancedSearch'
                    :isNLPSearchMode="isNLPSearchMode"
                    v-bind="currentProperties"
                    @hook:mounted="startVueTour()"
                    @updateActiveBinIdInWorkspace="handleActiveBinIdInWorspace"
                    @changeModalComponent="changeModalComponent" 
                    @changeSelectedMainComponent="changeSelectedMainComponent" 
                    @showAssetDetailsDiv="showAssetsDataOnDoubleClick" 
                    @selectedSingleFile='selectedSingleFile' 
                    @selectedMultipleFiles='selectedMultipleFiles' 
                    @closePanels="closePanels" 
                    @clearSearchData="clearSearchData" 
                    @rootPathPermissionUpdated="rootPathPermissionUpdate"
                    @handleNewTaskOrIssueAction="handleNewTaskOrIssueActionClick"
                    @handleShareAction="openShareWindow"
                    @handleCatalogPageReferesh="updateCatalogPageRefresh"
                    @reshareAssetSignal="handleReshareAssetInfo"
                    @retainSearchedKeywordToExplorer="retainSearchedKeywordToExplorer"
                    @checkIfAdvancedSearchVisible="checkIfAdvancedSearchVisible"
                    :pamLocationInfo="lastPamLocationInfo"
                    @openAdvancedSearch="openAdvancedSearch"
                    @changeJobsPanelState="changeJobsPanelState"
                    @hideMiniPlayerOnContextMenuDeselect="hideMiniPlayerOnContextMenuDeselect"
                    @updateSearchedTranscriptSelection="updateSearchedTranscriptSelection">
                  ></router-view>
                </div>
                <Asset-Details :transcriptPlayObject="transcriptPlayObject" :autoPlay='autoPlay' @hook:beforeDestroy="subclipAssetDetails = {}; transcriptPlayObject = {};" :subclipDetails="subclipAssetDetails" ref="assetDetailsDocPanel" v-if="['Catalogs','Bins'].includes(isActive) && getIsAssetsDetailsPanelVisible && !isMetadataView" :fileInfo="selectedFileDetails.singlefile" :basicAssetInfo="basicAssetInfo" @hideAssetDetails="hideAssetDetailsShowMiniplayer" class="col-md-4 assets-details-wrapper p-0"></Asset-Details>
                <metadata-dock :searchedText="searchedValue" :fileInfo="selectedFileDetails.singlefile" class="col-md-4 p-0" ref="metadataDockWidget" :playVideoOnOpen="showAssetsDataOnDoubleClick" :refreshFileInfoAndShowAsset="refreshFileInfoAndShowAsset" style="background:#1a1e21;border-inline-start:1px solid #2b2b2b" :basicAssetInfo="basicAssetInfo" v-if="unhideMetaDockComponent && !isMetadataView"
                  @selectTagsFromBrowse="selectTagsFromBrowse" @selectCategoryFromBrowse="selectCategoryFromBrowse" @openSubclipWindow="openSubclipWindow" @AIComponentNavigation="traverseToAIComp"></metadata-dock>
            </div>
          </div>
      </div>
    </div>
  <actions-icons v-if="['Catalogs','Bins'].includes(isActive) && !isMetadataView" @showMetadataDockPanel="showMetadataDock"></actions-icons>
  <template v-if="!isTypeCatalog">
    <mini-player ref="miniPlayerRef" :autoPlay='autoPlay' @hook:beforeDestroy="subclipAssetDetails = {}; transcriptPlayObject = {};" :transcriptPlayObject="transcriptPlayObject" @maximisePlayer="showAssetDetailsDockCloseMiniplayer" :subclipDetails="subclipAssetDetails" :selectedFile="assetInfoDetails" @closeMiniPlayer="closeMinimisedPlayer" v-if="getisMiniplayerVisible && showVideoMiniplayer && ((selectedAsset.asset_type && selectedAsset.asset_type != 'catalog') || !selectedAsset.asset_type)"></mini-player>
    <ImagePreviewDialog class="hide-element-util-mount" v-cloak @maximisePlayer="showAssetDetailsDockCloseMiniplayer" :selectedFile="selectedAsset" @closeMiniPlayer="closeMinimisedPlayer" v-if="showOtherFilesPreviewDialog"></ImagePreviewDialog>
  </template>
  <select-tags ref="tagBrowserWidget" v-if="idTagsBrowse" :fileInfo="selectedAsset"
  :refreshFileInfoAndShowAsset="refreshFileInfoAndShowAsset"
  :selectedTagIdList = selectedTags
  @close="closeTagsBrowse"></select-tags>
  <upload-panel v-if="getCookieValueOfJobPanel && ['Catalogs', 'Bins'].includes(isActive)"  @closeUploadPanel="closeUploadPanel"></upload-panel>
  <component :is="openModel" v-bind="currentProperties"  v-if="isMetadataManagerVisible" @close="closeModal"></component>
  <ReloadPanel v-if="isReloadPanelComponentVisible" :isAssetsGetRequired="isAssetsGetRequired" :routePath="reloadPanelPath"  @hideReloadPanelComponent="isReloadPanelComponentVisible = false" @reloadFusionUponPrivUpdate="loadFusionConfigData"
     @reloadSettingsMenu="reloadSettingsSidemenu" @reloadReportsMenu="reloadReportsSideMenu"></ReloadPanel>
<!-- <ReloadPanel v-if="isReloadPanelComponentVisible"  @hideReloadPanelComponent="isReloadPanelComponentVisible = false" @showReloadPanelComponent="isReloadPanelComponentVisible = true" @reloadSettingsMenu="reloadSettingsSidemenu" @setupcontextmenuaction="setupContextmenuActionsOnReloadPanel"></ReloadPanel> -->
  <notification v-if="openNotifications" @closeNotificationPanel='closeNotificationPanel'></notification>
  <v-tour name="myTour" 
  v-show="checkIfUpdateElementExists()"
  :steps="newUpdatesArr" 
  :options="tourOptions"
  :callbacks="updatesCallback"
  @hook:mounted="startVueTour()"
  ref="newUpdates">
  </v-tour>
  <new-updates v-if="openNewUpdatesTour" :updatesGuide="pageNewUpdatesGuide" @close="closePageNewUpdates"></new-updates>
  <download-panel v-if="isDownloadPanelVisible" @hideDownloadPanel="isDownloadPanelVisible = false"></download-panel>
  <editFavourites v-if="activeFavEntry" :newFav="false" :favInfo="activeFavEntry" @close="activeFavEntry = null"></editFavourites>
  <addBookmark v-if="addBookmark" :favInfo="getFavInfo()" :newFav="true" @close="addBookmark=false"></addBookmark>
  <AIPanel v-if="checkIfAIPanelShouldBeVisible" :textInformation="textInformation"></AIPanel>
  <div v-if="licenseExpMess && licenseExpMess.trim().length"  class="p-0 text-white-50"
       style="z-index: 9999;width: 100%;position: absolute;bottom: 0;background: #af1919 !important;height: 28px;color: #CCCCCC !important;">
        <div class="container text-center p-0" style="margin-top: 3px;">{{licenseExpMess}}</div>
      </div>
</div>
</template>

<script>
import {QuickAccessPanel, OverflowMenu, BinContextMenu} from "../../registry/plugins.js"
import Footer from "./Footer.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import AssetDetails from "../files/AssetDetails.vue";
import MetadataDock from "../files/MetadataDock.vue";
import Miniplayer from "../files/MiniPlayer.vue";
import ActionsIcons from "../files/ActionIcons.vue";
import selectTags from "../tags/TagsBrowse.vue";
import Utils from '../../components.utils';
import ExternalPluginOverflowMenu from "./ExternalPluginOverflowMenu.vue";
import UploadPanel from "./UploadPanel.vue";
import Constants from "../../components.constants.js";
import {NotifierConstants} from "../../components.constants.js";
import GlobalButton from "./GlobalButtons.vue";
import ButtonWithArrow from "./ButtonWithArrowIcon.vue";
import createFolder from "../actions/CreateFolder.vue";
import About from "./About.vue";
import createCatalog from "../categories/createCatalog.vue";
import ExternalPluginDialog from "./ExternalPluginDialog.vue";
import Subclips from "../subclips/Subclips.vue";
import AdvancedSearch from "./AdvancedSearch.vue";
import ConfigurableAdvancedSearch from "./ConfigurableAdvancedSearch.vue";
import ReloadPanel from './reloadPanel.vue';
import ImagePreviewDialog from './ImagePreviewDialog.vue';
import NewTasksIssues from "../PAM/newTasksIssues.vue";
import notification from "../users/UserNotifications.vue";
// import ticketsWorkspace from "../PAM/TicketsWorkspace.vue";
// import RemoteSystemStats from "../remoteSystemStats/remoteSystemStats.vue";
import MetadataManagerAssets from "../MetadataManager/MetadataRequestAssetDetails.vue"
import Multiselect from 'vue-multiselect';
import NewUpdates from "../miscellaneous/NewUpdates.vue";
import downloadPanel from "./DownloadPanel.vue";
import quickAccessPanel from "./quickAccessPanel.vue";
import editFavourites from "../Favorites/AddOrEditBookMark.vue";
import bookmarksbar from "./Bookmarksbar.vue";
import addBookmark from "../../components/Favorites/AddOrEditBookMark.vue";

// import CatalogBrowse from "../../components/categories/CatalogsDisplay.vue";
// import BinBrowse from "../../components/files/BinsBrowse.vue";

// import LiveVideoAnnotation from '../video_annotation_demo/Video_annotation.vue';
import AIPanel from "../ButtonsConfiguration/AIPanel.vue";
import {Route} from "../../registry/routes.js";
import $ from 'jquery';

export default {
  name: "Explorer",
  props : ["loggedInUserName","showAssetDetails","hideMetadataDock"],
  // i18n: {
  //    en: {
  //         Catalogs: 'Catalogs',
  //     },
  //     kn: {
  //         Catalogs: 'ಕ್ಯಾಟಲಾಗ್ಗಳು',
  //     }
  // }, 
  components:{
    "footer-div": Footer,
    "Asset-Details": AssetDetails,
    "metadata-dock": MetadataDock,
    "mini-player":Miniplayer,
    "actions-icons":ActionsIcons,
    "select-tags":selectTags,
    "upload-panel":UploadPanel,
    "external-plugin-overflow-menu":ExternalPluginOverflowMenu,
    "global-button":GlobalButton,
    "button-with-arrow":ButtonWithArrow,
    "create-folder": createFolder,
    "about": About,
    "create-catalog":createCatalog, 
    "external-plugin-dialog":ExternalPluginDialog,
    "subclips-manager":Subclips,
    // "remoteSystemStats":RemoteSystemStats,
    // "ticket-display": ticketsWorkspace,
    "advanced-search":AdvancedSearch,
    "config-advanced-search":ConfigurableAdvancedSearch,
    //  "new-tasks-issues":NewTasksIssues,
    "create-task-issue":NewTasksIssues,
    "Multiselect":Multiselect,
    ReloadPanel,
    ImagePreviewDialog,
    notification,
    "metadata-manager-display":MetadataManagerAssets,
    "new-updates":NewUpdates,
    "download-panel":downloadPanel,
    quickAccessPanel,
    editFavourites,
    bookmarksbar,
    addBookmark,
    AIPanel,
    // LiveVideoAnnotation
  },
  watch:{
    immediate: true,
    "$store.state.download.currentBatch.key":{
        handler:function(newVal, oldVal){
           if(newVal != oldVal){
                this.isDownloadPanelVisible = true;
           }
        }
    },
    enableAdvancedSearch(newVal){
      this.setAdvancedSearchState(newVal)
    },
    gridView(newVal, oldval){
      if(newVal != oldval){
          localStorage.setItem('fusion:viewtype',newVal);
      }
    },
    isMetadataView(newVal, oldVal){
      if(newVal != oldVal){
        localStorage.setItem('fusion:metadataView',newVal);
      }
    },
    taskIssueListView(newVal, oldVal){
      if(newVal != oldVal){
        localStorage.setItem('taskIssue:viewtype',newVal);
      }
    },
    userPrivCount(newVal, oldval){ // eslint-disable-line no-unused-vars
        this.refreshMyspacePrivileges()
    },
    showBookMarks(newVal, oldval){
        if (newVal != oldval){
          try {
            this.heightSet();
          } catch (error) {
            console.log("error in resizing height")
          }
       }
    },
    "$route.query": function(newVal){
      if(this.$route.name == 'media-pipeline-stage'){
        if(newVal.id){
          this.isActive = newVal.id;
          this.enableAdvancedSearch = (![undefined, null].includes(this.$route.query) && (('advanceFilter' in this.$route.query) || 'keyword' in this.$route.query))?true:false;
        }
      }
      if(this.$route.query.keyword && this.$route.query.keyword.length > 0){
          // this.keywordFilter = this.$route.query.keyword;  
          this.searchedValue = [];
          this.searchedValue.push(this.$route.query.keyword);
          this.$refs.globalSearch.search = this.$route.query.keyword;
          this.$set(this, 'keywordFilter', this.$route.query.keyword);
          this.$set(this, 'enteredKeyword', this.$route.query.keyword);
          if(this.$refs.globalSearch)this.$refs.globalSearch.search = this.$route.query.keyword;
          
          this.$nextTick(() => {
            this.keywordUniqeId = Utils.getUUID();
          });  
      }else{
        this.keywordFilter = '';
        this.searchedValue = [];
        if(this.$refs.globalSearch) this.$refs.globalSearch.search = '';
        this.enteredKeyword = '';
      }

      if(this.selectedMainComponent && this.selectedMainComponent == 'packages-display'){
        this.enableAdvancedSearch = false
        return
      }
      this.enableAdvancedSearch = (![undefined, null].includes(this.$route.query) &&
                                       (('advanceFilter' in this.$route.query) || 'keyword' in this.$route.query))?true:false;
    },
    "$route.path" : function(newVal, oldVal){
      let push = false
      let router_name = this.$route.name
      let router_params = this.$route.params
      router_params = Object.assign(router_params, {query:this.$router.query})
      this.taskIssueListView = JSON.parse(localStorage.getItem('taskIssue:viewtype'));
      
      this.$nextTick(()=>{
        let keyword = this.$route.query.keyword;

        if(!keyword || keyword.trim().length === 0){
          if(this.$refs.globalSearch)this.$refs.globalSearch.search = '';
          this.enteredKeyword = '';
        }  
      })

      if(router_name == "media-pipeline-stage"){
        if(this.$route.query.keyword){
            this.keywordFilter = this.$route.query.keyword;  
            this.searchedValue = [];
            this.searchedValue.push(this.keywordFilter);
            if(this.$refs.globalSearch)this.$refs.globalSearch.search = this.keywordFilter;
        }
        this.changeSelectedMainComponent(router_name, {'query':{"id":this.$route.query.id}}, false)
        this.enableAdvancedSearch = (![undefined, null].includes(this.$route.query) &&
                                       (('advanceFilter' in this.$route.query) || 'keyword' in this.$route.query))?true:false;
        return;
      }
      if (router_name == "explorer"){
        if(this.getRegisteredQuickAccessPannel().length){
          this.getEventHandler(this.getRegisteredQuickAccessPannel()[0],"onClick",this.getRegisteredQuickAccessPannel()[0]["onEvents"])
          return
        }
      }else if (this.$route.matched[this.$route.matched.length-1].parent.name != "explorer" 
      && this.$route.matched[this.$route.matched.length-1].parent.name != undefined){
        let nested_parent_info = Utils.getChildRoutefromParentName("explorer", this.$route.matched)
        if (nested_parent_info){
          router_name = nested_parent_info.name
        }
      } 

      if (newVal != oldVal){
        try {
          this.$nextTick(() => {
            this.resizeObservor = new ResizeObserver(() =>{
                this.heightSet();
            });
              this.resizeObservor.observe(document.querySelector('.advanced-search-wrapper'));
          }); 
        } catch (error) {
          console.log("error in resizing height")
        }
        if (!this.$route.meta.componentType.includes("enable_component")){
            this.enabledComponent = null
            if(router_name == "userPref" && newVal.endsWith("mypreferences")){
              push = true
            }
            this.changeSelectedMainComponent(router_name, router_params, push)
        }else{
            this.changeEnableComponent(router_name, false)
        }
        this.createLabelName = Utils.getCookieValue("context");
        if(["bins", "catalogs-display", "ticket-display","projects-display"].includes(Utils.getCookieValue("context")) || ["bins","catalogs-display", "ticket-display","projects-display"].includes(router_name)){
          
          this.enableAdvancedSearch = (![undefined, null].includes(this.$route.query) &&
                                       (('advanceFilter' in this.$route.query) || 'keyword' in this.$route.query))?true:false;
        }else {
          this.enableAdvancedSearch = false;
        }
        this.startVueTour();
        if(this.getNewUpdatesPageData && this.getNewUpdatesPageData.length){
          for(let u = 0; u < this.getNewUpdatesPageData.length; u++){
            if(this.getNewUpdatesPageData[u] && this.getNewUpdatesPageData[u].page_url && window.location.href.startsWith(this.getNewUpdatesPageData[u].page_url)){
                this.pageNewUpdatesGuide = this.getNewUpdatesPageData[u];
                this.openNewUpdatesTour = true;
            }
          }
        }
      }
      if(this.$route.path == "/explorer/mediashare"){
        this.isActive = this.$route.meta.title
      }
      if(this.$route.query.keyword){
          // this.keywordFilter = this.$route.query.keyword;
          this.searchedValue = [];
          this.searchedValue.push(this.$route.query.keyword);
          this.$refs.globalSearch.search = this.$route.query.keyword;
          this.$set(this, 'keywordFilter', this.$route.query.keyword); 
          this.$set(this, 'enteredKeyword', this.$route.query.keyword);
          this.$nextTick(() => {
            this.keywordUniqeId = Utils.getUUID();
          }); 
          
      }
    },
  },
  computed:{
    allStartUpData:{
        get(){
            return this.$store.state.startUpData.startUpDataDetails;
        }
    },
    checkIfAIPanelShouldBeVisible() {
      let panelState = this.getAIPanelState();
      return panelState?.openPanel || false;
    },
    textInformation() {
      let panelState = this.getAIPanelState();
      return panelState?panelState:null;
    },
    getOnlyBookMarks(){
        return this.favoritesList.filter(e => e.type == 'bookmark');
    },
    getMediaPipelineStagesFromStartupdata(){
      let mIndex = this.getSortedQuickAccessPanel.findIndex(e => e.pluginName == "media_pipeline");
      if(mIndex > -1){
        if(this.getSortedQuickAccessPanel[mIndex].quick_access_registry && this.getSortedQuickAccessPanel[mIndex].quick_access_registry.length > 0){
          return []
        }
      }
      if(this.getStartUpDataFromInCache().media_pipeline_startup_data && this.getStartUpDataFromInCache().media_pipeline_startup_data.media_pipeline_stage){
        return this.getStartUpDataFromInCache().media_pipeline_startup_data.media_pipeline_stage;
      }
      return []
    },
    getMediaPipelinesFromStartupData(){
      let mIndex = this.getSortedQuickAccessPanel.findIndex(e => e.pluginName == "media_pipeline");
      if(mIndex > -1){
        if(this.getSortedQuickAccessPanel[mIndex].quick_access_registry && this.getSortedQuickAccessPanel[mIndex].quick_access_registry.length > 0){
          return []
        }
      }
      if(this.getStartUpDataFromInCache().media_pipeline_startup_data && this.getStartUpDataFromInCache().media_pipeline_startup_data.media_pipeline){
        return this.getStartUpDataFromInCache().media_pipeline_startup_data.media_pipeline;
      }
      return []
    },
    isTypeCatalog(){
      try {
            if('asset_type' in this.assetInfoDetails){
              return ["catalog"].includes(this.assetInfoDetails.asset_type)
            }
        } catch (err) {
            console.error(`[isTypeCatalog][folder][Error while checking folderType-${err}]`)
        }
        return false
    },
    unhideMetaDockComponent(){
      let viewState = this.getIsMetadataDockVisible;
      if(!["Bins","Catalogs"].includes(this.isActive)){
        viewState = false;
      }
      return viewState;
    },
    basicAssetInfo(){
      return this.selectedAsset;
    },
    assetInfoDetails(){
       return this.selectedFileDetails.singlefile;
    },
    viewType(){
      return this.gridView;
    },
    taskIssueViewType(){
      return this.taskIssueListView;
    },
    currentProperties() { 
      // openModel variable based checks
      // if(this.openModel == "create-task-issue"){
      if(this.taskModelOpen){
        if(Object.keys(this.selectedFileDetails.multiplefiles).length){
          if(Object.keys(this.taskData).length){
            return { fileInfo : this.selectedFileDetails.multiplefiles, taskContext: this.selectedTaskType, taskDataFromChat: this.taskData};
          }else{
            return { fileInfo : this.selectedFileDetails.multiplefiles, taskContext: this.selectedTaskType}
          }  
        }else if(Object.keys(this.selectedFileDetails.singlefile).length){
          if(Object.keys(this.taskData).length){
            return { fileInfo : this.selectedFileDetails.singlefile, taskContext: this.selectedTaskType, taskDataFromChat: this.taskData};
          }else{
            return { fileInfo : this.selectedFileDetails.singlefile, taskContext: this.selectedTaskType}
          }
        }else{
          if(Object.keys(this.taskData).length){
            return { taskContext: this.selectedTaskType, taskDataFromChat: this.taskData};
          }else{
            return { taskContext: this.selectedTaskType}
          }  
        }  
      }else if(this.openModel == "create-catalog"){
        return {
                parentCalalog: this.catalogSelected, 
                isCatalogExists: this.isCatalogExists,
                refreshCatalogList: this.updateCatalogChildren
                }
      }

      //selectedModalComponent variable based checks
      if(["share-with-user","asset-share-with-user", "asset-object-detection","file-object-detection"].includes(this.selectedModalComponent)){
        return {filesInfo: this.selectedFileDetails}
      }
      if(this.selectedModalComponent === "subclips-manager"){
        return {fileInfo:this.selectedAssetToDisplaySubclips}
      }                                      //Dynamically send props
      if (this.selectedMainComponent === "bins-browse") {
        return { selectedBinId : this.selectedBinId, isAdvancedSearchEnabled:this.enableAdvancedSearch,rootPathPermission:this.rootPathPermission}//this.selectedBinId};  
      }else  if(this.selectedMainComponent === "catalogs-display"){
        return { catalogSelected : this.catalogSelected, isAdvancedSearchEnabled:this.enableAdvancedSearch, rootPathPermission:this.rootPathPermission}
      }else if(this.externalPluginComponent === "external-plugin" || this.selectedModalComponent === "external-plugin-overflow-menu"){
        return {selectedPlugin : this.selectedExternalPluginInfo}
      }
      // else if (this.selectedMainComponent === "media-pipeline-stage") {
      //   return { selectedStageFromParent : this.selectedStage}//this.selectedBinId};  
      // }else if (this.selectedMainComponent === "media-pipeline") {
      //   return { selectedPipelineFromParent : this.selectedPipeline}//this.selectedBinId};  
      // }
      else{
          return {}
      }
    },
    userPrivCount(){
      try {
        return this.getLoggedInUserPrivilege.length
      } catch (error) { // eslint-disable-line no-unused-vars
        return 0
      }
    },
    getSortedQuickAccessPanel(){
      let QAPArray = this.getRegisteredQuickAccessPannel();
      console.log("*************////////************", QAPArray)
      return QAPArray.sort(function(a, b){return a.position_priority - b.position_priority})
    },
    ...mapGetters("files",["getfolderInfoToGetCurrentPath"]),
    ...mapGetters("upload",["getUploadingFilesListState","getAllJobs"]),
    ...mapGetters("bins",["getPermissionOfSelectedBin"]),
    ...mapGetters("users", ["getClientSystemIP","getLoggedInUser","getIsMetadataDockVisible","getIsAssetsDetailsPanelVisible","getisMiniplayerVisible","getLoggedInUserPrivilege","getLoggedInUserId","getSelectedPlayerPanel","getLoggedInUserType","getLoggedInUserInfo"]),
    ...mapGetters("actions",["getNewUpdatesPageData"]),
    ...mapGetters("pluginRepo",["getInstalledPluginsData"]),
    ...mapGetters("download",["getDownloadFilesArr"])
  },
  data(){
    return{
      keywordUniqeId:Utils.getUUID(),
      enteredKeyword:"",
      isDownloadPanelVisible: false,
      licenseExpMess:undefined,
      loadRouteParams:{},
      logo: null,
      fusionlogo: Utils.getLogo(),
      favicon: Utils.getFavIcon(),
      selectedBinId:null,
      selectedMainComponent: '',
      showSettings: false,
      gridView:true,
      catalogViewMenuOpen: false,
      thumbnailAspectRatio: ['landscape', 'square', 'portrait'].includes(localStorage.getItem('fusion:thumbnailAspectRatio')) ? localStorage.getItem('fusion:thumbnailAspectRatio') : 'landscape',
      thumbnailScale: ['fit', 'fill'].includes(localStorage.getItem('fusion:thumbnailScale')) ? localStorage.getItem('fusion:thumbnailScale') : 'fit',
      thumbnailSize: (() => { const saved = localStorage.getItem('fusion:thumbnailSize'); const legacy = { small: 160, medium: 220, large: 300 }; const value = legacy[saved] || Number(saved); return Number.isFinite(value) && value >= 160 && value <= 300 ? value : 220; })(),
      taskIssueListView:true,
      isModalVisible: false,
      selectedAsset: {},
      selectedTags: {},
      idTagsBrowse: false,
      catalogSelected:null,
      isCategoryBrowse: false,
      isMetadataDockisNotVisible:false,
      mySpacePrivilege:[],
      selectedModalComponent:null,
      isActive:null,
      openModel:null,
      selectedExternalPluginInfo:{},
      jobInfoFromUploadPanel:null,
      isUploadPanel:true,
      jobsPanelData:null,
      uploadDetails:null,
      rootPathPermission:{
        "permission":"no-access"
      },
      isMetadataManagerVisible:false,
      getCookieValueOfJobPanel:Utils.getCookieValue('jobPanelState'),
      openNotifications:false,
      showHelp:false,
      showBookmark:false,
      createLabelName:Utils.getCookieValue("context"),
      selectedFileDetails: {"singlefile":{},"multiplefiles":{}},
      taskData: {},
      keywordFilter: "",
      searchedKeyword: "",
      requestingQueryParameters : {},
      searchedassetsList: [],
      searchedfilesList: [],
      selectedAssetToDisplaySubclips:{},
      externalPluginComponent:null,
      enabledComponent:null, //conflicted
      enableAdvancedSearch:false,
      resizeObservor:null,
      resizedHeight:"100%",
      isReloadPanelComponentVisible:false,
      reloadPanelPath:{},
      showVideoMiniplayer:false,
      showOtherFilesPreviewDialog:false,
      newMessageNotificationTagVisible:false,
      searchKeywordListFromAutocomplete:[],
      searchedValue: [],
      lastSearch: [],
      guid:Utils.getUUID(),
      selectedTaskType : null,
      newUpdatesArr:[],
      pageNewUpdatesGuide:null,
      openNewUpdatesTour:false,
      tourOptions:{
        startTimeout:3000,
        labels:{
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop:"Got it"
        }
      },
      updatesCallback:{
        onStop: this.readTheUpdate
      },
      newUpdateElement:null,
      updateKey:Utils.getUUID(),
      isAssetsGetRequired:false,
      enableUserNotificationBadge:false,
      loadFusionParams:{},
      mainNotifierIP:null,
      notifierIPFromStartupData:null,
      promiseNotifierIP:null,
      lastPamLocationInfo:{},
      promiseNewUpdates:null,
      newUpdatesFromStartupData:null,
      favoritesList:[],
      SearchBarSupportedList : ["Catalogs", "Ticket", "Projects", "Remote Edit", "Fusion Cut",'Media Qc'],
      isFavQPClick:false,
      subclipAssetDetails:{},
      showShareWindow:false,
      transcriptPlayObject:{},
      autoPlay:false,
      selectedStage:null,
      selectedPipeline:null,
      showFusionLogo:false,
      landingPageLogo:'',
      selectedLanguage:'English',
      languagesList:[],
      taskModelOpen :false,
      pluginsRegistryStatus:[],
      externalPluginInstalledDefered : {'didplugincomponentRegistered': null},
      externalPluginInstalledPromise: null,
      loadedPluginName:null,
      navigationContextMap:{contextList:[],projectContext:[]},
      explorerComponentThis:null,
      selectFirstMenu:false,
      activeFavEntry:null,
      bookmarkSVG:Utils.getBookmarkSvg(),
      showBookMarks:false,
      addBookmark:false,
      lastToastMessage:null,
      isSearchKeyMessageShown:false,
      advancedSearchEnabledComponents:['bins', 'catalogs-display', 'ticket-display', 'projects-display',"media-pipeline-stage"],
      doNotCalculateHeight:['ticket-display'],
      isMetadataView:false,
      isNLPSearchMode: false,
    };
  },
  methods:{
    getProxyConvertedURL(url){
      return Utils.convertToLoginIPDomainName(url);
    },
    addScreensToNotPlayMiniplayerAndDoc(screenName){
       this.dontPlayOverlayScreensOverMiniplayerAssetDoc(screenName);
    },
    setNLPSearchStateInLocalStorage(){
      localStorage.setItem('fusion:isNLPSearchMode', this.isNLPSearchMode);
      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          ...this.$route.query,
          semantic: this.isNLPSearchMode
        }
      })
    },
    handleGlobalKey(e) {
      const el = this.$refs.globalSearch?.$el;
      if (!el) return;

      const isActive = el.classList.contains("multiselect--active");
      if (isActive) return;

      const isAnyOtherFieldFocused = document.activeElement.matches(
        'input, textarea, select, [contenteditable="true"]'
      );

      if (e.key === "/") {
        // Allow "/" to be typed normally in other input fields
        if (isAnyOtherFieldFocused) return;

        // Prevent "/" from being appended to global search
        e.preventDefault();

        this.$nextTick(() => {
          const globalInput = el.querySelector("input");

          if (globalInput) {
            globalInput.focus();
            this.lastToastMessage = null;
            this.isSearchKeyMessageShown = false;
          }
        });

        return;
      }

      if (
        e.key.length === 1 &&
        /[\x20-\x7E]/.test(e.key) &&
        e.keyCode !== 32
      ) {
        if (!isAnyOtherFieldFocused) {
          const message = "Press '/' to continue to search";

          if (this.lastToastMessage !== message && this.keywordFilter) {
            this.lastToastMessage = message;
            this.isSearchKeyMessageShown = true;

            setTimeout(() => {
              this.lastToastMessage = null;
              this.isSearchKeyMessageShown = false;
            }, 3000);
          }
        }
      }
    },

    getFavInfo(){
      let folderName = ""
      let currentDir = this.$route.fullPath
      if(currentDir){
          folderName = this.$route.name
      }
      return {name:folderName,type:"bookmark"}
    },
    loadSelectedFavourite(favInfo){
      let favEvents = [{
        "event_name": "onClick",
        "event_handler": this.changeComponentToFavourite,
        "handler_args":[]
      }]
      let tempInfo = {
        id:favInfo._id,
        pluginName:'Favorites',
        label:favInfo.name,
        iconSvgCallback:favInfo.type=='bookmark'?Utils.getBookmarkSvg:Utils.getSavedSearchSvg,
        onEvents:favEvents,
        iconUrl:this.getfavThumbnail(favInfo),
        type:favInfo.type,
        url:this.getUrlWithoutPage(favInfo.url)
      }
      this.getEventHandler(tempInfo,'onClick')
    },

    unsetComponent(){
      this.selectedMainComponent = '';
    },

    checkIsLanguageDropdownIsShowing(){
      if('enable_global_language_option' in this.getStartUpDataFromInCache() && 
          this.getStartUpDataFromInCache().enable_global_language_option){
        return true
      }else{
        return false;
      } 
    },


    handleLanguageSelection(option){
        if(option){
            this.selectedLanguage = option.name;
            let payload = {};
            payload["user_language"] = this.selectedLanguage;
            payload.user_preferences = true;
            payload.params = { user_id: this.getLoggedInUserId};
            this.updateLoggedInUserPreferences(payload).then((data)=>{
                if(data.statusCode == 200){
                  this.$toast.success(data.message)
                }else{
                    this.$toast.error(data.message);
                    return
                }
            })
            
        }
    },

    getLanguageMap(languageName){
        let languageIndex = this.languagesList.findIndex((op)=>op.name == languageName);
        return this.languagesList[languageIndex];
    },

    getActiveLanguagesList(){
        let payload = {"enabled":true};
        this.getlangaugesDetailsFromServer(payload).then((data)=>{
            this.languagesList = data["languages"];
        });
    },

    openAssetFavouriteAdmin(){
        this.$router.push({
          name:'assetFavouriteAdmin',
          params:{
            parentinfo: this.$route,
          },
        });
    },
    

    showFavouriteEditWindow(favInfo){
      this.activeFavEntry = favInfo;
    },
    checkIsNewButtonDropdownIsShowing(){
      if((this.isEnabled('Upload') && ['Catalogs', 'Bins'].includes(this.isActive) && ['full-control','read-write'].includes(this.rootPathPermission.permission))
         || this.createLabelName == 'catalogs-display' && this.isEnabled('manage-catalogs') && ['full-control','read-write'].includes(this.rootPathPermission.permission) 
         || (this.createLabelName == 'bins' ||this.createLabelName == 'bins-display') && this.permissionCheck() && this.isEnabled('CreateFolder') && ['full-control','read-write'].includes(this.rootPathPermission.permission)
         || this.isEnabled('Projects')
         || this.isEnabled('Ticket')){
           return true;
      }else{
        return false;
      }
    },  

     /**
      *  External plugin registration
      */
    checkIfAdvancedSearchVisible(){
      console.log("this.enableAdvancedSearch",this.enableAdvancedSearch)
    },
    openAdvancedSearch(isEnable){
      this.enableAdvancedSearch = isEnable?isEnable:true;
    },
    addNewExternalPluginIframe(pluginInfo){
      if(pluginInfo && pluginInfo.id){
          let ele = document.querySelector(`#external-plugins-wrapper #extp${pluginInfo.id}`);
          if(!ele){
                const iframe = document.createElement("iframe");
              iframe.style.cssText = 'width:0px;height:0px;border:0px;display: none;';
              iframe.id = `extp${pluginInfo.id}`;
              iframe.src = '';
              console.log('plugin-iframe',document.getElementById('external-plugins-wrapper'));
              document.getElementById('external-plugins-wrapper').appendChild(iframe);
          }
      }
    },
    checkIsPluginAlreadyLoaded(pathname){
        let dynamicPathObj = Utils.getCurrentMatchingRoute(pathname,this.getRegisteredQuickAccessPannel());
        console.log('[isPluginAlreadyLoaded]',dynamicPathObj);
        if((dynamicPathObj && dynamicPathObj.route_info && dynamicPathObj.route_info.route_name)){
            let routedRegisteredObj = this.$router.resolve({name: dynamicPathObj.route_info.route_name});
            if(routedRegisteredObj && routedRegisteredObj.resolved.matched.length){
                this.enabledComponent = null
                this.changeSelectedMainComponent(dynamicPathObj.route_info.route_name, {}, true)
                console.log('Route already present');
              return true;
            }
        }
        console.log('Route not present');
        return false;
    },
    isPathResolved(){
        return this.$router.resolve({path:location.pathname}).resolved.matched.length 
    },

    registerStoreAndRoutes(e){
      /**
       *   This implementation is done for Media Pipeline and PAM to solve the issue of using other components(external plugin) into it.
       *   To check the example please look into `Media Pipeline` and PAM
       */
      console.log("[registerDampluginsRoutes]",e);
      if(e.pluginStore && Array.isArray(e.pluginStore) && e.pluginStore.length){
            for(let i = 0; i < e.pluginStore.length; i++){
              if(!this.$store.hasModule(e.pluginStore[i].module))
                this.$store.registerModule(e.pluginStore[i].module,e.pluginStore[i].store); // registers store dynamically at run time
            }
        }else{
          if(e.pluginStore && !this.$store.hasModule(e.pluginStore.module))
              this.$store.registerModule(e.pluginStore.module,e.pluginStore.store); // registers store dynamically at run time
        }

       if(e && e.routes && Array.isArray(e.routes)){
          for(let i = 0; i < e.routes.length;i++){
              for(let j = 0; j < e.routes[i].routes.length;j++){
                  this.$router.addRoute(e.routes[i].parentRouteName,e.routes[i].routes[j]);
              }
          }
       }
       if(e && e.childRoutes && Array.isArray(e.childRoutes) && e.childRoutes.length){
          for(let j = 0; j < e.childRoutes.length;j++){
              this.$router.addRoute(e.childRoutes[j].parentRouteName,e.childRoutes[j].route);
          }
       }
    },
     
    registerDampluginsRoutes(e){
       this.registerStoreAndRoutes(e);
       this.externalPluginInstalledDefered.didplugincomponentRegistered.resolve();
    },
    pluginMounted(e){
          if(e.storeOptions && Array.isArray(e.storeOptions) && e.storeOptions.length){
             for(let i = 0; i < e.storeOptions.length; i++){
                if(!this.$store.hasModule(e.storeOptions[i].module))
                  this.$store.registerModule(e.storeOptions[i].module,e.storeOptions[i].store); // registers store dynamically at run time
             }
          }else{
            if(e.storeOptions && !this.$store.hasModule(e.storeOptions.module))
                this.$store.registerModule(e.storeOptions.module,e.storeOptions.store); // registers store dynamically at run time
          }

          for(let compName in e.components){
              if(!Object.prototype.hasOwnProperty.call(this.$options.components,compName)){
                  console.log('[Registering: component]',compName);
                  this.$options.components[compName] =  e.components[compName];
              }
          }

          if(e.routeOptions && e.routeOptions.routes && typeof e.routeOptions.routes == 'object' 
             && Object.prototype.hasOwnProperty.call(e.routeOptions.routes,'children')){
              let tempRouteObjList = [];
              for(let i = 0; i < e.routeOptions.routes.children.length; i++){
                  tempRouteObjList.push(new Route(...e.routeOptions.routes.children[i]));
              }
              if(e.routeOptions.routes.parent && e.routeOptions.routes.childrenIndex){
                  if(e.routeOptions.routes.parent && Array.isArray(e.routeOptions.routes.parent)
                     && e.routeOptions.routes.parent.length >= e.routeOptions.routes.childrenIndex){
                     e.routeOptions.routes.parent[e.routeOptions.routes.childrenIndex] = tempRouteObjList;
                     e.routeOptions.routes = e.routeOptions.routes.parent;
                  }
              }
          }

          let isComponentTransitiveDependent = false;

          if(e.routeRegistration){
              if(Array.isArray(e.routeRegistration)){
                  for(let i = 0; i < e.routeRegistration.length; i++){
                      // let children = [];
                      e.routeRegistration[i].children.forEach((obj) => {
                        //  children.push(new Route(...obj));
                        // let routedRegisteredObj = this.$router.resolve({name: e.routeRegistration[i].children[index]});
                        // if(routedRegisteredObj && routedRegisteredObj.resolved.matched.length) return;
                         this.$router.addRoute(e.routeRegistration[i].parent,new Route(...obj));
                      });
                  }
                  isComponentTransitiveDependent = true;
                   
                  let routeLoadInfo = {};
                  if(typeof this.getLazyLoadPluginInfo == 'function'){
                       routeLoadInfo = this.getLazyLoadPluginInfo();
                  }else{
                      routeLoadInfo = this.getLazyLoadPluginInfo;
                  }
                  if(routeLoadInfo && Object.keys(routeLoadInfo).length){
                      if(routeLoadInfo.isLoadRequired){
                          let pushObj = {name:routeLoadInfo.route.name,params:{...routeLoadInfo.route.params},query:{...routeLoadInfo.route.query}};
                  
                          if(routeLoadInfo && Object.prototype.hasOwnProperty.call(routeLoadInfo,'props') && Object.keys(routeLoadInfo.props).length){
                              pushObj.params[routeLoadInfo.props.key] = routeLoadInfo.props[routeLoadInfo.props.key](this);
                          }
                          console.log(`[external on demand plugin object]`,pushObj);
                          this.$nextTick(() => {
                              this.$router[routeLoadInfo.pushType](pushObj);  // it can be either push or replace, if you don't want forward backward support then replace
                          });
                      }
                  }

                  this.unsetLazyLoadPluginInfo(); //unset the old lazy load store

                  try{
                    this.$refs['maincomponent'+this.selectedMainComponent].deselectFileAndContextMenu();
                  }catch(e){console.log(e)}
             
                  // return;
              }
          }

          if(!isComponentTransitiveDependent){
            let routedRegisteredObj = this.$router.resolve({name: e.routeOptions.routes[0]});
            if(routedRegisteredObj && !routedRegisteredObj.resolved.matched.length){
                console.log(`[Registering ${e.routeOptions.routes}] for the first time`);

                //registering route dynamically
                this.$router.addRoute(e.routeOptions.parentRouteName,new Route(...e.routeOptions.routes))
                let routeOb = this.$router.resolve({path:this.loadFusionParams.fullPath});
                this.$nextTick(() => {
                      this.selectedMainComponent = e.routeOptions.routes[0];
                      this.$router.push({name:e.routeOptions.routes[0],params:routeOb.route.params,query:routeOb.route.query});
                });
                
            }else{
                console.log(`[${e.routeOptions.routes[0]} Route] Already registered`);
                this.selectedMainComponent = e.routeOptions.routes[0];
                this.$nextTick(() => {
                      this.$router.push({name:e.routeOptions.routes[0],params:{...this.loadFusionParams.params},query:{...this.loadFusionParams.query}});
                    });
            }
          }
          this.$nextTick(() =>{
              try{
                $(`head#${e.id}`).remove();
              }catch(e){
                console.log(e);
              }
              $('head:first').append('<style type="text/css"  id="'+e.id+'" name="dynamic-plugin-component-css">' + e.pluginGeneratedCss + '</style>');
        });
      },

      getLicenseErrorMessage(){
        this.getLicensesListFromServer().then((response) => {
          if (Utils.isAcceptedStatusCode(response.statusCode)) {
            if(response.license.length > 0 && 'message' in response.license[0]){
              this.licenseExpMess = response.license[0]["message"]
            }
          }
        });
      },
      getUserFavListFromServer(){
        return new Promise((resolve,reject)=>{
          let payload = {params:{user_id:this.getLoggedInUserId,type:JSON.stringify(["bookmark","Saved Search"])}}
          this.favoritesList =[]
          this.getAllFavoritesFromServer(payload).then((data) => {
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
              this.favoritesList = data.favorites
              this.setFavourites(data.favorites)
              resolve(data.favorites)
            }else{
              reject({"error": "Unable to load favorites."})
            }
          });
        })
      },
      getBinsCatalogBrowseContext(doAssestsGet = false){
        let browseView = '', ref = '';
        if(this.$refs['maincomponentbins-browse']){
           browseView = 'bins';
           ref = 'maincomponentbins-browse';
           if(doAssestsGet)
             return this.$refs[this.getBinsCatalogBrowseContext().ref].refreshFilesList(this.$refs['maincomponentbins-browse'].currentFolderInfo);
        }else if(this.$refs['maincomponentcatalogs-display']){
            browseView = 'catalogs'
            ref = 'maincomponentcatalogs-display';
            if(doAssestsGet){
              if(this.getStartUpDataFromInCache().enable_department)this.$refs[this.getBinsCatalogBrowseContext().ref].updateDepartmentsFunc();
              return this.$refs[this.getBinsCatalogBrowseContext().ref].refreshAssetsList(this.$refs['maincomponentcatalogs-display'].selectedCatalog);
            }   
        }
        return {view:browseView,ref:ref};
      },
      determineIsPrivilegeChangedBins(notification){
         let browseView = this.getBinsCatalogBrowseContext().view;
        if(!browseView) return false;
        const isCurrentPathMatched = (notification)=>{
            if(notification && notification.message && notification.message.access_control){
                 let binsOrCatalogList = notification.message.access_control[browseView];
                 for(let i = 0; i < binsOrCatalogList.length; i++){
                     if(binsOrCatalogList[i].path == this.rootPathPermission.path)
                       return true;

                    try{
                      let rootPath = this.rootPathPermission.path;
                      if(!String(rootPath).endsWith('/')) rootPath = `${rootPath}/` 

                      let  nextPath = String(binsOrCatalogList[i].path).replace(rootPath,'')
                      if(nextPath.split('/').length == 1)
                         return true;
                    }catch(e){
                       console.log(e);
                       return false;
                    }
        
                 }
            }
           return false;
        }
        console.log('isCurrentPathMatched',isCurrentPathMatched(notification));
        if(this.$refs[this.getBinsCatalogBrowseContext().ref] && isCurrentPathMatched(notification)){
             if(notification && notification.message && notification.message.access_control){
                 if(this.getLoggedInUserInfo && this.getLoggedInUserInfo.access_control && this.getLoggedInUserInfo.access_control.bins){
                   try{
                      return JSON.stringify(this.getLoggedInUserInfo.access_control.bins) != JSON.stringify(notification.message.access_control.bins);
                   }catch(e){console.log(e)}
                 }
             }
        }
        return false;
      },
      closePageNewUpdates(){
        this.openNewUpdatesTour = false;
      },
      isElementVisible(e){
        return !( e.offsetWidth || e.offsetHeight || e.getClientRects().length );
      },
      checkIfUpdateElementExists(){
        //&& this.isElementVisible(document.querySelector(this.newUpdateElement))
        if(document.querySelector(this.newUpdateElement)){
          if(this.newUpdatesArr.length){
            // if(document.querySelector(".modal")){
            //     document.querySelector(".modal").classList.add("disable-modal-parent")
            // }else{
            //   document.querySelector(".v-tour").classList.add("disable-parent");
            // }
            this.attachEventListener();
          }
          return true;
        }else{
          return false;
        }
      },
      startVueTour(){
        this.attachEventListener();
        try {
          this.$tours['myTour'].start();
            if(this.newUpdatesArr.length){
              for(var i = 0; i< this.newUpdatesArr.length; i++){
                if(document.querySelector(this.newUpdatesArr[i].target)){
                  this.newUpdateElement = this.newUpdatesArr[i].target;
                }
              }
            }
        } catch (error) {
          console.log("Error",error)
        }
      },
      attachEventListener(){
          [].map.call(document.querySelectorAll(".newUpdates-learn-more"),(ele)=>{
                ele.addEventListener('click',this.readTheUpdate);
          });
      },
      readTheUpdate(){
        // if(document.querySelector(".disable-parent") || document.querySelector(".disable-modal-parent")){
          if(this.$refs["newUpdates"] && this.$refs["newUpdates"].step){
            let payload = {"_id":this.$refs["newUpdates"].step._id}
            this.updateReadStatusOfNewUpdates(payload).then(() => {
              // if(document.querySelector(".modal")){ 
              //   document.querySelector(".modal").classList.remove("disable-modal-parent");
              // }
              // document.querySelector(".v-tour").classList.remove("disable-parent");
              this.newUpdatesArr = [];
            })
          }
        // }
      },
      playeSubclipPreview(subclip, autoPlay=false){
        if(!this.autoPlay)this.autoPlay = autoPlay;
        let markinMarkoutObj = {start:subclip.markers.start,end:subclip.markers.end};
        this.transcriptPlayObject = {};
        this.subclipAssetDetails = subclip;
        //  this.$nextTick(() => {
             if(this.getIsAssetsDetailsPanelVisible){
                console.log(`[markinMarkoutObj][markinMarkoutObj]`,markinMarkoutObj);
               /*  if(this.$refs.assetDetailsDocPanel){
                      this.$refs.assetDetailsDocPanel.playSubClipPreview(markinMarkoutObj,()=>{
                          this.$refs.metadataDockWidget.unselectActiveSubclipPreview();
                      });
                } */
            }else{
              if(!this.getisMiniplayerVisible){
                  this.setMiniplayerState(true);
                  this.showVideoMiniplayer = true;
               }
   /*             this.$nextTick(() => {
                 setTimeout(() => {
                      this.$refs.miniPlayerRef.playSubClipPreview(markinMarkoutObj,()=>{
                          [].map.call(document.querySelectorAll('.active-subclip-preview'),(el) => {
                                el.classList.remove('active-subclip-preview');
                          })
                          this.$refs.metadataDockWidget.unselectActiveSubclipPreview();
                      });
                 },900);
               }); */
         
            }
        //  });
      },
      style(name){
        let style = {
          'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
          'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
        }
        return style
      },
      getProfileImageOfUser(image){
        let defaultImage = Utils.getNoThumbnailImg();
        let profileImageTag = '<img src='+this.getProxyConvertedURL(image)+' onerror="this.src='+defaultImage+'; this.onerror = null"  style="width:100%;height:100%;border-radius:6px">'
        return profileImageTag;
      },
      replaceWithUserIcon(e){
          e.target.onerror = null
          e.target.src = Utils.getNoThumbnailImg();
      },
      isFullscreenPreviewAllowed(){
         let allowedFullScreenPreview = ['image',...Constants.supportedDocumentPreviewList,...Constants.supported3dModelPreviewList];
         return allowedFullScreenPreview.indexOf(Utils.getFileMediaType(this.selectedFileDetails.singlefile)) > -1
      },
      setupContextmenuActionsOnReloadPanel(){
         this.setUpContextMenuActions();
         let reloadOnList = ['bins-browse','catalogs-display',"Mediashare","metadata-manager-display"];
         try{
          for(let i = 0; i < reloadOnList.length; i++){
              if(this.$refs['maincomponent'+reloadOnList[i]]){
                  this.$refs['maincomponent'+reloadOnList[i]].eventsAttached = false;
                  break;
              }
          }
         }catch(e){console.log(e)}
      },
      reloadSettingsSidemenu(){
          if(this.$refs['maincomponentsettings']){
              this.isReloadPanelComponentVisible = false;
              this.$toast.success('Updated Sucessfully.');
              // this.loadFusionExplorer(routePath)
            this.$refs['maincomponentsettings'].getUserSettingsPrivilege().then((data) =>{
                this.$refs['maincomponentsettings'].userSettings = data;
                this.loadFusionConfigData().then(() => {
                  this.$refs.maincomponentsettings.reloadSettingsSideMenuList();
                  this.setupContextmenuActionsOnReloadPanel();
                });
            });
          }
      },
      reloadReportsSideMenu(routePath){
        if(this.$refs['maincomponentreports']){
              this.isReloadPanelComponentVisible = false;
              this.$toast.success('Updated Sucessfully.');
              this.loadFusionExplorer(routePath)
              // this.$refs['maincomponentreports'].doSetup();
              // this.loadFusionConfigData();
              this.setupContextmenuActionsOnReloadPanel();
          }
      },
      //Advanced search
      checkContext(){
        let contextList = ["Mediashare","bins-display", "chat-display","metadata-manager-display", "review-display", "license-manager-display", "gen21-display", "remoteEdit-display",'media-pipeline','edit-pro','mediaQc-display'];
        if(!('package_id' in this.$route.query)){
          contextList.push('packages-display');
        }
        let projectContext = ['issues-projects','board-projects','tasks-projects','assets-projects','pipeline-projects'];
        if(!this.navigationContextMap.contextList.length){
            this.navigationContextMap.contextList = contextList;
        }
        if(!this.navigationContextMap.projectContext.length){
            this.navigationContextMap.projectContext = projectContext;
        }
        if(this.navigationContextMap.contextList.includes(Utils.getCookieValue("context"))){
          return false;
        }else if(Utils.getCookieValue("context") == "projects-display"){
          if(this.navigationContextMap.projectContext.includes(this.$route.name)){
            return true;
          }else{
            return false;
          }
        }else{
          return true;
        }
      },
      getHeightCalculationBasedOnBookmarksbar(){
        if(this.showBookMarks){
          this.resizedHeight = `calc(100% - 50px)`;
        }else{
          this.resizedHeight = `100%`;
        }
      },
      heightSet(){
        if (this.doNotCalculateHeight.includes(Utils.getCookieValue("context"))) return;
        let height = 0;
        this.resizedHeight = '100%';
        if(this.showBookMarks){
          height += 50;
        }
        if (document.querySelector(".advanced-search-wrapper")) {
          height += document.querySelector(".advanced-search-wrapper").getBoundingClientRect().height;
        }
        height = `calc(100% - ${height}px)`;
        this.resizedHeight = height;
      },
      enableAdvancedSearchFunc(){
          if(this.advancedSearchEnabledComponents.includes(Utils.getCookieValue("context"))){
            this.enableAdvancedSearch = !this.enableAdvancedSearch;
            // if(!document.querySelector('.advanced-search-wrapper')){
            //       this.heightSet();
            // }
            this.setAdvancedSearchState(this.enableAdvancedSearch)
            this.$nextTick(() => {
              this.resizeObservor = new ResizeObserver(() =>{
                  // this.resizeObservor.disconnect();
                  this.heightSet();
              });
              try {
                this.resizeObservor.observe(document.querySelector('.advanced-search-wrapper'));
              } catch (error) {
                console.log("Error to resize")
                this.heightSet();
              }
            });
        }
      },
      advancedSearchData(data){
        let query = {}
        if (this.keywordFilter){
            query.keyword = `${this.keywordFilter}`
        }

        // query.advanceFilter = JSON.stringify(data)
        if(Object.keys(data).length == 1 && Object.keys(data).includes('fields') && Object.keys(data.fields).length == 0){
          delete data.fields;
        }else{
          query.advanceFilter = JSON.stringify(data)
        }
        this.$router.push({query:query});
        this.$nextTick(() => {
          this.resizeObservor = new ResizeObserver(() =>{
            // this.resizeObservor.disconnect();
            this.heightSet();
        });
            this.resizeObservor.observe(document.querySelector('.advanced-search-wrapper'));
        });
        // this.$refs["maincomponent" +  this.selectedMainComponent].functionCallAfterSearchFieldsChange(data,this.keywordFilter);
      },

      selectionLabelCallback(option){
        return `${option}`
      },

      setAutocompleteOff(){
         this.$refs.globalSearch.$el
          .querySelector(".multiselect__input").setAttribute("autocomplete", "off");
      },

      getSearchKeywordsOnKeyup(option){
        // this.showUserFilter = true
        // this.keywordFilter = option;
        this.enteredKeyword = option;
        if((option && option.length == 0) || !option){
          this.keywordFilter = "";
          this.searchedValue = [];
          this.lastSearch = [];
          this.$refs.globalSearch.search = "";
          this.searchKeywordListFromAutocomplete = [];
        }
       
        this.$nextTick(()=>{
          if(this.selectedMainComponent != 'projects-display' && this.enabledComponent != 'projects-display' && this.selectedMainComponent != "ticket-display" && this.selectedMainComponent != 'packages-display'){
            let payload = {}
            // if(option == 0){
            //   this.keywordFilter = "";
            //   this.searchedValue = [];
            //   this.lastSearch = [];
            //   this.$refs.globalSearch.search = "";
            //   this.searchKeywordListFromAutocomplete = [];
            // }
            
            this.searchKeywordListFromAutocomplete = [];
            if(typeof(option) != "undefined" && option && option.trim().length >= 2 && this.isAutoCompleteEnabled()){
              this.searchKeywordListFromAutocomplete.push(option);
              payload.params = {keyword:option};
              this.getSearchKeywordAutoComplitionFromServer(payload).then((data) => {
                let tempList = data["keywords"];
                this.searchKeywordListFromAutocomplete = this.searchKeywordListFromAutocomplete.concat(tempList.filter(ele => !this.searchKeywordListFromAutocomplete.includes(ele)));
              }); 
            }else{
              if(option == ""){
                this.searchKeywordListFromAutocomplete = [];  
              }else if(this.isAutoCompleteEnabled()){
                this.searchKeywordListFromAutocomplete = [];
                this.searchKeywordListFromAutocomplete.push(option);
              }else{
                this.keywordFilter = option
              }
            }
          }   
        });  
      },
      isAutoCompleteEnabled(){
        return JSON.parse(Utils.getLocalStorageValue('enable_auto_complete_for_assets_search'))
      },
      //-------------------------------------------------

      //User Notifications---------------------------------
      closeNotificationPanel(){
        this.enableUserNotificationBadge = false;
        this.openNotifications = false;
      },
      //---------------------------------------------------

      keywordOptionsOnSelectCallback(option){
        // let index = this.searchKeywordListFromAutocomplete.findIndex(item => item == option);
        // this.keywordFilter = this.searchKeywordListFromAutocomplete[index];
        this.keywordFilter = option;
        this.searchedValue = [];
        this.searchedValue.push(option);
        this.$refs.globalSearch.search = option;

        this.lastToastMessage = null;
        this.isSearchKeyMessageShown = false;
        this.keywordSearchParameters();
      },

      SearchKeywordOptionsOnRemoveCallback(){
        // this.keywordFilter = "";
        this.searchKeywordListFromAutocomplete = [];
      },

      clearSearchBarTextOnly(){
        this.keywordFilter = "";
        this.searchKeywordListFromAutocomplete = [];
          this.searchedValue = [];
          this.lastSearch = [];
        if(this.selectedMainComponent != 'review-display' && this.enabledComponent != 'projects-display' && this.selectedMainComponent != 'ticket-display'){  
          this.$refs.globalSearch.search = "";
        }  
        this.$nextTick(() => {
          this.resizeObservor = new ResizeObserver(() =>{
            // this.resizeObservor.disconnect();
            this.heightSet();
        });
            this.resizeObservor.observe(document.querySelector('.advanced-search-wrapper'));
        });
        this.keywordSearchParameters();
      },

      open() {
        // console.log("open", id, this.$refs.globalSearch.search, this.lastSearch);
        // console.log(
        //   "el",
        //   this.$refs.globalSearch.$el.querySelector(".multiselect__input")
        // )
        this.searchedValue = this.lastSearch;
        this.$nextTick(() =>{
          // this.$refs.globalSearch.$el.querySelector("input").value = this.enteredKeyword;
          this.$refs.globalSearch.search = this.enteredKeyword;
          this.$refs.globalSearch.$el
          .querySelector(".multiselect__input")
          .setSelectionRange(-1, -1);
        });
      },

      updateEnteredKeyword(value){
        // this.$refs.globalSearch.$el
        // .querySelector(".multiselect__input").value = value;
        this.enteredKeyword = value;
        this.$refs.globalSearch.search = value;
      },

      closed() {
        // console.log("value, id", value, id);
        let search = this.$refs.globalSearch.search;
        console.log("search", search);
        if (!search) {
          this.searchedValue = [];
          return;
        }
        this.searchedValue = [];
        this.searchedValue.push(search);
        this.lastSearch = [];
        this.lastSearch.push(search);

        //******* this section is for updated entered keyword value and focus out the search bar  ******************/
        this.$nextTick(()=>{
          const wrapper = this.$el.querySelector(".search-bar-autocomplete-wrapper");
            
          if (wrapper) {
            let singleElement = wrapper.querySelector(".multiselect__placeholder");
            this.$nextTick(()=>{
              const childElement = wrapper.querySelector(".multiselect__single"); 
              if(childElement){
                singleElement = childElement;
              }
              
              if (singleElement) {
                singleElement.textContent = search // Update the value
              }
            });  
          }
        }); 
        //***************************************** */   
      },  
      traverseToAIComp(compName){
        let binCatWorkspace = false
        if(this.$refs['maincomponentbins-browse']){
          binCatWorkspace = true
        }else if(this.$refs['maincomponentcatalogs-display']){
          binCatWorkspace = true
        }
        if( binCatWorkspace){
          if (compName == 'ai_ocr'){
            return this.$refs[this.getBinsCatalogBrowseContext().ref].submitOCRAction();
          }else if(compName == 'ai_obd'){
            return this.$refs[this.getBinsCatalogBrowseContext().ref].submitOBDAction();
          }else if(compName == 'ai_face_detection'){
            return this.$refs[this.getBinsCatalogBrowseContext().ref].submitFaceDetectionAction();
          }else if(compName == 'ai_transcript'){
            return this.$refs[this.getBinsCatalogBrowseContext().ref].submitTranscript();
          }
        }
      },
      openSubclipWindow(selectedAssetInMetadataDock){
       this.selectedAssetToDisplaySubclips = selectedAssetInMetadataDock
       this.changeModalComponent("subclips-manager")
      },
      handleFieldsNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
            let statupContent = this.getStartUpDataFromInCache()["custom_metadatas"];
            let entry_info = notification.message
            if (notification.message_type == NotifierConstants.fieldRemovedNotification){
                statupContent = statupContent.filter((f)=>f._id!=entry_info.custom_metadata_id)
            }else{
                let payload = {};
                payload.params = { _id: entry_info.custom_metadata_id };
                this.getCustomMetadataInfoFromServer(payload).then((resp) => {
                    if(notification.message_type == NotifierConstants.fieldCreatedNotification){
                        statupContent.push(resp.custom_metadata);
                    }else if(notification.message_type == NotifierConstants.fieldModifiedNotification){
                        let Findex = statupContent.findIndex(t=>t._id==entry_info.custom_metadata_id);
                        statupContent[Findex] = resp.custom_metadata;
                    }
                });
            }
            this.updateStartUpEntry({"key":"custom_metadatas","content":statupContent})
            // this.updatestartupDatainfo(statupContent, "custom_metadatas");
        }
      },
      handleScreensNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message && notification.message_type == NotifierConstants.screenModifiedNotification){
            let statupContent = this.getStartUpDataFromInCache()["screens"];
            let entry_info = notification.message
            let payload = {};
            payload.params = { _id: entry_info.screen_id };
            this.getScreenInfoFromServer(payload).then((resp) => {
              let Findex = statupContent.findIndex(t=>t._id==entry_info.screen_id);
              statupContent[Findex] = resp.screen;
            });
            this.updateStartUpEntry({"key":"screens","content":statupContent})
            if(Object.keys(this.getStartUpDataFromInCache()).includes('screens')){
                this.updatestartupDatainfo({"screens":statupContent});
            }
            // this.updatestartupDatainfo(statupContent, "screens");
        }
      },
      handleScreenProfilesNotification(notification){
        if('screen_profile_required' in this.getStartUpDataFromInCache() &&
            !this.getStartUpDataFromInCache()["screen_profile_required"]){
          return
        }
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        let statupContent = this.getStartUpDataFromInCache()["metadata_profiles"];
            let entry_info = notification.message
            if (notification.message_type == NotifierConstants.screenProfileRemovedNotification){
                statupContent = statupContent.filter((f)=>f._id!=entry_info.metadata_profile_id)
            }else{
                let payload = {};
                payload.params = { _id: entry_info.metadata_profile_id };
                this.getMetadataProfileInfoFromServer(payload).then((resp) => {
                    if(notification.message_type == NotifierConstants.screenProfileCreatedNotification){
                        statupContent.push(resp.metadata_profile);
                    }else if(notification.message_type == NotifierConstants.screenProfileModifiedNotification){
                        let Findex = statupContent.findIndex(t=>t._id==entry_info.metadata_profile_id);
                        statupContent[Findex] = resp.metadata_profile;
                    }
                });
            }
            this.updateStartUpEntry({"key":"metadata_profiles","content":statupContent})
            // this.updatestartupDatainfo(statupContent, "metadata_profiles");
      },
      handleUserGroupsNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        let statupContent = this.getStartUpDataFromInCache()["user_groups"];
            let entry_info = notification.message
            if (notification.message_type == NotifierConstants.userGroupRemovedNotification){
                statupContent = statupContent.filter((f)=>f._id!=entry_info.user_group_id)
            }else{
                let payload = {};
                payload.params = { _id: entry_info.user_group_id };
                this.getUserGroupInfoFromServer(payload).then((resp) => {
                    if(notification.message_type == NotifierConstants.userGroupCreatedNotification){
                        statupContent.push(resp.user_group);
                    }else if(notification.message_type == NotifierConstants.userGroupModifiedNotification){
                        let Findex = statupContent.findIndex(t=>t._id==entry_info.user_group_id);
                        statupContent[Findex] = resp.user_group;
                        if(entry_info.user_list && entry_info.user_list.includes(this.getLoggedInUserId)){
                          if('preferred_retrieve_path_mapper' in notification.message && notification.message.preferred_retrieve_path_mapper){
                            let userRetrivePath = notification.message.preferred_retrieve_path_mapper.find(op=>op.user_id == this.getLoggedInUserId)
                            if(userRetrivePath){
                              this.updatestartupDatainfo({'user_preferred_retrieve_path':userRetrivePath.user_preferred_retrieve_path})
                            }
                          }
                          this.$toast.info("Group '"+entry_info.group_name+"' has been updated");
                        }
                    }
                });
            }
            this.updateStartUpEntry({"key":"user_groups","content":statupContent})
            // this.updatestartupDatainfo(statupContent, "user_groups");
            if(('added_user_list' in notification.message && notification.message.added_user_list.includes(this.getLoggedInUserId)) ||
               ('removed_user_list' in notification.message && notification.message.removed_user_list.includes(this.getLoggedInUserId)) ||
               (!('added_user_list' in notification.message || 'removed_user_list' in notification.message) && notification.message.user_list.includes(this.getLoggedInUserId))){
              this.reloadPanelPath = this.$route
              this.isAssetsGetRequired = this.determineIsPrivilegeChangedBins(notification);
              this.isReloadPanelComponentVisible = true;
            }
      },
      updateSearchedTranscriptSelection(transciptEntry){
        if(this.transcriptPlayObject.uid == transciptEntry.uid){
          //already selected the transcript, either reaching for pause/play
          if(this.$refs.miniPlayerRef){
            let minPlayer = this.$refs.miniPlayerRef
            if(minPlayer){
              let mimeType = null;
              if(this.selectedFileDetails.singlefile) {
                mimeType = this.selectedFileDetails.singlefile['mime_type'];
              }
              if(mimeType.startsWith('video/')){
                let vPlayer = minPlayer.$refs.videoPlayerEl;
                if(vPlayer){
                  let video = vPlayer.$el.querySelector('video');
                  if(transciptEntry['state'] == 'paused'){
                    if(video.paused){
                        console.log("pauseButtonClicked : video current state paused. Ignoring the action.")
                    }else{
                        console.log("pauseButtonClicked : video current state play. Pause the video.")
                        video.pause();
                    }
                  }else if(transciptEntry['state'] == 'playing'){
                    console.log("resumePlayer : video current state paused. Playing the video");
                    video.play();
                  }
                  return
                }
              }else if(mimeType.startsWith('audio/')){
                let aPlayer = minPlayer.$refs.audioPlayerComponent;
                if(aPlayer){
                  let audio = aPlayer.getAudioPlayer();
                  if(transciptEntry['state'] == 'paused'){
                    if(audio.paused){
                        console.log("pauseButtonClicked : audio current state paused. Ignoring the action.")
                    }else{
                        console.log("pauseButtonClicked : audio current state play. Pause the audio.")
                        audio.pause();
                    }
                  }else if(transciptEntry['state'] == 'playing'){
                    console.log("resumePlayer : audio current state paused. Playing the audio");
                    audio.play();
                  }
                  return
                }
              }
              minPlayer.addSubclipMarkers({markers:{start:transciptEntry['media_in'], end:transciptEntry["media_out"]}}, true)
            }
          }
          return;
        }else{
          //new Transcript selected
          this.transcriptPlayObject = transciptEntry;
        }
      },
      selectedSingleFile(selectedFile, transcriptEntry = null){
        // this.showVideoMiniplayer = false;
        this.selectedFileDetails["singlefile"] = {};
        if (selectedFile != undefined){
          Object.assign(this.selectedFileDetails["singlefile"],selectedFile);
          this.subclipAssetDetails = {};
        }
        if(transcriptEntry){
          this.showAssetsDataOnDoubleClick(transcriptEntry,true,()=>{
                console.log('playTranscriptFromSearchResults ....... transcriptEntry',transcriptEntry);
              })
        }else{
          this.transcriptPlayObject = {};
        }
      },
      selectedMultipleFiles(selectedFiles){
        this.selectedFileDetails["multiplefiles"] = {}
        if (selectedFiles != undefined){
          Object.assign(this.selectedFileDetails["multiplefiles"],selectedFiles)
        }
        this.transcriptPlayObject = {};
      },
      rootPathPermissionUpdate(pathPermission){
        this.rootPathPermission = pathPermission;
      },
      closeCatalogViewMenu() {
        this.catalogViewMenuOpen = false;
      },
      handleCatalogViewOutsideClick(event) {
        const selector = this.$refs.catalogViewSelector;
        if (this.catalogViewMenuOpen && (!selector || !selector.contains(event.target))) {
          this.closeCatalogViewMenu();
        }
      },
      selectCatalogView(view) {
        if (view === 'metadata' && this.isActive !== 'Catalogs') return;
        this.gridView = view === 'thumbnail';
        if (this.isActive === 'Catalogs') this.isMetadataView = view === 'metadata';
      },
      setThumbnailAspectRatio(ratio) {
        if (!['landscape', 'square', 'portrait'].includes(ratio)) return;
        this.thumbnailAspectRatio = ratio;
        localStorage.setItem('fusion:thumbnailAspectRatio', ratio);
      },
      setThumbnailScale(scale) {
        if (!['fit', 'fill'].includes(scale)) return;
        this.thumbnailScale = scale;
        localStorage.setItem('fusion:thumbnailScale', scale);
      },
      setThumbnailSize(size) {
        const value = Number(size);
        if (!Number.isFinite(value)) return;
        this.thumbnailSize = Math.max(160, Math.min(300, value));
        localStorage.setItem('fusion:thumbnailSize', this.thumbnailSize);
      },
      changeViewTypes(){
        if(this.isActive == 'Catalogs'){
          if (this.gridView && !this.isMetadataView) { this.gridView = false; this.isMetadataView = false; } 
          else if (!this.gridView && !this.isMetadataView) { this.gridView = false; this.isMetadataView = true; } 
          else { this.gridView = true; this.isMetadataView = false; }
        }else{
          this.gridView = !this.gridView;
        }
      },
      changeTaskIssueViewTypes(){
        this.taskIssueListView = !this.taskIssueListView;
        // if(this.taskIssueListView == "listView"){
        //   this.taskIssueListView="detailsView";
        //   localStorage.setItem('taskIssue:viewtype','detailsView');
        // }else{  
        //   this.taskIssueListView="listView";
        //   localStorage.setItem('taskIssue:viewtype','listView');
        // }
      },
      taskIssueListViewChangeinExporer(){
        this.taskIssueListView = true;
      },
      permissionCheck(){
        let appliedPermission = this.getPermissionOfSelectedBin;
        if(["read-modify","read-write","full-control"].includes(appliedPermission)){
          return true;
        }else{
          return false;
        }
      },
     changeSelectedMainComponent(compName, data = {}, push=true, pluginInfo={}) {
      console.log( " ***************** changeSelectedMainComponent ", compName)
      //  alert(compName)
      this.closeModal()
      // this.selectedMainComponent= ""
      this.enableAdvancedSearch = false;
      let routerInfo = {name: compName};
      //Utils.updateCookieByKeyName("context",compName);
      if (compName == "bins-display"){
        if(!this.isEnabled('bins-workspace')){
          return
        }
        this.isActive = "Bins";
        this.unsetLocationHash()
        if (data.query){
          routerInfo.query = Object.assign({},data.query)
        }
        Utils.updateCookieByKeyName("context","bins-display");
      }else if (compName == "catalogs-display"){
        if(this.getStartUpDataFromInCache().pinned_filters_in_catalog_workspace){
          this.enableAdvancedSearch = true;
        }
        if(!this.isEnabled('catalogs-workspace')){
          return
        }
        Utils.updateCookieByKeyName("context","catalogs-display");
        this.createLabelName = "catalogs-display";
        this.isActive = "Catalogs";
        if (Object.keys(data).length != 0 && "catalog_id" in data){
          this.catalogSelected = data;
          this.catalogSelected._id = this.catalogSelected.catalog_id;
          if (data.query){
            routerInfo.query = Object.assign({},data.query)
          }
        }else{
          this.catalogSelected = this.getRootCategoryDetails()
        }
        routerInfo.params = Object.assign({catalog_id: this.catalogSelected._id}, this.catalogSelected)
        // this.unsetLocationHash()
      }else if (compName == "bins-browse"){
        this.isActive = "Bins";
        if (data){
          routerInfo.params = Object.assign({},data)
          if (data.query){
            routerInfo.query = Object.assign({},data.query)
          }
        }
      }else if (compName == "favourites"){
        this.isActive = "Favourites";
      }else if (compName == "dashboard"){
        if(!this.isEnabled('Dashboard')){
          return
        }
        this.isActive = "Dashboard";
      }else if (compName == "review-display"){ //TO BE CHECKED
        if(!this.isEnabled('Review')){
          return
        }
        this.isActive = "Review";
        if (data){
          routerInfo.params = Object.assign({},data)
          if (data.query){
            routerInfo.query = Object.assign({},data.query)
          }
        }        
      }else if(compName == "remoteEdit-display"){
        if(!this.isEnabled('Remote Edit')){
          return
        }
        this.isActive = "Remote Edit";
        if (data){
          routerInfo.params = Object.assign({},data)
          if (data.query){
            routerInfo.query = Object.assign({},data.query)
          }
        }    
      }else if (compName == "chat-display"){
        console.log("datadatadatadata",data)
        if(!this.isEnabled('Chat')){
          return;
        }
        this.isActive = "Chat";
        this.newMessageNotificationTagVisible = false;
        if (data){
          routerInfo.params = Object.assign({},data)
          if (data.query){
            routerInfo.query = Object.assign({},data.query)
          }
        }
        Utils.updateCookieByKeyName("context",'chat-display');
      }else if (compName == "share-display"){
        if(!this.isEnabled('Share')){
          return;
        }
        this.isActive = "Mediashare";
        if (data){
          routerInfo.params = Object.assign({},data)
          if (data.query){
            routerInfo.query = Object.assign({},data.query)
          }
        }
        Utils.updateCookieByKeyName("context",'share-display');
      }
      else if (compName == "metadata-manager-display"){
        if(this.isEnabled('tag-metadata-requestor') || this.isEnabled('tag-metadata-approver')){
          let panelLabel = "";
          if(!('forceUpdate' in data) && 'query' in this.$route && ![undefined,null].includes(this.$route.query) && 'type' in this.$route.query &&
                   ((this.$route.query.type == "Approve" && this.isEnabled('tag-metadata-approver')) ||
                   (this.$route.query.type == "Requests" && this.isEnabled('tag-metadata-requestor'))) ){
              panelLabel = this.$route.query.type
              routerInfo.query = Object.assign({status:"all",type:panelLabel},this.$route.query);
              this.isActive = panelLabel
          }else if('query' in data && ![undefined,null].includes(data.query) && 'type' in data.query){
              panelLabel = data.query.type
              routerInfo.query = Object.assign({status:"all",type:panelLabel},data.query);
              this.isActive = panelLabel
          }
        }else{
          return;
        }
      }else if (compName == "hype-display"){
        if(!this.isEnabled('Hype-SocialMedia')){
          return;
        }
        this.isActive = "Hype";
        if (data){
          routerInfo.params = Object.assign({},data)
          if (data.query){
            routerInfo.query = Object.assign({},data.query)
          }
        }
        Utils.updateCookieByKeyName("context",'hype-display');
      }else if (compName == "license-manager-display"){
        if(!this.isEnabled('manage-license')){
          return;
        }
        this.isActive = "Manage License";
        if (data){
          routerInfo.params = Object.assign({},data)
          if (data.query){
            routerInfo.query = Object.assign({},data.query)
          }
        }
        Utils.updateCookieByKeyName("context",'license-manager-display');
      }else if (compName == "gen21-display"){
        if(!this.isEnabled('GEN21')){
          return;
        }
        this.isActive = "Gen21";
        if (data){
          routerInfo.params = Object.assign({"tabType":"programs"},data)
          if (data.query){
            routerInfo.query = Object.assign({},data.query)
          }
        }
        Utils.updateCookieByKeyName("context",'gen21-display');
      }else if (compName == "ticket-display"){
        if(!this.isEnabled('Ticket')){
          return;
        }
        this.isActive = "Ticket";
        if (data){
          routerInfo.params = Object.assign({},data)
          if (data.query){
            routerInfo.query = Object.assign({},data.query)
          }else{
            if(!this.isClientUser()){
              routerInfo.query = Object.assign({},{state: 'Active'})
            }  
          }
        } 
        Utils.updateCookieByKeyName("context",'ticket-display'); 
      }else if (compName == "projects-display"){
        if(!this.isEnabled('Projects')){
          return;
        }
        this.isActive = "Projects";
        if (data){
          routerInfo.params = Object.assign({},data)
          if (data.query){
            routerInfo.query = Object.assign({},data.query)
          }  
        }  
        Utils.updateCookieByKeyName("context",'projects-display');
      }else if(compName == "edit-pro"){
        this.isActive = "Fusion Cut";
        if (data){
          routerInfo.params = Object.assign({},data)
          if (data.query){
            routerInfo.query = Object.assign({},data.query)
          }
        } 
      // }else if(compName == "mediaQc-display"){
      //   if(pluginInfo._id){
      //     this.isActive = pluginInfo._id;
      //   }else{
      //     this.isActive = "Media Qc";
      //   }  
      //   if (data){
      //     routerInfo.params = Object.assign({},data)
      //     if (data.query){
      //       routerInfo.query = Object.assign({},data.query)
      //     }
      //   } 
      }else if (compName == "external-plugin"){
        if(!this.isEnabled(pluginInfo.privilege)){
          return;
        }
        this.isActive = pluginInfo.label;
        if (data){
            routerInfo.params = Object.assign({},data)
          if (data.query){
            routerInfo.query = Object.assign({},data.query)
          }
        }  
      }else if(compName == "userPref"){
        if('requestedRoute' in data && data.requestedRoute &&
           data.requestedRoute.meta && data.requestedRoute.meta.title){
          routerInfo = {
            name: data["subComp"],
            params: {pluginId: data.requestedRoute.meta.title},
            query: {}
          }
        }
      }else if(compName == 'media-pipeline-stage'){
        console.log("Ddddddddddddddddd",pluginInfo,data)
        if(!this.isEnabled('Media Pipeline')){
          return
        }
        this.createLabelName = "media-pipeline-stage";
        if(data.query && data.query.id){
          this.isActive = data.query.id;
        }else if(pluginInfo._id){
          this.isActive = pluginInfo._id;
        }
        this.selectedStage=this.getMediaPipelineStagesFromStartupdata.find(op=>op._id == this.isActive);
        console.log("selectedStageselectedStageselectedStage",this.selectedStage)
        routerInfo = {
            name: 'media-pipeline-stage',
            params: Object.assign({'stageInfo': pluginInfo},data),
            query: {'id': this.isActive}
          }
      }else if(compName == 'media-pipeline'){
        if(!this.isEnabled('Media Pipeline')){
          return
        }
        if(data.query && data.query.id){
          this.isActive = data.query.id;
        }else if(pluginInfo._id){
          this.isActive = pluginInfo._id;
        }
        routerInfo = {
            name: 'media-pipeline',
            params: {'pipelineInfo': pluginInfo},
            query: {'id': this.isActive}
          }
      }
      else{
        this.closePanels();
      }
      if (!["workspace-plugin-iframe","external-plugin"].includes(compName)){
          this.selectedExternalPluginInfo = {}
      }


      if (Object.keys(data).length != 0 && ("bin_id" in data)){
          this.selectedBinId = data.bin_id;
          routerInfo.params = {selectedBinId: this.selectedBinId, file_uid: this.selectedBinId,_id:this.selectedBinId}
      }

      this.keywordFilter = "";
      this.searchKeywordListFromAutocomplete = [];
      this.searchedValue = [];
      this.lastSearch = [];
      if(this.selectedMainComponent != 'review-display' && this.enabledComponent != 'projects-display' && this.selectedMainComponent != 'ticket-display' && this.selectedMainComponent != 'remoteEdit-display'){  
          if (this.$refs.globalSearch != undefined){
              this.$refs.globalSearch.search = "";
          }
      } 

      this.selectedMainComponent = compName;

      let routeDetails = this.$router.resolve({'name':compName});
        if(routeDetails && routeDetails.resolved && routeDetails.resolved.meta && routeDetails.resolved.meta.newExternalPlugin){
          if (data){
            routerInfo.params = Object.assign({},data)
            if (data.query){
              routerInfo.query = Object.assign({},data.query)
            }
          }
          this.$router.push(routerInfo)
        }
        else
         if (push){
          if (data.query){
            // Adding this, because the query params are not being passed when navigating to a new route on page reload. So, we are adding the query params to the routerInfo object before pushing it to the router.
            routerInfo.query = Object.assign({},data.query)
          }
          this.$router.push(routerInfo)
        }
      },
      closePanels(){
        this.hideShowAssetDetails()
        this.setMetadataDockState(false);
      },
      closeCatBrowse(){
        this.isCategoryBrowse = false;
        this.$refs.fadeWhenModelOpen.style.opacity = 1;
      },
      closeTagsBrowse(selectedTags){
        let tagList = [];
        Object.assign(tagList, this.$refs.tagBrowserWidget.getSelectedTagIdNameMapper());
        let tagIdNamesList = this.$refs.metadataDockWidget.getTagIdNames();
        for(let tagId of Object.keys(tagList)){
          tagIdNamesList.push({"name":tagList[tagId],"_id":tagId});
        }
        this.$refs.metadataDockWidget.setBrowseTagIdNames(tagIdNamesList);
        this.idTagsBrowse = false;
        this.$refs.fadeWhenModelOpen.style.opacity = 1;
        this.selectedTags = selectedTags;
      },
      selectTagsFromBrowse(selectedTagIds){
        this.idTagsBrowse = true;
        this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
        this.selectedTags = selectedTagIds
      },
      selectCategoryFromBrowse(){
        this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
      },
      openAboutDAM(){
        this.isMetadataManagerVisible = true;
        this.openModel = "about";
        this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
      },
      openHelpManual(){
        window.open(Constants.extendedUrl +"/manual");
      },
      openReportAnIssue(){
        window.open("https://workflowlabs.app/explorer/ticket");
      },
      showMetadataDock(){
        this.setMetadataDockState(true);
      },
      showAssetsDataOnDoubleClick(transcriptDetails = {},autoPlay=false, callback){
        if(!this.autoPlay){
          this.autoPlay = autoPlay;
        }
        let metadata = this.unhideMetaDockComponent;
        let assetsInfo = this.getIsAssetsDetailsPanelVisible;
        let miniPlayer = this.getisMiniplayerVisible;
        let selectedPlayer = this.getSelectedPlayerPanel;

        if (selectedPlayer == "miniPlayerPanel"){
          miniPlayer = true
        }

        if(!(metadata) && !(assetsInfo) && !(miniPlayer)){
          metadata = true
          assetsInfo = true
        }

        
        if(!(assetsInfo) && !(miniPlayer) && metadata){
          miniPlayer = true
          assetsInfo = false
        }
    
        
        if(transcriptDetails && Object.keys(transcriptDetails).length){
            this.transcriptPlayObject = transcriptDetails;

        }
        
        if(!this.getIsAssetsDetailsPanelVisible && !this.unhideMetaDockComponent && this.isFullscreenPreviewAllowed()){
           if(!this.isFullscreenPreviewAllowed()){
              this.$toast.warning('Un-supported preview.');
              return;
            }
         /*    if(!this.showVideoMiniplayer)
                this.showOtherFilesPreviewDialog = false;
            this.setMiniplayerState(true); */
            this.showOtherFilesPreviewDialog = true;
            this.$nextTick(() => {
                this.showVideoMiniplayer = false;
            });
            return;
          }else{
              this.showOtherFilesPreviewDialog = false;
              this.$nextTick(() => {
                  this.showVideoMiniplayer = true;
              });
              if(!this.getIsAssetsDetailsPanelVisible)
                  this.setMiniplayerState(true);
             if(!this.getIsAssetsDetailsPanelVisible && !this.unhideMetaDockComponent) return;
          }

        if(metadata == true){
          this.showMetadataDock()
        }
        
        if(assetsInfo && !(miniPlayer)){
          this.showAssetDetailsDock()
        }else{
          this.hideShowAssetDetails()
        }

        if(miniPlayer && !(assetsInfo)){
          this.showMiniPlayer()
        }else{
          this.closeMinimisedPlayer()
        }
        if(callback && typeof callback == 'function'){
            this.$nextTick(()=>{
                callback();
            });
        }
      },
      showAssetDetailsDockCloseMiniplayer(){
        // this.closeMinimisedPlayer()
        // this.showVideoMiniplayer = false;
        if(this.showOtherFilesPreviewDialog) this.showOtherFilesPreviewDialog = false;
        this.showAssetDetailsDock()
        this.setMiniplayerState(false);
      },
      hideAssetDetailsShowMiniplayer(){
 /*        if(!this.isFullscreenPreviewAllowed()){
          if(!this.showVideoMiniplayer)
             this.showVideoMiniplayer = true;
        }else{
          if(this.showVideoMiniplayer)
             this.showVideoMiniplayer = false;
        } */
        if(this.isFullscreenPreviewAllowed()){
            this.showVideoMiniplayer = false;
            this.showOtherFilesPreviewDialog = true;
            return;
         }
        this.hideShowAssetDetails()
        this.showMiniPlayer()
      },
      showAssetDetailsDock(){
        this.setAssetDetailsPanelState(true);
      },
      hideShowAssetDetails(){
        this.setAssetDetailsPanelState(false);
      },
      showMiniPlayer(){
        this.setMiniplayerState(true);
      },
      closeMinimisedPlayer(){
    /*     if(this.showVideoMiniplayer)
           this.showVideoMiniplayer = false; */
        this.showVideoMiniplayer = false;
        this.showOtherFilesPreviewDialog = false;
        this.setMiniplayerState(false);
        this.transcriptPlayObject={}
      },
      isEnabled(priv){
        return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv)
      },
      handleActiveBinIdInWorspace(binId){
        this.selectedBinId = binId
      },
      changeModalComponent(compName,responsefromUploadRequest,binID,uploadNewVersion){
        this.isModalVisible=true;
        this.selectedModalComponent = compName;
        if (this.selectedModalComponent != 'external-plugin-overflow-menu'){
          this.selectedExternalPluginInfo = {}
        }
        if(compName == "upload"){
          this.wrapUploadDetails({"responseData":responsefromUploadRequest,"binId":binID},uploadNewVersion);
        }
        this.$router.push({
          name:this.selectedModalComponent,
          params:{
            parentinfo: this.$route,
            uploadDetails: Object.assign({}, this.uploadDetails) 
          }
        })
      },
      changeToManageFavourites(compName){
        this.isModalVisible=true;
        this.selectedModalComponent = compName;
        this.$router.push({
          name:this.selectedModalComponent,
          params:{
            parentinfo: this.$route,
            showFavourites: true
          }
        })
      },
      wrapUploadDetails(workspaceInfo, uploadNewVersion){
        if(uploadNewVersion && Object.keys(this.selectedFileDetails.singlefile).length)
            workspaceInfo["parentVersionFileInfo"] = this.selectedFileDetails.singlefile
        this.uploadDetails = workspaceInfo
      },
      createFolderFromGlobalButton(){
        if(Utils.getCookieValue("context") == "bins"){
          this.isMetadataManagerVisible = true;
          this.openModel = "create-folder";
        }else if(Utils.getCookieValue("context") == "catalogs-display"){
          this.isMetadataManagerVisible = true;
          this.openModel = "create-catalog";
        }else{
          alert("Create folder is not supported in this area");
          return false;
        }
      },

      createTasksIssues(){
          this.selectedModalComponent = 'new-tasks-issues';
          this.isMetadataManagerVisible = true;
          this.isModalVisible=true;       
      },

      async handleNewTaskOrIssueActionClick(taskType, data){
        // this.openModel = 'create-task-issue';
        // this.isMetadataManagerVisible = true;
        // this.isModalVisible=true;
        
        const loadPAMplugin = async()=>{
            return new Promise((resolve)=>{
                let pamPlugin = null;
                for(let pluginId in this.getRegisteredPluginMapper()){
                  pamPlugin = this.getRegisteredPluginMapper()[pluginId];
                  if(pamPlugin && pamPlugin.name == 'PAM'){
                      break;
                  }
                }
                if(pamPlugin && pamPlugin.getAlldependentPluginBundles){
                      pamPlugin.getAlldependentPluginBundles(()=>resolve());
                }else{
                    resolve();
                }
            });
        }

        await loadPAMplugin();

        this.taskModelOpen = true;
        this.$nextTick(()=>{
          if(![undefined, null].includes(taskType)){
            this.selectedTaskType = taskType;
          }else{
            this.selectedTaskType = null;
          }

          if(data && Object.keys(data).length>0){
            // this.taskData = data;
            Object.assign(this.taskData, data);
          }else{
            this.taskData = {};
          }

          let query = {editMode:false, taskContext:taskType};
          this.$router.push({
            name: "tasks-window",
            params:{
              parentinfo: this.$route,
            },
            query:query
          });
        });  
      },

      getNewbuttonMenuQuery(uploadNewVersion){
        let query = {};
        if(Utils.getCookieValue("context") == "catalogs-display"){
             query = {
              path: this.getStartUpDataFromInCache()["upload_settings"][0].upload_path, 
              newVersion:uploadNewVersion?uploadNewVersion:false,
              catalog_id:this.$route.params.catalog_id
            }
            if (Object.keys(this.selectedFileDetails).length!=0 && Object.keys(this.selectedFileDetails.singlefile).length!=0){
              Object.assign(query, {parentfileUid: this.selectedFileDetails.singlefile.file_uid})
            }
        }else if(Utils.getCookieValue("context") == "bins"){
           query = {
            path: this.getfolderInfoToGetCurrentPath.path, 
            newVersion:uploadNewVersion?uploadNewVersion:false,
            bin_id:this.getfolderInfoToGetCurrentPath.bin_id
          }
          if (Object.keys(this.selectedFileDetails).length!=0 && Object.keys(this.selectedFileDetails.singlefile).length!=0){
            Object.assign(query, {parentfileUid: this.selectedFileDetails.singlefile.file_uid})
          }
        }
        return query;
      },

      uploadFileThroughGlobalButton(uploadNewVersion, isImportCSV = false){
        if(Utils.getCookieValue("context") == "bins"){
          let query = this.getNewbuttonMenuQuery(uploadNewVersion);
          let name = 'upload'
          if(isImportCSV){
            name = 'import-csv'
          }
          this.$router.push({
            name: name,
            params:{
              parentinfo: this.$route,
            },
            query:query
          })
        }else if(Utils.getCookieValue("context") == "catalogs-display"){
          if(Object.keys(this.getStartUpDataFromInCache()).includes("upload_settings")){
            let query = this.getNewbuttonMenuQuery(uploadNewVersion);
            let name = 'upload'
            if(isImportCSV){
              name = 'import-csv'
            }
            this.$router.push({
              name: name,
              params:{
                parentinfo: this.$route,
              },
              query:query
            })
          }
        }else{
            alert("Upload file is not supported in this area");
            return false;
        }
      },
      updateCatalogPageRefresh(catalogInfo){
        this.catalogSelected = catalogInfo
      },
      handleReshareAssetInfo(fileInfo){
        this.selectedFileDetails = {
          multiplefiles : [],
          singlefile : fileInfo
        }
        this.openShareWindow();
      },
      openShareWindow(){
        // this.showShareWindow = true;
        let shareWithUserUA = this.getRegisteredShareContextMenu().findIndex(e => e.action_name == 'Share' && e.label == 'with User');

          if(Object.keys(this.selectedFileDetails.singlefile).length == 0 && Object.keys(this.selectedFileDetails.multiplefiles).length == 0){
            alert("No files are selected");
            return false;
          }

          if(Object.keys(this.selectedFileDetails.singlefile).length > 0){
            if(this.selectedFileDetails.singlefile.asset_type && this.selectedFileDetails.singlefile.asset_type == 'catalog' && this.selectedFileDetails.singlefile.catalog_type != 'package'){
              alert("Catalog share is not supported");
              return false;
            }else if(this.selectedFileDetails.singlefile.file_type && this.selectedFileDetails.singlefile.file_type == 'folder'){
              alert("Folder share is not supported");
              return false;
            }
          }

          if(Object.keys(this.selectedFileDetails.multiplefiles).length > 0){
            for (let i in this.selectedFileDetails.multiplefiles){
                if(this.selectedFileDetails.multiplefiles[i].asset_type && this.selectedFileDetails.multiplefiles[i].asset_type == 'catalog'){
                    alert("Select only files");
                    return false;
                }else if(this.selectedFileDetails.multiplefiles[i].file_type && this.selectedFileDetails.multiplefiles[i].file_type == 'folder'){
                    alert("Select only files");
                    return false;
                }
              }
          }

        if(shareWithUserUA >= 0){
          let name  = 'share-with-user-from-global-btn';
          if(this.$route.name == 'catalogs-display'){
            name  = 'asset-share-with-user-from-global-btn';
          }
          this.$router.push({
            name:name,
            params:{filesInfo:this.selectedFileDetails,parentinfo:this.$route}
          })
        }else{
          alert("Error while sharing with user");
          return false;
        }
        // if(file != undefined && Object.keys(file).length > 0){
        //   this.selectedFileDetails.multiplefiles = {}
        //   this.selectedFileDetails.singlefile = file;
        // }
        // let checkState = []
        // if(this.selectedFileDetails != undefined){
        //   if(Object.keys(this.selectedFileDetails).length){
        //     if(Object.keys(this.selectedFileDetails.multiplefiles).length || Object.keys(this.selectedFileDetails.singlefile).length){
        //       for(let file_uid of Object.keys(this.selectedFileDetails.multiplefiles)){
        //         if(this.selectedFileDetails.multiplefiles[file_uid].asset_type && this.selectedFileDetails.multiplefiles[file_uid].asset_type == 'subclip'){
        //           alert("Media share is not supported for subclips.")
        //           return
        //         }
        //         checkState.push(this.selectedFileDetails.multiplefiles[file_uid].state)
        //       }
        //       if (Object.keys(this.selectedFileDetails.singlefile).length){
        //         if(this.selectedFileDetails.singlefile.asset_type && this.selectedFileDetails.singlefile.asset_type == 'subclip'){
        //           alert("Media share is not supported for subclips.")
        //           return
        //         }
        //         checkState.push(this.selectedFileDetails.singlefile.state)
        //       }
        //       if(checkState.length > 10){
        //         alert("You can only share 10 files at a time.")
        //         return
        //       }
        //       if (checkState.includes("MARK FOR DELETE")){
        //           alert("Sharing deleted files is not supported")
        //           this.selectedFileDetails["multiplefiles"] = {}
        //           this.selectedFileDetails["singlefile"] = {}
        //           return
        //       }
        //       // this.changeModalComponent("share");
        //       this.$router.push({
        //         name:"share-with-user",
        //         params:{
        //           parentinfo: this.$route,
        //           selectedFilesDataFromBrowse: Object.assign({}, this.selectedFileDetails) 
        //         }
        //       })
        //     }else{
        //       if(Utils.getCookieValue("context") == "bins" || Utils.getCookieValue("context") == "catalogs-display"){
        //         alert("Select files to share");
        //       }else{
        //         alert("Share is not supported in this area");
        //       }
        //     }
        //   }
        // }
      },
      openSettings(){
        this.changeModalComponent("settings");
      },
      openReports(){
        this.changeModalComponent("reports")
      },
      openJobs(){
        this.changeModalComponent("jobs")
      },
      openExternalPluginDialog(){
        this.changeModalComponent("external-plugin-overflow-menu")
      },
      closeModal(){
        this.isModalVisible=false;
        this.selectedModalComponent = null
        this.selectedExternalPluginInfo =  {};
        this.isMetadataManagerVisible = false;
        this.openModel = null;
        this.$refs.fadeWhenModelOpen.style.opacity = 1;
        this.selectedAssetToDisplaySubclips = {};
        // this.selectedFileDetails["singlefile"] = {};
        // if(type == "upload"){
        //   if(Object.values(this.getAllJobs).length > 0 && isClose != "closeWindow"){
        //     this.isUploadPanel = true;
        //   }
        // }
      },
      displayJobsStatusesInPanel(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message.user_id == this.getLoggedInUserId && notification.message.job_name == "Upload"){
          // if(notification.message.job_name == "Download"){
          //   return false;
          // }
          this.addToJobsDisplayList(notification);
          this.getCookieValueOfJobPanel = Utils.getCookieValue('jobPanelState');
          if(this.getCookieValueOfJobPanel){
            Utils.updateCookieByKeyName("jobPanelState",true);
          }else{
            Utils.updateCookieByKeyName("jobPanelState",false);
          }
        }
      },
      changeJobsPanelState(state){
        console.log("statestate",state)
        Utils.updateCookieByKeyName("jobPanelState",state);
        if(!state){
          this.closeUploadPanel();
        }else{
          Utils.updateCookieByKeyName("jobPanelState",true);
          this.getCookieValueOfJobPanel = Utils.getCookieValue('jobPanelState');
        }
        
      },
      closeUploadPanel(){
          Utils.updateCookieByKeyName("jobPanelState",false);
          Utils.unsetCookie("jobPanelState");
          Utils.unsetCookie("jobFilter");
          this.getCookieValueOfJobPanel = Utils.getCookieValue('jobPanelState');
      },
      changeComponentToBinsDisplay(){
        this.changeSelectedMainComponent('bins-display');
        this.isActive = "Bins";
        Utils.updateCookieByKeyName("context","bins-display");
        this.createLabelName = "Bins";
      },
      changeComponentToDashboardDisplay(){
        this.changeSelectedMainComponent('dashboard')
        Utils.updateCookieByKeyName("context","dashboard");
        this.createLabelName = "dashboard";
      },
      // changeComponentToExternalPluginDisplay(){
      //   this.changeSelectedMainComponent('external-plugin')
      //   this.isActive = "external-plugin";
      //   Utils.updateCookieByKeyName("context","external-plugin")
      // },
      changeComponentToExternalPluginDisplay(pluginInfo){
        this.changeSelectedMainComponent('external-plugin',{query:{}},true,pluginInfo)
        this.externalPluginComponent = "external-plugin"
        this.isActive = pluginInfo.label;
        Utils.updateCookieByKeyName("context","external-plugin")
      },
      changeComponentToFavouritesDisplay(){
        this.changeSelectedMainComponent('favourites');
        Utils.updateCookieByKeyName("context","favourites")
      },
      changeComponentToMediaPipelineStages(info,multiPanelInfo){
        if(multiPanelInfo && Object.keys(multiPanelInfo).length > 0){
          this.changeSelectedMainComponent('media-pipeline-stage',{query:{'id':multiPanelInfo._id}, params:{'stageInfo':multiPanelInfo}},true,multiPanelInfo);
        }else{
          this.changeSelectedMainComponent('media-pipeline-stage',{query:{'id':info._id}, params:{'stageInfo':info}},true,info);
        }
        Utils.updateCookieByKeyName("context","media-pipeline-stage");
      },
      changeComponentToMediaPipeline(info,multiPanelInfo){
        if(multiPanelInfo && Object.keys(multiPanelInfo).length > 0){
          this.changeSelectedMainComponent('media-pipeline',{query:{'id':multiPanelInfo._id}, params:{'stageInfo':multiPanelInfo}},true,multiPanelInfo);
        }else{
          this.changeSelectedMainComponent('media-pipeline',{query:{'id':info._id}, params:{'stageInfo':info}},true,info);
        }
      },
      async changeComponentToCatalogsDisplay(){
        if(!Object.keys(this.getRootCategoryDetails()).length) {
          try{
            let payload = {};
            payload.params = {page:1,catalog_id:Constants.rootCategory} 
            let data = await this.getAllAssetsFromServer(payload);
            this.setRootCategoryDetails(data["assets"][0])
          }catch(error){
              console.error(`[changeComponentToCatalogsDisplay][explorer][Set root category details][Error->${error}]`) 
          }
        }
        this.changeSelectedMainComponent('catalogs-display');
        this.isActive = "Catalogs";
        Utils.updateCookieByKeyName("context","catalogs-display");
        this.createLabelName = "catalogs-display";
      },
      changeComponentToReviewDisplay(){
        this.changeSelectedMainComponent('review-display');
        Utils.updateCookieByKeyName("context","review-display");
      },
      changeComponentToRemoteEditDisplay(){
        this.changeSelectedMainComponent('remoteEdit-display');
        Utils.updateCookieByKeyName("context","remoteEdit-display");
      },
      changeComponentToTickets(){
        this.changeSelectedMainComponent('ticket-display');
        Utils.updateCookieByKeyName("context","ticket-display");
      },
      changeEnableComponent(comp_name, push=true){
        if (comp_name == 'projects-display'){
            this.changeComponentToProjects(push)
        }

        else if(comp_name == "tasks-window"){
          // this.selectedModalComponent = "tasks-window";
        }
      },

      changeComponentToProjectsWorksapce(){
          this.changeSelectedMainComponent('projects-display');
          Utils.updateCookieByKeyName("context","projects-display");
      },

      changeComponentToEditProWorksapce(){
        this.changeSelectedMainComponent('edit-pro');  
        Utils.updateCookieByKeyName("context","edit-pro");
      },

      changeComponentToMediaQCWorkspace(){
        this.changeSelectedMainComponent('mediaQc-display');  
      },

      changeComponentToProjects(push=true){
        // if(this.createLabelName == "projects-display"){
        //   return;
        // }
        this.enabledComponent = 'projects-display';
        this.keywordFilter = "";
        this.isActive = "Projects";
        Utils.updateCookieByKeyName("context","projects-display");
        this.createLabelName = "projects-display";
        if (push){
            let query = this.$route.query;
            this.$router.push({
                name: "projects-display",
                params: Object.assign({parentinfo: this.$route}, this.$route.params),
                query:Object.assign({}, query),
            })
        }
      
        // console.log(push)
        // this.changeSelectedMainComponent('projects-display');
        // Utils.updateCookieByKeyName("context","projects-display");
      },
      changeComponentToEditPro(push=true){
        this.enabledComponent = 'edit-pro';
        this.keywordFilter = "";
        this.isActive = "Fusion Cut";
        Utils.updateCookieByKeyName("context","edit-pro");
        this.createLabelName = "edit-pro";
        if (push){
            this.$router.push({
                name: "edit-pro",
                params: Object.assign({parentinfo: this.$route}, this.$route.params),
            })
        }
      },
      changeComponentToChat(){
        this.changeSelectedMainComponent('chat-display');
        Utils.updateCookieByKeyName("context","chat-display");
      },
      changeComponentToRemoteSystemStats(){
        // this.enabledComponent = 'remoteSystemStats-display';
        // this.keywordFilter = "";
        // this.isActive = "Monitor";
        // Utils.updateCookieByKeyName("context","remoteSystemStats-display");
        // this.createLabelName = "remoteSystemStats-display";
        this.changeModalComponent("remoteSystemStats")
        Utils.updateCookieByKeyName("context","remoteSystemStats");
      },

/*       changeComponentToWorkSpaceExternalPlugin(){
          this.changeSelectedMainComponent('workspace-external-plugin');
          Utils.updateCookieByKeyName("context","workspace-external-plugin");
      }, */

      changeComponentToHypeAssetsDisplay(){
        this.changeSelectedMainComponent('hype-display');
        Utils.updateCookieByKeyName("context","hype-display");
      },
      changeComponentToMetadataManagerAssetsDisplay(panelLabel){
        this.changeSelectedMainComponent('metadata-manager-display',{query:{type:panelLabel,status:"all"}, forceUpdate: true});
        Utils.updateCookieByKeyName("context","metadata-manager-display");
        this.createLabelName = "metadata-manager-display";
      },
      updateCookieContextValue(key="",value){
        if(key && value)
          Utils.updateCookieByKeyName(key,value);
      },
      getCookieContextValue(key){
        Utils.getCookieValue(key);
      },
      loadExternalWorkspacePlugin(info,route_name,params = {},push = true,callback = '',loadInfo){
          console.log(`info,route_name,params = {},push = true,callback = '',loadInfo`,info,route_name,params,push,loadInfo);
          let isPluginLoaded = false;
          let routedRegisteredObj = this.$router.resolve({name: route_name});
          if(routedRegisteredObj && routedRegisteredObj.resolved.matched.length){
            this.changeSelectedMainComponent(route_name, params, push)
            console.log('[loadExternalWorkspacePlugin] Route already present');
            isPluginLoaded = true;
          }
          if(!isPluginLoaded){
            return this.changeComponentToWorkspaceExternalPlugin(info,callback,loadInfo);
          }
      },
      changeComponentToWorkspaceExternalPlugin(pluginInfo,callback,loadInfo){
          const updateContext = function(pluginInfo){
              let contextMap = {"Chat":'chat-display',"Share":'share-display',"Hype":'hype-display',"Review":"review-display","Manage License":'license-manager-display',
               "GEN21":'gen21-display', "Remote Edit":'remoteEdit-display', "Package":'packages-display'};
              if(contextMap[pluginInfo.privilege_id]){
                  Utils.updateCookieByKeyName("context",contextMap[pluginInfo.privilege_id]);
              }
              return;
          }
          console.log("pluginInfopluginInfopluginInfo",pluginInfo)
          this.addNewExternalPluginIframe(pluginInfo);
          let templuginInfo = {...pluginInfo};
          if(pluginInfo && Object.prototype.hasOwnProperty.call(pluginInfo,'pluginInfo'))
              templuginInfo = {...templuginInfo.pluginInfo}

          this.isActive = templuginInfo.plugin_name;
          updateContext(pluginInfo);
          
              this.loadExternalPluginWorkspaceUI({...templuginInfo,tagId: `extp${pluginInfo.id}`, callback:callback, loadInfo: loadInfo});
      },
      logout(){
    /*     try{
          this.setLoadPageInfo(this.$route);
        }catch(e){console.log(e)} */
        this.logOutFromServer();
        this.setDefaultLanguage();
      },
      async refreshFileInfoAndShowAsset(selectedFileId, is_assetId=null, autoPlay=false, transcriptEntry=null, metadataView=false){
        if ((this.selectedMainComponent == "catalogs-display")||(is_assetId)){
          if(this.selectedAsset && Object.keys(this.selectedAsset).length>0 && this.selectedAsset['asset_id'] == selectedFileId){
            //Skipping the multiple GET API's when the same file is already selected
            console.log("Skipping the multiple GET API's when the same file is already selected")
          }else{
            let payload = {params:{assetId: selectedFileId}}
            let data = await this.getAssetInfoFromServer(payload);
            if (Constants.acceptedStatusCodes.includes(data.statusCode)){
                this.selectedAsset = data["asset"]
            }
          }
          if(!metadataView){
            if(transcriptEntry){
              this.showAssetsDataOnDoubleClick(transcriptEntry,true,()=>{
                console.log('refreshFileInfoAndShowAsset::ASSET::playTranscriptFromSearchResults ....... transcriptEntry',transcriptEntry);
              })
            }else{
              this.showAssetsDataOnDoubleClick();
            }
          }
        }else {
          let payload = {params:{fileId: selectedFileId, metadata:true}}
          this.getFileInfoFromServer(payload).then((data) => {
            this.selectedAsset = data["file"]
            if(!metadataView){
              if(transcriptEntry){
                this.showAssetsDataOnDoubleClick(transcriptEntry,true,()=>{
                  console.log('refreshFileInfoAndShowAsset::FILE::playTranscriptFromSearchResults ....... transcriptEntry',transcriptEntry);
                })
              }else{
                this.showAssetsDataOnDoubleClick();
              }
            }
          })
        }
        this.autoPlay = autoPlay;
      },
      setUpOverflowMenu(over_flow_elements){
        for (let overflowMenu of over_flow_elements) { 
          if (overflowMenu == "jobs"){
            let jobsEvents = [{
              "event_name": "onClick",
              "event_handler": this.openJobs,
              "handler_args":[]
           }]
            let jobs = new OverflowMenu("jobs", "jobs", "Jobs", Utils.getJobsSvg,jobsEvents)
            jobs.register()
          }
          if (overflowMenu == "reports"){
            let reportsEvents = [{
              "event_name": "onClick",
              "event_handler": this.openReports,
              "handler_args":[]
           }]
            let reports = new OverflowMenu("reports", "reports", "Reports", Utils.getReportsSvg,reportsEvents)
            reports.register()
          }
          if (overflowMenu == "settings"){
            let settingsEvents = [{
              "event_name": "onClick",
              "event_handler": this.openSettings,
              "handler_args":[]
           }]
            let settings = new OverflowMenu("settings", "settings", "Settings", Utils.getSettingsSvg,settingsEvents)
            settings.register()
          }
        }
      },
      setUpQuickAccessPanel(quick_access_panel){
        for (let panel of quick_access_panel) {
          if ((panel == "dashboard") && (Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, "Dashboard"))){
            let dashboardEvents = [{
              "event_name": "onClick",
              "event_handler": this.changeComponentToDashboardDisplay,
              "handler_args":[]
           }]
            let dashboard = new QuickAccessPanel("dashboard", "dashboard", "Dashboard", Utils.getDashboardSvg,dashboardEvents)
            dashboard.register()
          }
          if(panel == "favourites"){
            for(let fType of ['bookmark','Saved Search']){
              let favList = this.favoritesList.filter(op=>op.type == fType)
              for(let eachFav of favList){
                this.regFavQAEntry(eachFav)
              }
            }
          }
          if((panel == "bins") && (Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, "bins-workspace"))){
            let binsEvents = [{
              "event_name": "onClick",
              "event_handler": this.changeComponentToBinsDisplay,
              "handler_args":[]
           }]
            let bins = new QuickAccessPanel("bins", "bins", "Bins", Utils.getBinsSvg,binsEvents)
            bins.register()
          }
          if((panel == "catalogs") && (Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, "catalogs-workspace"))){
            let catalogEvents = [{
              "event_name": "onClick",
              "event_handler": this.changeComponentToCatalogsDisplay,
              "handler_args":[]
           }]
            let catalogs = new QuickAccessPanel("catalogs", "catalogs", "Catalogs", Utils.getCatalogSvg,catalogEvents)
            catalogs.register()
          }
        }
      },
      getfavThumbnail(favInfo){
        if(favInfo.cover_photo && favInfo.cover_photo.length > 0){
          return Utils.convertToLoginIPDomainName(favInfo.cover_photo);
        }else{
          return null
        }
      },
      regFavQAEntry(favInfo, forcePush = false){
        let favEvents = [{
            "event_name": "onClick",
            "event_handler": this.changeComponentToFavourite,
            "handler_args":[]
          }]
        if(forcePush){
          this.getSortedQuickAccessPanel.push({
            id:favInfo._id,
            pluginName:'Favorites',
            label:favInfo.name,
            iconSvgCallback:favInfo.type=='bookmark'?Utils.getBookmarkSvg:Utils.getSavedSearchSvg,
            onEvents:favEvents,
            iconUrl:this.getfavThumbnail(favInfo),
            type:"QuickAccessPanel"
          })
        }else{
          let favourites = new QuickAccessPanel(favInfo._id, 'Favorites', favInfo.name, favInfo.type=='bookmark'?Utils.getBookmarkSvg:Utils.getSavedSearchSvg, favEvents, false, this.getfavThumbnail(favInfo))
          favourites.register()
        }
      },
      closeExternalPlugin(){
        this.enabledComponent = null;
        let temp = this.selectedMainComponent;
        temp = temp.split("-")[0];
        this.isActive = temp.charAt(0).toUpperCase() + temp.slice(1);
        Utils.updateCookieByKeyName("context",this.selectedMainComponent)
      },
      async refreshMyspacePrivileges(){
        let data = await this.getUserSpacePrivilege()
        console.log("[refreshMyspacePrivileges refreshMyspacePrivileges]",data);
        this.unSetQuickAccessPanel()
        this.unSetOverflowMenu()
        this.mySpacePrivilege = data.user_space
        this.setUpOverflowMenu(this.mySpacePrivilege[0].over_flow_elements);
        // this.setUpQuickAccessPanel(this.mySpacePrivilege[0].quick_access_panel) //NOT IN USE
        if(Object.keys(this.getRootCategoryDetails()).length){
          let locationToLoad = Object.assign({}, this.getLocationinfoToLoad())
          if(locationToLoad && ["catalogs-display"].indexOf(locationToLoad.name) == -1){
            this.getBinsCatalogBrowseContext(true)
              return;
          } 
          return;
        } 
        try {
          let payload = {};
          payload.params = {page:1,catalog_id:Constants.rootCategory} 
          this.getAllAssetsFromServer(payload).then((data)=>{
            this.setRootCategoryDetails(data["assets"][0])
          })
        } catch (error) {
          console.error(`[refreshMyspacePrivileges][explorer][Set root category details][Error->${error}]`) 
        }
        let locationToLoad = Object.assign({}, this.getLocationinfoToLoad())
        if(locationToLoad && ["catalogs-display"].indexOf(locationToLoad.name) == -1){
            return;
        } 
      },
      setUpContextMenuActions(){
        for (let contextMenu of this.getActionListFromInMem()) {  
          if(!contextMenu.position_priority){
            contextMenu["position_priority"] = 1001
          }
          let action = new BinContextMenu(contextMenu._id, contextMenu.action_name, contextMenu.label, Utils.getSvgIconsForContextMenu(contextMenu.action_name,contextMenu.label), [],
          contextMenu.required_permission,contextMenu.required_states,contextMenu.status,contextMenu.supported_resources,
          contextMenu.supported_types,contextMenu.target_type, null, contextMenu.sub_menu, false,contextMenu.multiple_selection_support, contextMenu.supported_mime_types, contextMenu.position_priority)
          action.register()
        }
      },
      setUpHardCodedPluginContextMenuAction(contextMenu){
        if(!contextMenu.position_priority){
            contextMenu["position_priority"] = 1001
          }
          let action = new BinContextMenu(contextMenu._id, contextMenu.action_name, contextMenu.label, Utils.getSvgIconsForContextMenu(contextMenu.action_name,contextMenu.label), [],
          contextMenu.required_permission,contextMenu.required_states,contextMenu.status,contextMenu.supported_resources,
          contextMenu.supported_types,contextMenu.target_type, null, contextMenu.sub_menu, false,contextMenu.multiple_selection_support, contextMenu.supported_mime_types, contextMenu.position_priority)
          action.register()
      },
      loadBookmarkData(bInfo){
        let pluginConfigDetailsList = this.getInstalledPluginsData;
        let pluginToLoad = null;
        for(let i = 0; i < pluginConfigDetailsList.length; i++){
          if(pluginConfigDetailsList[i] && Object.prototype.hasOwnProperty.call(pluginConfigDetailsList[i],'dependent_plugin_web_paths')){
              for(let j = 0; j < pluginConfigDetailsList[i].dependent_plugin_web_paths.length; j++){
                  if(String(pluginConfigDetailsList[i].dependent_plugin_web_paths[j]).startsWith("REGEXP__")){
                      let regex = new RegExp(String(pluginConfigDetailsList[i].dependent_plugin_web_paths[j]).replace("REGEXP__",""));
                      if(regex.test(bInfo.url)){
                        this.loadedPluginName = pluginConfigDetailsList[i].plugin_name;
                        pluginToLoad = pluginConfigDetailsList[i];
                      }
                  }else{ //(bInfo.url.startsWith(pluginConfigDetailsList[i].dependent_plugin_web_paths[j]))
                    if((bInfo.url.startsWith(pluginConfigDetailsList[i].dependent_plugin_web_paths[j]))){
                      this.loadedPluginName = pluginConfigDetailsList[i].plugin_name;
                      pluginToLoad = pluginConfigDetailsList[i];
                    }
                  }
              }
          }
        }
        if(!pluginToLoad){
          alert("Selected bookmark's plugin is not installed");
          return;
        }
        if(this.$refs['quickAccessPanelRef']){
          let isExists = this.$refs['quickAccessPanelRef'].checkIfGivenPluginExistsInSideMenu(pluginToLoad.plugin_id);
          if(!isExists){
            alert("Configure selected bookmark's plugin in Quick Access Panel to load it");
            return;
          }
        }
        let mappedPluginDetails = this.getRegisteredPluginMapper()[pluginToLoad.plugin_id];
        if(mappedPluginDetails.exposeBundles){
          let bundleInfo = mappedPluginDetails.exposeBundles;
          try{
            Utils.loadCssBundle({id:bundleInfo.css.id,cssUrl:bundleInfo.css.cssUrl});
          }catch(e){console.log(e)}
          Utils.loadPluginBundles([{id:bundleInfo.js.id,jsUrl:bundleInfo.js.jsUrl}], bundleInfo.js.eventName).then((event) => {
            this.registerStoreAndRoutes(event[0])
            let getCurrentRouteInfo = this.$router.resolve({path: bInfo.url}).route;
            this.$router.replace({
              name: getCurrentRouteInfo.name,
              params: getCurrentRouteInfo.params,
              query: getCurrentRouteInfo.query
            })
          });
        }else{
          alert("Selected bookmark's plugin is not installed");
          return;
        }
      },
      getUrlWithoutPage(urlStr){
        const [path, queryString] = urlStr.split('?');
        if (!queryString) return urlStr;
        const params = new URLSearchParams(queryString);
        params.delete('after_key');
        params.delete('page');
        const newQuery = params.toString();
        return newQuery ? `${path}?${newQuery}` : path;
      },
      getEventHandler(info,eventname,supportedEvents,multiPanelInfo){
        console.log("info---------------------------------",info,eventname,supportedEvents,multiPanelInfo);
        this.selectFirstMenu = false;
        this.isFavQPClick = false;
        // this.keywordFilter = ""
        this.loadRouteParams= {}
        this.searchedKeyword = "";
        this.getHeightCalculationBasedOnBookmarksbar();

        this.$nextTick(()=>{
          if(this.$refs.globalSearch)this.$refs.globalSearch.search = '';
          this.enteredKeyword = '';
        })
        /**
         *  Below code in try{}catch block directly calls the click handler attached at damplugins side
         *  Based on clickHandler:{pluginName:'PAM',handler:()=>{}} once clicked the damplugins side will get whole component
         */
        try{
          for(let key in this.getRegisteredPluginMapper()){
              let pluginInfo = this.getRegisteredPluginMapper()[key]; 
              if(pluginInfo && pluginInfo.clickHandler && Object.prototype.hasOwnProperty.call(pluginInfo.clickHandler, 'hasKeyList') && pluginInfo.clickHandler.hasKeyList.length){
                for(let i = 0; i < pluginInfo.clickHandler.hasKeyList.length; i++){
                      if(Object.prototype.hasOwnProperty.call(info,pluginInfo.clickHandler.hasKeyList[i]) || info.pluginName == pluginInfo.clickHandler.hasKeyList[i]){
                          pluginInfo.clickHandler.handler(this,{"info":info,eventname,supportedEvents,multiPanelInfo});
                          return;
                      }
                  }
              }
              if(pluginInfo && pluginInfo.clickHandler && pluginInfo.clickHandler.pluginName && typeof pluginInfo.clickHandler.pluginName == 'string' && pluginInfo.clickHandler.pluginName == info.pluginName){
                  pluginInfo.clickHandler.handler(this,{"info":info,eventname,supportedEvents,multiPanelInfo});
                  return;
              }
              if(pluginInfo && pluginInfo.clickHandler && pluginInfo.clickHandler.pluginName && Array.isArray(pluginInfo.clickHandler.pluginName) && pluginInfo.clickHandler.pluginName.indexOf(info.pluginName) > -1){
                  pluginInfo.clickHandler.handler(this,{"info":info,eventname,supportedEvents,multiPanelInfo});
                  return;
              }
          }
        }catch(e){console.log(e)}
        if (info.externalPlugin != undefined && info.externalPlugin){
          this.selectedExternalPluginInfo = info
          if(info.dialogRequired != undefined && info.dialogRequired){
            return this.openExternalPluginDialog()
          }
          if(info.pluginName == "Review"){
            // this.selectedFileDetails= {"singlefile":{},"multiplefiles":{}};
            // return this.changeComponentToReviewDisplay()
            this.isActive = info.pluginName;
            Utils.updateCookieByKeyName("context","review-display");
            this.loadExternalWorkspacePlugin(info,'review-display',{},true);
            return;
          }if(info.pluginName == "Remote Edit"){
            // this.selectedFileDetails= {"singlefile":{},"multiplefiles":{}};
            // return this.changeComponentToReviewDisplay()
            this.isActive = info.pluginName;
            Utils.updateCookieByKeyName("context","remoteEdit-display");
            this.loadExternalWorkspacePlugin(info,'remoteEdit-display',{},true);
            return;
          }
          if(info.pluginName == "media_pipeline" && multiPanelInfo.type && multiPanelInfo.type == 'stage'){
            this.isActive = multiPanelInfo._id;
            Utils.updateCookieByKeyName("context","media-pipeline-stage");
            setTimeout(() => {
              this.changeComponentToMediaPipelineStages(info,multiPanelInfo)
            }, 200);
            return;
          }
          if(info.pluginName == "media_pipeline" && multiPanelInfo.type && multiPanelInfo.type == 'pipeline'){
            this.isActive = multiPanelInfo._id;
            Utils.updateCookieByKeyName("context","media-pipeline");
            setTimeout(() => {
              this.changeComponentToMediaPipeline(info,multiPanelInfo)
            }, 200);
            return;
          }
          if(info.pluginName == "PAM"){
            this.selectedFileDetails= {"singlefile":{},"multiplefiles":{}};
            return this.changeComponentToProjectsWorksapce()
          }if(info.label == "Ticket"){
            // this.selectedFileDetails= {"singlefile":{},"multiplefiles":{}};
            return this.changeComponentToTickets()
          }
          if(info.pluginName == "Chat" || info.pluginName == "Chat Pro"){
            this.isActive = info.pluginName;
            Utils.updateCookieByKeyName("context","chat-display");
            this.loadExternalWorkspacePlugin(info,'chat-display',{},true);
            return;
          }if(info.pluginName == "Fusion Cut"){
            this.isActive = info.pluginName;
            return this.changeComponentToEditProWorksapce();
            // Utils.updateCookieByKeyName("context","edit-pro");
            // return this.changeComponentToEditPro();
          }if(info.pluginName == "Media Qc"){
            this.loadRouteParams = {},
            this.isActive = info.pluginName;
            Utils.updateCookieByKeyName("context","mediaQc-display");
            this.changeComponentToMediaQCWorkspace();
            return;
          }if(info.pluginName == "Mediashare"){
            this.loadRouteParams = {},
            this.isActive = info.pluginName;
            Utils.updateCookieByKeyName("context","share-display");
            this.loadExternalWorkspacePlugin(info,'share-display',{},true);
            return;
          }if(info.pluginName == "Metadata Approver"){
            return this.changeComponentToMetadataManagerAssetsDisplay(info.label)
          }if(info.pluginName == "Hype"){
            this.isActive = info.pluginName;
            Utils.updateCookieByKeyName("context","hype-display");
            this.loadExternalWorkspacePlugin(info,'hype-display',{},true);
            return;
            // return this.changeComponentToHypeAssetsDisplay()
          }if(info.pluginName == "Licensemanager"){
            this.isActive = info.pluginName;
            Utils.updateCookieByKeyName("context","license-manager-display");
            this.loadExternalWorkspacePlugin(info,'license-manager-display',{},true);
            return;
            // return this.changeComponentToHypeAssetsDisplay()
          }if(info.pluginName == "Gen21"){
            this.isActive = info.pluginName;
            Utils.updateCookieByKeyName("context","gen21-display");
            this.loadExternalWorkspacePlugin(info,'gen21-display',{},true);
            return;
            // return this.changeComponentToHypeAssetsDisplay()
          }if(info.pluginName == "remote_system_stats"){
            this.selectedFileDetails= {"singlefile":{},"multiplefiles":{}};
            return this.changeComponentToRemoteSystemStats()
          }else{
            this.selectedFileDetails= {"singlefile":{},"multiplefiles":{}};
            return this.changeComponentToExternalPluginDisplay(info)
          }
        }else if(info.type=="Saved Search" || info.type=="bookmark"){
        if(!this.$router.resolve({path: this.getUrlWithoutPage(info.url)}).route.matched.length){
          this.loadBookmarkData(info);
          return;
        }
          let favEntry = info;
          if(favEntry){
            Utils.unsetCookie("traverseHistory")
            if(favEntry.url.startsWith("/explorer/catalogs")){
              this.createLabelName = "catalogs-display"
              Utils.updateCookieByKeyName("context","catalogs-display")
            }else{
              this.createLabelName = "bins"
              Utils.updateCookieByKeyName("context","bins")
            }
            this.$router.push({path:favEntry.url})
            if(favEntry.type == "Saved Search"){
              this.enableAdvancedSearch = true;
               this.$nextTick(() => {
                  this.resizeObservor = new ResizeObserver(() =>{
                      // this.resizeObservor.disconnect();
                      this.heightSet();
                  });
                    this.resizeObservor.observe(document.querySelector('.advanced-search-wrapper'));
                });
            }
            return
          }else{
            alert(`Unable to find the details of "${info.label}".`)
            return
          }
        }else if(info.pluginName == "media_pipeline" && multiPanelInfo.type && multiPanelInfo.type == 'stage'){
          this.isActive = multiPanelInfo._id;
          Utils.updateCookieByKeyName("context","media-pipeline-stage");
          setTimeout(() => {
            this.changeComponentToMediaPipelineStages(info,multiPanelInfo)
          }, 200);
          return;
        }
        else if(info.pluginName == "media_pipeline" && multiPanelInfo.type && multiPanelInfo.type == 'pipeline'){
          this.isActive = multiPanelInfo._id;
          Utils.updateCookieByKeyName("context","media-pipeline");
          setTimeout(() => {
            this.changeComponentToMediaPipeline(info,multiPanelInfo)
          }, 200);
          return;
        }
        else if(info.pipeline_id){
          // this.selectedStage = info;
          this.isActive = info._id;
          Utils.updateCookieByKeyName("context","media-pipeline-stage");
          setTimeout(() => {
            this.changeComponentToMediaPipelineStages(info)
          }, 200);
          return;
        }else if(info.pipeline_name){
          // this.selectedPipeline = info;
          this.isActive = info._id;
          Utils.updateCookieByKeyName("context","media-pipeline");
          setTimeout(() => {
            this.changeComponentToMediaPipeline(info)
          }, 200);
          return;
        }else if(Object.keys(info).includes('externalPlugin') && info.externalPlugin == false){
            this.isActive = info.label;
            if(info.id == "catalogs"){
              this.changeComponentToCatalogsDisplay();
            }
            if(info.id == "dashboard"){
              this.changeComponentToDashboardDisplay();
            }
            if(info.id == "bins"){
              this.changeComponentToBinsDisplay();
            }
            if(info.id == "favourites"){
              this.changeComponentToFavourite();
            }
        }else{
          let event = supportedEvents.filter((eventInfo) => eventInfo.event_name == eventname);
          if(event.length != 0){
            return event[0]["event_handler"]();
          }
        }

        // else if(multiPanelInfo){
        //   this.isActive = multiPanelInfo.name;
        //   Utils.updateCookieByKeyName("context","media-pipeline");
        //   setTimeout(() => {
        //     this.changeComponentToExternalPluginDisplay(info,'media-pipeline',{},true)
        //   }, 200);
        //   return;
        // }
      },

      // loadTickets(){
      //   alert("O");
      //   return this.changeComponentToTickets();
      // },

      registerAction(action){
        console.log("actionactionaction",action)
        if(action.sub_menu == "MOREACTIONS"){
          if(this.getLoggedInUserPrivilege().includes(action.action_name)){
            this.registerBinsMoreActionsContextMenu(action)
          }
        }else if(action.sub_menu == "NEWOPTION"){
          this.registerBinsNewActionsContextMenu(action)
        }else if(action.sub_menu == "IMPORTOPTION"){
          this.registerBinsImportActionsContextMenu(action)
        }else if(action.sub_menu == "SHAREACTIONS"){
          console.log("actionaction",action)
          this.registerBinsShareActionsContextMenu(action)
        }else if(action.sub_menu == "CATALOGICON"){
          this.registerCatalogIconActionsContextMenu(action)
        }else if(action.sub_menu == "AITOOLACTIONS"){
          this.registerAIToolActionsContextMenu(action)
        }else if(action.sub_menu == "EXPORTOPTION"){
          this.registerExportActionsContextMenu(action)
        }else if(action.sub_menu == "OPENWITHACTIONS"){
          this.registerOpenWithActionsContextMenu(action)
        }else{
          this.registerBinContextMenu(action)
        }
      },
      updateAction(id, actionName, events=[]){
        this.updateActionCallbacks({
            id: id,
            action_name: actionName,
            onEvents: events,
          })
      },
      registerLinksBrowsePlugins(pluginInfo){
            this.registerAllLinksBrowsePlugins(pluginInfo);
      },
      registerPropertiesTabsPlugins(pluginInfo){
              this.registerPropertiesTabPlugins(pluginInfo);
      },
      registerPamBrowserPlugin(pluginInfo){
        this.registerPamBrowserFromPamPlugin(pluginInfo);
      },
      registerDashboardPluginWidgets(pluginInfo){
          this.registerDashboardWidgetsPlugins(pluginInfo)
      },
      registerMetadataDock(metadatalist){
         this.registerMetadataDockPlugins(metadatalist);
      },
      registerPluginLicense(pluginLicense){
        this.registerPluginLicensePlugins(pluginLicense);
      },
      registerAllReviewTags(tagsList){
        this.registerReviewTags(tagsList);
      },
      registerSubclipPlugin(metadatalist){
         this.registerSubclipPlugins(metadatalist);
      },
      registeredCustomReportsPluginData(reportList){
        this.registerCustomReportsPLugins(reportList)
      },
      registerPropertiesMetadata(metadata){
          this.registerPropertiesMetadataPlugins(metadata);
      },
      registerGlobalButtonExternalPlugins(button){
         this.registerGlobalButtonExternalPlugin(button)
      },
      registerPluginRouterRoutes(info){
          this.registerPluginRouterRoutesForLoading(info);
      },
      registerExternalPluginToQuickAccessPanel(panel){
        let pIndex = this.getInstalledPluginsData.findIndex(e => e.id == panel.id);
        if(pIndex > -1){
          if(this.getInstalledPluginsData[pIndex].position_priority){
            panel["position_priority"] = this.getInstalledPluginsData[pIndex].position_priority;
          }else{
            panel["position_priority"] = 1001
          }
        }
        if (panel.privilege != undefined && panel.privilege && this.getLoggedInUserPrivilege.includes(panel.privilege)){
          this.registerQuickAccessPanel(panel)
        }
      },
      registerCreateReviewButton(button){
        this.registerCreateReviewButton(button)
      },
      registerExternalPluginToOverflowMenu(menu){
        this.registerOverflowMenu(menu)
      },
      registerExternalPluginToImportExportSettingsMenu(menu){
        this.registerImportExportSettingsMenu(menu)
      },
      registerExternalPluginToSystemSettingsMenu(menu){
        console.log("system settings tabs list from explorere.vue...", menu)
        this.registerSystemSettingsMenu(menu)
      },
      registerSettingsSideNavMenu(menu){
        if(menu && 'privilege' in menu && menu.privilege.trim().length > 0 && !this.isEnabled(menu.privilege)){
          return;
        }
        this.registerSettingsSidemenu(menu)
      },
      registerPropertiesTopNavigationBar(menu){
        console.log("properties top nav bar list from explorere.vue...", menu)
        this.registerPropertiesTopNav(menu)
      },
      registerMediaBrowseIconToOpenDialog(menu){
        this.registerDialogForMediaBrowse(menu)
      },
      registerShareNavMenus(menu){
        this.registerShareExternalPlugins(menu)
      },
      registerDashboardWidgetsData(menu){
        this.registerDashboardWidgets(menu)
      },
      registerReportsSideNavMenu(menu){
        if('privilege' in menu && !this.isEnabled(menu.privilege)){
          return;
        }
        this.registerReportsSidemenu(menu)
      },
      registerPluginDefaultData(pluginId, data){
        if (pluginId.includes('chat') || pluginId.includes('chat-pro')){
            this.addChatStartupData(data)
        }
      },
      registerMyApp(menu){
        this.registerMyApps(menu)
      },
      registorInstalledPlugins(){
        let currentPath = this.getPathLocationInfoToLoad();
       console.log("[registorInstalledPlugins] currentPath",currentPath);
       return new Promise((resolve) => {
        this.getInstalledPluginsFromServer().then((data) => {
          let externalPlugins = []
          if (data.statusCode == 200){
            externalPlugins = data.plugins;
            this.setInstalledPluginsData(externalPlugins)
          }
          
          const resolvePluginNotFoundPromise = () => {
              this.externalPluginInstalledPromise = new Promise((resolve, reject) => {
                 this.externalPluginInstalledDefered.didplugincomponentRegistered = {resolve: resolve, reject: reject};
             });
             this.externalPluginInstalledDefered.didplugincomponentRegistered.resolve();
          }

          let pluginConfigDetailsList = this.getInstalledPluginsData;
          console.log("All installed plugins",pluginConfigDetailsList);

          const findPluginToLoad = () => {
             let pluginToLoad = null;
             for(let i = 0; i < pluginConfigDetailsList.length; i++){
                if(pluginConfigDetailsList[i] && Object.prototype.hasOwnProperty.call(pluginConfigDetailsList[i],'dependent_plugin_web_paths')){
                    for(let j = 0; j < pluginConfigDetailsList[i].dependent_plugin_web_paths.length; j++){
                         console.log("pluginConfigDetailsList[i].dependent_plugin_web_paths[j]",pluginConfigDetailsList[i].dependent_plugin_web_paths[j],"currentPath",currentPath);
                        if(String(pluginConfigDetailsList[i].dependent_plugin_web_paths[j]).startsWith("REGEXP__")){
                           let regex = new RegExp(String(pluginConfigDetailsList[i].dependent_plugin_web_paths[j]).replace("REGEXP__",""));
                           if(regex.test(currentPath)){
                              this.loadedPluginName = pluginConfigDetailsList[i].plugin_name;
                              pluginToLoad = pluginConfigDetailsList[i].plugin_name;
                              this.externalPluginInstalledPromise = new Promise((resolve, reject) =>{
                                  this.externalPluginInstalledDefered.didplugincomponentRegistered = {resolve: resolve, reject: reject};
                              });
                              return pluginToLoad;
                           }
                        }else{ //(currentPath.startsWith(pluginConfigDetailsList[i].dependent_plugin_web_paths[j]))
                          if((currentPath.startsWith(pluginConfigDetailsList[i].dependent_plugin_web_paths[j]))){
                            console.log("[registorInstalledPlugins] current path",pluginConfigDetailsList[i].plugin_name);
                            this.loadedPluginName = pluginConfigDetailsList[i].plugin_name;
                            pluginToLoad = pluginConfigDetailsList[i].plugin_name;
                            this.externalPluginInstalledPromise = new Promise((resolve, reject) =>{
                                this.externalPluginInstalledDefered.didplugincomponentRegistered = {resolve: resolve, reject: reject};
                            });
                            return pluginToLoad;
                          }
                        }
                    }
                }
             }
             return null;
          }

          let pluginToLoad = null;
          if(pluginConfigDetailsList.length && currentPath){
             pluginToLoad = findPluginToLoad();
          }else{
              resolvePluginNotFoundPromise();
          }

          if(!pluginToLoad){
             resolvePluginNotFoundPromise();
          }

          console.log("pluginToLoad .............>>>>pluginToLoad",pluginToLoad);

          for (let plugin of externalPlugins) {
            try {
              let isAnyPrivEnabled = false;
              if('privileges' in plugin){
                for(let a of plugin.privileges){
                  if(this.isEnabled(a)){
                    isAnyPrivEnabled = true;
                    break;
                  }
                }
              }
              if(this.isEnabled(plugin.privilege_id) || isAnyPrivEnabled){
                plugin["id"] = plugin["plugin_id"]
                if(plugin.quick_access_registry && plugin.quick_access_registry.length){
                  plugin["multi_panels"] = plugin["quick_access_registry"]
                }
                this.registerDamPlugin({plugin: plugin,       // eslint-disable-line no-undef
                  // jsFileUrl:`${window.location.origin}/components/components/editPro/editProProjects.vue` ,
                  jsFileUrl:`${window.location.origin}/damplugins${plugin.web_hook_path}` ,
                  damInterface:{
                    actionRegistrator: this.registerAction,
                    updateRegisteredAction: this.updateAction,
                    quickAccessPanelRegistrator:this.registerExternalPluginToQuickAccessPanel,
                    createReviewButtonRegsitrator:this.registerCreateReviewButton,
                    overflowMenuRegistrator: this.registerExternalPluginToOverflowMenu,
                    systemSettingsMenuRegistrator: this.registerExternalPluginToSystemSettingsMenu,
                    settingsSideMenuRegistrator: this.registerSettingsSideNavMenu,
                    propertiesTopNavBarRegistrator: this.registerPropertiesTopNavigationBar,
                    mediaBrowseIconRegistrator: this.registerMediaBrowseIconToOpenDialog,
                    importExportMenuRegistrator: this.registerExternalPluginToImportExportSettingsMenu,
                    shareMenusRegistrator: this.registerShareNavMenus,
                    reportsSideMenuRegistrator: this.registerReportsSideNavMenu,
                    setPluginDefaultData:this.registerPluginDefaultData,
                    dashboardWidgetsRegistrator:this.registerDashboardWidgetsData,
                    // addNewExternalPluginIframe: this.addNewExternalPluginIframe,
                    globalNewButtonRegistrator: this.registerGlobalButtonExternalPlugins,
                    propertiesMetadataRegistrator: this.registerPropertiesMetadata, //this will register to show plugins list such as Transcript list , ocr list etc in Properties
                    metadataDockListRegistrator: this.registerMetadataDock, // In Metadata dock it will register plugins list like Transcript , OCR , Faces etc
                    pluginLicenseRegistrator : this.registerPluginLicense,
                    reviewTagsArrRegistrator: this.registerAllReviewTags,
                    subclipRegistrator: this.registerSubclipPlugin, 
                    exposeExplorerComponent: () => {return this},
                    registerPropertiesTabPlugins:this.registerPropertiesTabsPlugins,
                    registerDashboardWidgetsPlugins:this.registerDashboardPluginWidgets,
                    pluginToLoad: pluginToLoad,
                    pamBrowsersPluginsRegistrator:this.registerPamBrowserPlugin,
                    loadingPath:currentPath,
                    myAppRegistrator: this.registerMyApp, 
                    setUpHardCodedPluginContextMenuAction: this.setUpHardCodedPluginContextMenuAction,
                    registerLinksBrowsePlugins: this.registerLinksBrowsePlugins,
                    customReportsRegistrator: this.registeredCustomReportsPluginData,
                    registerPluginRouterRoutes: this.registerPluginRouterRoutes,
                    addScreensToNotPlayMiniplayerOverlay: this.addScreensToNotPlayMiniplayerAndDoc
                  }
                })
                if(this.$refs &&  this.$refs.maincomponentsettings)
                     this.$refs.maincomponentsettings.reloadSettingsSideMenuList();
                  resolve(externalPlugins);
              }else{
                console.warn("[explorer][registorInstalledPlugins][User is not having privilege for ", plugin)
              }

            } catch (error) {
              console.error(error)
            }
          }
         });
       });
      },

      triggerClickTheEnterbutton(){
        if(this.$refs.globalSearch && this.$refs.globalSearch.search)this.keywordFilter = this.$refs.globalSearch.search;
        if(this.$refs.globalSearch && this.$refs.globalSearch.$el)this.$refs.globalSearch.$el.click();
        this.keywordSearchParameters();
      },

      keywordSearchParameters(){
        if(this.enabledComponent == 'projects-display'){
            //   this.$refs["fullScreencomponent" + this.enabledComponent].functionCallForGlobalKeywordSearch(this.keywordFilter);
            let query = Object.assign({},this.$route.query) 
            query.keyword = `${this.keywordFilter}`
            query.page = 1
            this.$router.push({
                query:query
            })
        }else if  (this.selectedMainComponent == "bins-display"){
          let query = Object.assign({},this.$route.query)
          query.keyword = `${this.keywordFilter}`
          this.$router.push({
              query:query
          })
        }else if  (this.selectedMainComponent == "remoteEdit-display"){
          // let query = Object.assign({},this.$route.query)
          let query = {};
          if(`${this.keywordFilter}`){
            query.project_name = `${this.keywordFilter}`
          }  
          this.$router.push({
              query:query
          })
        }else if  (this.selectedMainComponent == 'media-pipeline-stage'){
          let query = Object.assign({},this.$route.query)
          query.keyword = `${this.keywordFilter}`
          this.$router.push({
              query:query
          })
        }else if  (this.selectedMainComponent == 'media-pipeline'){
          let query = Object.assign({},this.$route.query)
          query.keyword = `${this.keywordFilter}`
          this.$router.push({
              query:query
          })
        }else if (this.selectedMainComponent == 'mediaQc-display'){
          let query = Object.assign({},this.$route.query)
          query.keyword = `${this.keywordFilter}`
          this.$router.push({
              query:query
          })
        }else if (this.selectedMainComponent == "dashboard"){
          alert("Search not supported here..!");
          this.clearSearchData();
        }else{
          if([ 'projects-display','edit-pro'].includes(this.selectedMainComponent)){
            this.enableAdvancedSearch = false;
          }else{
            this.enableAdvancedSearch = true;
          }
            //   this.$refs["maincomponent" +  this.selectedMainComponent].functionCallForGlobalKeywordSearch(this.keywordFilter);
            
            // if(document.getElementById("search_bar").value == ''){
            //   this.keywordFilter = "";
            // }
            let query = Object.assign({},this.$route.query) 
            if(this.keywordFilter.length > 0){
              query.keyword = `${this.keywordFilter}`
            }else if('keyword' in query){
              if('advanceFilter' in query){
                let tempParse = JSON.parse(query.advanceFilter)
                if(Object.keys(tempParse).includes('search_as')){
                  delete tempParse["search_as"]
                }
                if(Object.keys(tempParse).includes('search_in')){
                  delete tempParse["search_in"]
                }
                console.log("tempParsetempParse",tempParse)
                query.advanceFilter = JSON.stringify(tempParse)
              }
              delete query.keyword
            }
            query.page = 1
            this.$router.push({
                query:query
            })
            this.$nextTick(() => {
              this.resizeObservor = new ResizeObserver(() =>{
                  // this.resizeObservor.disconnect();
                  this.heightSet();
              });
                this.resizeObservor.observe(document.querySelector('.advanced-search-wrapper'));
            });
          // this.searchedKeyword = this.keywordFilter;
        }
      },
      clearSearchData(){
        // this.keywordFilter = "";
        this.searchedKeyword = "";
        this.showVideoMiniplayer = false;
      },

      hideMiniPlayerOnContextMenuDeselect(){
        this.showVideoMiniplayer = false;
      },

      retainSearchedKeywordToExplorer(searchedKeyword){
        if(searchedKeyword == undefined || searchedKeyword == null){
          this.keywordFilter = "";
        }else{
          this.keywordFilter = searchedKeyword;
        }
        this.searchedKeyword = searchedKeyword
        this.searchedValue = [searchedKeyword];
        this.$refs.globalSearch.search = searchedKeyword;
      },

      async handleUserLogin(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
          let session_info = notification.message
          if(notification.message_type == NotifierConstants.licenseUpdatedNotification){
                alert('License got updated.\nPlease log in again.');
                await this.logOutFromServer();
                this.setDefaultLanguage();
          }else{
            if ((session_info.logged_in)&&(session_info.user_id == this.getLoggedInUserId)){
              let session_id = Utils.getCookieValue("session_id")
              if(session_info && Object.prototype.hasOwnProperty.call(session_info,'logged_in_from_mobile') && 
                  session_info.logged_in_from_mobile)  return; // don't logout as mobile is having different session
              if ((session_id != session_info.session_id)&&(this.getClientSystemIP!=session_info.system_ip)){
                alert(`User logged in to different system(${session_info.system_ip}), So logging out here`)
                await this.logOutFromServer();
                this.setDefaultLanguage();
              }
            }
          }
        }
      },

      sendRetrieveSettingNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
          if(notification.message && 'preferred_retrieve_path_mapper' in notification.message && notification.message.preferred_retrieve_path_mapper){
            let userRetrivePath = notification.message.preferred_retrieve_path_mapper.find(op=>op.user_id == this.getLoggedInUserId)
            if(userRetrivePath){
              this.updatestartupDatainfo({'user_preferred_retrieve_path':userRetrivePath.user_preferred_retrieve_path})
            }
          }
        }
        this.$toast.info("Global Retrieve path has updated");
      },

      sendUploadSettingNotification(){
        // this.$toast.info("Global Upload path has updated");
      },

      sendUserUpdateNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message._id == this.getLoggedInUserId){
          if('user_preferred_retrieve_path' in notification.message){
            this.updatestartupDatainfo({'user_preferred_retrieve_path':notification.message.user_preferred_retrieve_path})
          }

          if('user_language' in notification.message){
            this.selectedLanguage = notification.message.user_language;
          }
          // this.$toast.info("Logged in User has updated");
          this.reloadPanelPath = this.$route
          if('status' in notification.message && notification.message.status == 'disabled'){
            alert(`Logged in user account has been marked as inactive.\n Please contact System Admin.`)
            this.logOutFromServer();
            return
          }
          this.isAssetsGetRequired = this.determineIsPrivilegeChangedBins(notification);
          this.isReloadPanelComponentVisible = true;
        }
      },

      handleLanguageUpdateNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
          this.getActiveLanguagesList();
        }  
      },

      sendpluginInstalledNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        this.$toast.info(notification.message.message);
      },

      sendpluginUpgradedNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        this.$toast.info(notification.message.message);
      },

      sendPluginUninstalledNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        this.$toast.info(notification.message.message);
      },

      async updatePools(){
          let pools = await this.getFusionPools()
          this.setPoolsInfo(pools)
      },
      async updatePoolDevices(){
        let devices = await this.getPoolDevices()
        this.setPoolDevices(devices)
      },

      handleMessageCreatedNotification(notification){
        if(this.isEnabled('Chat')){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
          let messageInfo = notification.message;
          if ([NotifierConstants.messageCreatedNotification, 
                      NotifierConstants.mentionedYouInMessageNotification, 
                      NotifierConstants.messageModifiedNotification, 
                      NotifierConstants.replyCountModifiedNotification].includes(notification.message_type)){
              // Utils.showBrowserNotification(notification, this.getLoggedInUserId,
              //             [(notification)=>this.$router.push({name:"chat-display", params:Object.assign({}, notification)})])
          if(notification.message_type == NotifierConstants.mentionedYouInMessageNotification && messageInfo.receiver_type == 'group'){
              if(messageInfo.mentioned_user_ids.includes(this.getLoggedInUserId)){
                  // const audio = new Audio(Utils.getSecondaryNotificationAudio());
                  // audio.play();  
                  // this.$toast.info(messageInfo.sender_name+"' mentioned you in " + messageInfo.receiver_name + " channel");
                  if(this.isActive != 'Chat')this.newMessageNotificationTagVisible = true;
              }
          }
          if (notification.message_type == NotifierConstants.messageCreatedNotification){
              let loggedInuserChannels = this.getChatStartupData().channels?this.getChatStartupData().channels:[]
              Utils.showBrowserNotification(Object.assign({loggedInuserChannels: loggedInuserChannels}, notification), this.getLoggedInUserId,
                        [(notification)=>this.$router.push({
                            name:"chat-display", 
                            params: {
                              resource: notification.message.receiver_type == 'group'?'ch':'dm',
                              recipientId: notification.message.receiver_type == 'group'?notification.message.receiver_id:notification.message.sender_id,
                              commentId: notification.message.pid=="0"?notification.message._id:notification.message.pid
                              }
                            })])
              if(this.getLoggedInUserId != messageInfo.sender_id && messageInfo.receiver_type == 'group' && 
                        loggedInuserChannels.includes(messageInfo.receiver_id)){
                  const audio = new Audio(Utils.getNotificationAudio());
                  audio.play();
                  this.$toast("New message from '"+messageInfo.sender_name+"' in " + messageInfo.receiver_name + " channel",
                        {
                            type: "info",
                            timeout: Constants.chatToastTimeOut,
                            onClick: ()=>{
                                    if (this.$route.name == "chat-display" &&
                                        this.$route.params.resource == (notification.message.receiver_type=='group'?'ch':'dm') &&
                                        this.$route.params.recipientId == (notification.message.receiver_type == 'group'?notification.message.receiver_id:notification.message.sender_id) &&
                                        this.$route.params.commentId == (notification.message.pid=="0"?notification.message._id:notification.message.pid)){
                                            console.log(`[ChatRouteCallback][User already in message->${notification.message.pid=="0"?notification.message._id:notification.message.pid}]`)
                                            return
                                        }
                                    this.$router.push({
                                        name:"chat-display", 
                                        params: {
                                            resource: notification.message.receiver_type == 'group'?'ch':'dm',
                                            recipientId: notification.message.receiver_type == 'group'?notification.message.receiver_id:notification.message.sender_id,
                                            commentId: notification.message.pid=="0"?notification.message._id:notification.message.pid
                                        }
                                    })
                                }
                        });
                  if(this.isActive != 'Chat')this.newMessageNotificationTagVisible = true;
              }
              
              if(this.getLoggedInUserId == messageInfo.receiver_id && messageInfo.receiver_type != 'group'){
                  const audio = new Audio(Utils.getSecondaryNotificationAudio());
                  audio.play();
                //   this.$toast.info("New message from '"+messageInfo.sender_name);
                  this.$toast("New message from '"+messageInfo.sender_name,
                        {
                            type: "info",
                            timeout: Constants.chatToastTimeOut,
                            onClick: ()=>{
                                    if (this.$route.name == "chat-display" &&
                                        this.$route.params.resource == (notification.message.receiver_type=='group'?'ch':'dm') &&
                                        this.$route.params.recipientId == (notification.message.receiver_type == 'group'?notification.message.receiver_id:notification.message.sender_id) &&
                                        this.$route.params.commentId == (notification.message.pid=="0"?notification.message._id:notification.message.pid)){
                                            console.log(`[ChatRouteCallback][User already in message->${notification.message.pid=="0"?notification.message._id:notification.message.pid}]`)
                                            return
                                        }
                                    this.$router.push({
                                        name:"chat-display", 
                                        params: {
                                            resource: notification.message.receiver_type == 'group'?'ch':'dm',
                                            recipientId: notification.message.receiver_type == 'group'?notification.message.receiver_id:notification.message.sender_id,
                                            commentId: notification.message.pid=="0"?notification.message._id:notification.message.pid
                                        }
                                    })
                                }
                        });
                  if(this.isActive != 'Chat')this.newMessageNotificationTagVisible = true;
              }
          }
        }
        }
      },

      handleUserNotificationDisplayState(){
          this.openNotifications = !this.openNotifications;
      },

      handleUserNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message_type == NotifierConstants.userNotificationCreated){
          if(notification.message.scope == 'bell' && notification.message.message_to.includes(this.getLoggedInUserId)){
              const audio = new Audio(Utils.getNotificationAudio());
              audio.play();
              this.enableUserNotificationBadge = true;
          }else if(notification.message.scope == 'mentions' && notification.message.message_to.includes(this.getLoggedInUserId)){
              const audio = new Audio(Utils.getSecondaryNotificationAudio());
              audio.play();
              this.enableUserNotificationBadge = true;
          }
        }
      },
      handleFavNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message && notification.message.user_id == this.getLoggedInUserId){
              let favInfo = notification.message
              if('type' in favInfo && favInfo.type && ['Saved Search', 'bookmark'].includes(favInfo.type)){
                if(notification.message_type == NotifierConstants.favoriteRemovedNotification){
                    this.favoritesList = this.favoritesList.filter(op=>op._id != favInfo._id)
                    this.removeQuickAccessPanelEntry(favInfo)

                }else if(notification.message_type == NotifierConstants.favoriteModifiedNotification){
                    let indx = this.favoritesList.findIndex(op=>op._id == favInfo._id)
                    if(indx >= 0){
                        this.$set(this.favoritesList[indx], "name", favInfo.name);
                        this.$set(this.favoritesList[indx], "show_in_bookmark_bar", favInfo.show_in_bookmark_bar)
                        this.$set(this.favoritesList[indx], "show_in_quick_access_panel", favInfo.show_in_quick_access_panel)
                        if(Object.keys(favInfo).includes('cover_photo')){
                          this.$set(this.favoritesList[indx], "cover_photo", Utils.convertToLoginIPDomainName(favInfo.cover_photo))
                        }
                        let qPIndx = this.getSortedQuickAccessPanel.findIndex(op=>op.id == favInfo._id)
                        if(qPIndx >= 0){
                          this.$set(this.getSortedQuickAccessPanel[qPIndx], "label", favInfo.name)
                          if(favInfo.cover_photo){
                            this.$set(this.getSortedQuickAccessPanel[qPIndx], 'iconUrl', this.getfavThumbnail(favInfo))
                          }
                        }
                    }
                }else if(notification.message_type == NotifierConstants.favoriteCreatedNotification){
                    this.favoritesList.push(favInfo)
                    this.regFavQAEntry(favInfo, true)
                }
              }
            }
        },

      updateGlobalSettingsValueFromNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
        if(Object.keys(notification.message).includes('lock_restricted_actions')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('lock_restricted_actions')){
            this.updatestartupDatainfo({"lock_restricted_actions":notification.message.lock_restricted_actions});
          }
        }
        if(Object.keys(notification.message).includes('CATALOG_READ_ONLY')){
            if(Object.keys(this.getStartUpDataFromInCache()).includes('CATALOG_READ_ONLY')){
                this.updatestartupDatainfo({"CATALOG_READ_ONLY":notification.message.CATALOG_READ_ONLY});
            }
        }
        if(Object.keys(notification.message).includes('ARCHIVE_TO_REQUIRED')){
            if(Object.keys(this.getStartUpDataFromInCache()).includes('ARCHIVE_TO_REQUIRED')){
                this.updatestartupDatainfo({"ARCHIVE_TO_REQUIRED":notification.message.ARCHIVE_TO_REQUIRED});
            }
        }
        if(Object.keys(notification.message).includes('configure_description_from_screen')){
            if(Object.keys(this.getStartUpDataFromInCache()).includes('configure_description_from_screen')){
                this.updatestartupDatainfo({"configure_description_from_screen":notification.message.configure_description_from_screen});
            }
        }
        if(Object.keys(notification.message).includes('configure_tags_from_screen')){
            if(Object.keys(this.getStartUpDataFromInCache()).includes('configure_tags_from_screen')){
                this.updatestartupDatainfo({"configure_tags_from_screen":notification.message.configure_tags_from_screen});
            }
        }
        if(Object.keys(notification.message).includes('configure_catalogs_from_screen')){
            if(Object.keys(this.getStartUpDataFromInCache()).includes('configure_catalogs_from_screen')){
                this.updatestartupDatainfo({"configure_catalogs_from_screen":notification.message.configure_catalogs_from_screen});
            }
        }
        if(Object.keys(notification.message).includes('enable_multi_catalog_browse')){
            if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_multi_catalog_browse')){
                this.updatestartupDatainfo({"enable_multi_catalog_browse":notification.message.enable_multi_catalog_browse});
            }
        }
        if(Object.keys(notification.message).includes('configure_upload_location_from_screen')){
            if(Object.keys(this.getStartUpDataFromInCache()).includes('configure_upload_location_from_screen')){
                this.updatestartupDatainfo({"configure_upload_location_from_screen":notification.message.configure_upload_location_from_screen});
            }
        }
        if(Object.keys(notification.message).includes('DISABLE_SECURED_PASSWORD_ENFORCEMENT')){
          Utils.setLocalStorageValue('enable_password_enforcement', JSON.stringify(!(notification.message.DISABLE_SECURED_PASSWORD_ENFORCEMENT)))
        }else{
          Utils.setLocalStorageValue('enable_password_enforcement', JSON.stringify(true))
        }
        if(Object.keys(notification.message).includes('enable_auto_complete_for_assets_search')){
          Utils.setLocalStorageValue('enable_auto_complete_for_assets_search', JSON.stringify(notification.message.enable_auto_complete_for_assets_search))
        }else{
          Utils.setLocalStorageValue('enable_auto_complete_for_assets_search', JSON.stringify(true))
        }

        if(Object.keys(notification.message).includes('enable_reference_id_workflow')){
            if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_reference_id_workflow')){
                this.updatestartupDatainfo({"enable_reference_id_workflow":notification.message.enable_reference_id_workflow});
            }
        }
        if(Object.keys(notification.message).includes('allow_refrence_id_to_edit')){
            if(Object.keys(this.getStartUpDataFromInCache()).includes('allow_refrence_id_to_edit')){
                this.updatestartupDatainfo({"allow_refrence_id_to_edit":notification.message.allow_refrence_id_to_edit});
            }
        }
        if(Object.keys(notification.message).includes('enable_assets_tree_count')){
            if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_assets_tree_count')){
                this.updatestartupDatainfo({"enable_assets_tree_count":notification.message.enable_assets_tree_count});
            }
        }
        if(Object.keys(notification.message).includes('enable_file_extension')){
            if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_file_extension')){
                this.updatestartupDatainfo({"enable_file_extension":notification.message.enable_file_extension});
            }
        }
        if(Object.keys(notification.message).includes('alias')){
            if(Object.keys(this.getStartUpDataFromInCache()).includes('alias')){
                this.updatestartupDatainfo({"alias":notification.message.alias});
            }
        }
        if(Object.keys(notification.message).includes('client_logo')){
          Utils.setLocalStorageValue('client_logo', JSON.stringify(notification.message.client_logo))
          if(Object.keys(this.getStartUpDataFromInCache()).includes('client_logo')){
              this.updatestartupDatainfo({"client_logo":notification.message.client_logo});
              this.showFusionLogo = false;
          }
        }else{
          Utils.setLocalStorageValue('client_logo', JSON.stringify(Utils.getLogoWithText()))
          this.showFusionLogo = true;
        }

        if(Object.keys(notification.message).includes('landing_page_logo_web')){
          Utils.setLocalStorageValue('landing_page_logo_web', JSON.stringify(notification.message.landing_page_logo_web))
          if(Object.keys(this.getStartUpDataFromInCache()).includes('landing_page_logo_web')){
              this.updatestartupDatainfo({"landing_page_logo_web":notification.message.landing_page_logo_web});
              Utils.setLocalStorageValue('landing_page_logo_web', JSON.stringify(notification.message.landing_page_logo_web))
              if(notification.message.landing_page_logo_web.length > 0){
                this.landingPageLogo = notification.message.landing_page_logo_web;
              }else{
                this.landingPageLogo = Utils.getLogo();
              }
          }
        }else{
          Utils.setLocalStorageValue('landing_page_logo_web', JSON.stringify(Utils.getLogo()))
          this.landingPageLogo = Utils.getLogo();
          this.showFusionLogo = true;
        }

        if(Object.keys(notification.message).includes('client_branding_name')){
          Utils.setLocalStorageValue('client_branding_name', JSON.stringify(notification.message.client_branding_name))
          if(Object.keys(this.getStartUpDataFromInCache()).includes('client_branding_name')){
              this.updatestartupDatainfo({"client_branding_name":notification.message.client_branding_name});
          }
        }else{
          Utils.setLocalStorageValue('client_branding_name', null)
        }

        if(Object.keys(notification.message).includes('media_edit_advanced_controls')){
          Utils.setLocalStorageValue('media_edit_advanced_controls', JSON.stringify(notification.message.media_edit_advanced_controls))
          if(Object.keys(this.getStartUpDataFromInCache()).includes('media_edit_advanced_controls')){
              this.updatestartupDatainfo({"media_edit_advanced_controls":notification.message.media_edit_advanced_controls});
          }
        }else{
          Utils.setLocalStorageValue('media_edit_advanced_controls', null)
        }

        if(Object.keys(notification.message).includes('enable_display_catalogs')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_display_catalogs')){
              this.updatestartupDatainfo({"enable_display_catalogs":notification.message.enable_display_catalogs});
          }
        }

        if(Object.keys(notification.message).includes('disable_resolution_display_for_video')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('disable_resolution_display_for_video')){
              this.updatestartupDatainfo({"disable_resolution_display_for_video":notification.message.disable_resolution_display_for_video});
          }
        }

        if(Object.keys(notification.message).includes('disable_resolution_display_for_image')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('disable_resolution_display_for_image')){
              this.updatestartupDatainfo({"disable_resolution_display_for_image":notification.message.disable_resolution_display_for_image});
          }
        }

        if(Object.keys(notification.message).includes('enable_department')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_department')){
              this.updatestartupDatainfo({"enable_department":notification.message.enable_department});
          }
        }

        if(Object.keys(notification.message).includes('department_alias')){
            if(Object.keys(this.getStartUpDataFromInCache()).includes('department_alias')){
                this.updatestartupDatainfo({"department_alias":notification.message.department_alias});
            }
        }

        if(Object.keys(notification.message).includes('enable_department')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_department')){
              this.updatestartupDatainfo({"enable_department":notification.message.enable_department});
          }
        }

        if(Object.keys(notification.message).includes('enable_resumable_uploads')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_resumable_uploads')){
              this.updatestartupDatainfo({"enable_resumable_uploads":notification.message.enable_resumable_uploads});
          }
        }

        if(Object.keys(notification.message).includes('enable_folder_upload')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_folder_upload')){
              this.updatestartupDatainfo({"enable_folder_upload":notification.message.enable_folder_upload});
          }
        }

        if(Object.keys(notification.message).includes('datetime_format')){
              if(Object.keys(this.getStartUpDataFromInCache()).includes('datetime_format')){
                  this.updatestartupDatainfo({"datetime_format":notification.message.datetime_format});
              }
          }

          if(Object.keys(notification.message).includes('date_format')){
              if(Object.keys(this.getStartUpDataFromInCache()).includes('date_format')){
                  this.updatestartupDatainfo({"date_format":notification.message.date_format});
              }
          }

          if(Object.keys(notification.message).includes('application_time_zone')){
              if(Object.keys(this.getStartUpDataFromInCache()).includes('application_time_zone')){
                  this.updatestartupDatainfo({"application_time_zone":notification.message.application_time_zone});
              }
          }
        if(Object.keys(notification.message).includes('global_path')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('global_path')){
              this.updatestartupDatainfo({"global_path":notification.message.global_path});
          }
        }

        if(Object.keys(notification.message).includes('pinned_filters_in_catalog_workspace')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('pinned_filters_in_catalog_workspace')){
              this.updatestartupDatainfo({"pinned_filters_in_catalog_workspace":notification.message.pinned_filters_in_catalog_workspace});
          }
        }

        if(Object.keys(notification.message).includes('enable_ai_plugin_related_buttons')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_ai_plugin_related_buttons')){
              this.updatestartupDatainfo({"enable_ai_plugin_related_buttons":notification.message.enable_ai_plugin_related_buttons});
          }
          this.unsetAIToolActionsContextMenu();
            this.updateAllUserActionstoInMem().then(()=>{
            this.setupContextmenuActionsOnReloadPanel();
            console.log("Updating contextmenu w.r.t enable_ai_plugin_related_buttons")
          })
        }
        if(Object.keys(notification.message).includes('enable_nlp_search')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('enable_nlp_search')){
              this.updatestartupDatainfo({"enable_nlp_search":notification.message.enable_nlp_search});
          }
        }

        if(Object.keys(notification.message).includes('selected_model_for_nlp')){
          if(Object.keys(this.getStartUpDataFromInCache()).includes('selected_model_for_nlp')){
              this.updatestartupDatainfo({"selected_model_for_nlp":notification.message.selected_model_for_nlp});
          }
        }
      },

      checkIfAdvancedSearchEnabled(){
         if('pinned_filters_in_catalog_workspace' in this.getStartUpDataFromInCache() && this.getStartUpDataFromInCache().pinned_filters_in_catalog_workspace){
          return true
         }
         return this.enableAdvancedSearch;
      },
      updateUploadInfo(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
        if(Object.keys(this.getStartUpDataFromInCache()).includes('upload_settings') && this.getStartUpDataFromInCache().upload_settings.length > 0){
          this.getStartUpDataFromInCache().upload_settings[0] = notification.message;
        }
      },
      handleUserForceLogot(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message && 'force_logout' in notification.message && notification.message.force_logout){
          if (this.getLoggedInUserId == notification.message["user_id"]){
            let msg = `User logged out forcefully.`;
            if(notification.message && Object.prototype.hasOwnProperty.call(notification.message,'display_message')){
                msg = notification.message.display_message;
            } 
            alert(msg);
            this.logOutFromServer()
          }
        }
      },
      handleUserDeletion(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message &&
           (notification.message_type == NotifierConstants.userRemovedNotification) &&
           notification.message._id == this.getLoggedInUserId){
            alert("Your account has been deleted. Please contact administrator.")
            this.logOutFromServer()
        }
      },
      handleSubclipsSettingsNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
        if(notification.message){
          this.updatestartupDatainfo({"subclip_settings":notification.message});
        }
      },
      handleVersionConfigUpdateNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
        if(this.isEnabled('Manage Version')){
          if(notification.message.show_version_info)this.setVersionInfoDislayCheckDetails(notification.message.show_version_info)
        }
      },
      registerWebsocketNotifier(){
        this.addWSEventListener({eventname:[NotifierConstants.userRemovedNotification], callback:this.handleUserDeletion,parent:"Explorer"})
        this.addWSEventListener({eventname:[NotifierConstants.userLoggedOutNotification], callback:this.handleUserForceLogot,parent:"Explorer"})
        this.addWSEventListener({
            eventname:[NotifierConstants.favoriteCreatedNotification, NotifierConstants.favoriteModifiedNotification, NotifierConstants.favoriteRemovedNotification],
            callback:this.handleFavNotification,
            parent:"Explorer"})
        this.addWSEventListener({eventname:[NotifierConstants.fieldCreatedNotification,NotifierConstants.fieldModifiedNotification,NotifierConstants.fieldRemovedNotification],
            callback:this.handleFieldsNotification,parent:"Explorer"})
        this.addWSEventListener({eventname:[NotifierConstants.screenCreatedNotification,NotifierConstants.screenModifiedNotification,NotifierConstants.screenRemovedNotification],
            callback:this.handleScreensNotification,parent:"Explorer"})
        this.addWSEventListener({eventname:[NotifierConstants.screenProfileCreatedNotification,NotifierConstants.screenProfileModifiedNotification,NotifierConstants.screenProfileRemovedNotification],
            callback:this.handleScreenProfilesNotification,parent:"Explorer"})
        this.addWSEventListener({eventname:[NotifierConstants.userGroupCreatedNotification, NotifierConstants.userGroupModifiedNotification,NotifierConstants.userGroupRemovedNotification],
            callback:this.handleUserGroupsNotification,parent:"Explorer"})
        this.addWSEventListener({eventname:"reload-installed-plugins", callback:this.registorInstalledPlugins,parent:"Explorer"})
        this.addWSEventListener({eventname:"POOL_MODIFIED", callback:this.updatePools,parent:"Explorer"})
        this.addWSEventListener({eventname:"POOL_DEVICES_MODIFIED", callback:this.updatePoolDevices,parent:"Explorer"})
        this.addWSEventListener({eventname:Constants.jobStatusUpdateNotification, callback:this.displayJobsStatusesInPanel,parent:"Explorer"})
        this.addWSEventListener({eventname:"supportbundle-status-update", callback:this.triggerDownloadSupportBundleJob,parent:"Explorer"})
        this.addWSEventListener({eventname:[NotifierConstants.userLoggedInNotification,NotifierConstants.licenseUpdatedNotification], callback:this.handleUserLogin,parent:"Explorer"})
        this.addWSEventListener({eventname:Constants.retreiveSettingsNotification, callback:this.sendRetrieveSettingNotification, parent:"Explorer"});
        this.addWSEventListener({eventname:Constants.uploadSettingsNotification, callback:this.sendUploadSettingNotification, parent:"Explorer"});
        this.addWSEventListener({eventname:Constants.userUpdatedNotification, callback:this.sendUserUpdateNotification, parent:"Explorer"});    
        this.addWSEventListener({eventname:Constants.plugininstalledNotification, callback:this.sendpluginInstalledNotification, parent:"Explorer"}); 
        this.addWSEventListener({eventname:Constants.pluginupgradedNotification, callback:this.sendpluginUpgradedNotification, parent:"Explorer"}); 
        this.addWSEventListener({eventname:Constants.pluginUninstalledNotification, callback:this.sendPluginUninstalledNotification, parent:"Explorer"}); 
        this.addWSEventListener({eventname:NotifierConstants.globalSettingsUpdatedNotification, callback:this.updateGlobalSettingsValueFromNotification, parent:"Explorer"}); 
        this.addWSEventListener({eventname:NotifierConstants.languageUpdated, callback:this.handleLanguageUpdateNotification,parent:"Explorer"})
            this.addWSEventListener({
            eventname:[NotifierConstants.messageCreatedNotification, 
                      NotifierConstants.mentionedYouInMessageNotification, 
                      NotifierConstants.messageModifiedNotification, 
                      NotifierConstants.replyCountModifiedNotification],
            callback:this.handleMessageCreatedNotification,
            parent: "Explorer",
            browserNotificationPaylod:{
              id: "chat-id-explorer",
              parent: "Explorer",
              title_callback: Utils.getBrowserNotificationTitle,
              body_callback: Utils.getBrowserNotificationBody,
              icon_callback: Utils.getBrowserNotificationIconCallback,
              validator_callback: Utils.validateBrowserNotification,
              onclick_callbacks: [(notification)=>this.$router.push({name:"chat-display", params:Object.assign({}, notification)})]
            }
            });
        this.addWSEventListener({eventname:NotifierConstants.userNotificationCreated, callback:this.handleUserNotification, parent:"Explorer"});
        this.addWSEventListener({eventname:[NotifierConstants.uploadSettingsUpdated], callback:this.updateUploadInfo,parent:"Explorer"});
        this.addWSEventListener({eventname:NotifierConstants.mediaVersionSettingsUpdated, callback:this.handleVersionConfigUpdateNotification, parent:"Explorer"});
        this.addWSEventListener({eventname:NotifierConstants.subclipsSettingsUpdated, callback:this.handleSubclipsSettingsNotification,parent:"Explorer"})},
      unRegisterWebsocketNotifier(){
        this.removeWSEventListener({eventname:[NotifierConstants.userLoggedOutNotification], callback:this.handleUserForceLogot,parent:"Explorer"})
        this.removeEventListener({eventname:[NotifierConstants.userRemovedNotification], callback:this.handleUserDeletion,parent:"Explorer"})
        this.removeWSEventListener({
            eventname:[NotifierConstants.favoriteCreatedNotification, NotifierConstants.favoriteModifiedNotification, NotifierConstants.favoriteRemovedNotification],
            callback:this.handleFavNotification,
            parent:"Explorer"})
        this.removeWSEventListener({eventname:[NotifierConstants.fieldCreatedNotification,NotifierConstants.fieldModifiedNotification,NotifierConstants.fieldRemovedNotification],
            callback:this.handleFieldsNotification,parent:"Explorer"})
        this.removeWSEventListener({eventname:[NotifierConstants.screenCreatedNotification,NotifierConstants.screenModifiedNotification,NotifierConstants.screenRemovedNotification],
            callback:this.handleScreensNotification,parent:"Explorer"})
        this.removeWSEventListener({eventname:[NotifierConstants.screenProfileCreatedNotification,NotifierConstants.screenProfileModifiedNotification,NotifierConstants.screenProfileRemovedNotification],
            callback:this.handleScreenProfilesNotification,parent:"Explorer"})
        this.removeWSEventListener({eventname:[NotifierConstants.userGroupCreatedNotification, NotifierConstants.userGroupModifiedNotification,NotifierConstants.userGroupRemovedNotification],
            callback:this.handleUserGroupsNotification,parent:"Explorer"})
        this.removeWSEventListener({eventname:"reload-installed-plugins", callback:this.registorInstalledPlugins,parent:"Explorer"})
        this.removeWSEventListener({eventname:Constants.jobStatusUpdateNotification, callback:this.displayJobsStatusesInPanel,parent:"Explorer"})
        this.removeWSEventListener({eventname:"supportbundle-status-update", callback:this.triggerDownloadSupportBundleJob,parent:"Explorer"})
        this.removeWSEventListener({eventname:[NotifierConstants.userLoggedInNotification,NotifierConstants.licenseUpdatedNotification], callback:this.handleUserLogin,parent:"Explorer"})
        this.removeWSEventListener({eventname:Constants.retreiveSettingsNotification, callback:this.sendRetrieveSettingNotification, parent:"Explorer"});
        this.removeWSEventListener({eventname:Constants.uploadSettingsNotification, callback:this.sendUploadSettingNotification, parent:"Explorer"});
        this.removeWSEventListener({eventname:Constants.userUpdatedNotification, callback:this.sendUserUpdateNotification, parent:"Explorer"});    
        this.removeWSEventListener({eventname:Constants.plugininstalledNotification, callback:this.sendpluginInstalledNotification, parent:"Explorer"}); 
        this.removeWSEventListener({eventname:Constants.pluginupgradedNotification, callback:this.sendpluginUpgradedNotification, parent:"Explorer"}); 
        this.removeWSEventListener({eventname:Constants.pluginUninstalledNotification, callback:this.sendPluginUninstalledNotification, parent:"Explorer"}); 
        this.removeWSEventListener({eventname:NotifierConstants.globalSettingsUpdatedNotification, callback:this.updateGlobalSettingsValueFromNotification, parent:"Explorer"}); 
        this.removeWSEventListener({eventname:NotifierConstants.languageUpdated, callback:this.handleLanguageUpdateNotification,parent:"languageSettings"})
        this.removeWSEventListener({
            eventname:[NotifierConstants.messageCreatedNotification, 
                      NotifierConstants.mentionedYouInMessageNotification, 
                      NotifierConstants.messageModifiedNotification, 
                      NotifierConstants.replyCountModifiedNotification],
            callback:this.handleMessageCreatedNotification,
            parent: "Explorer",
            browserNotificationPaylod:{
              id: "chat-id-explorer",
              parent: "Explorer",
              title_callback: Utils.getBrowserNotificationTitle,
              body_callback: Utils.getBrowserNotificationBody,
              icon_callback: Utils.getBrowserNotificationIconCallback,
              validator_callback: Utils.validateBrowserNotification,
              onclick_callbacks: [(notification)=>this.$router.push({name:"chat-display", params:Object.assign({}, notification)})]
            }
            });
        this.removeWSEventListener({eventname:NotifierConstants.userNotificationCreated, callback:this.handleUserNotification, parent:"Explorer"});
        this.removeWSEventListener({eventname:[NotifierConstants.uploadSettingsUpdated], callback:this.updateUploadInfo,parent:"Explorer"});
        this.removeWSEventListener({eventname:NotifierConstants.mediaVersionSettingsUpdated, callback:this.handleVersionConfigUpdateNotification, parent:"Explorer"});
        this.removeWSEventListener({eventname:NotifierConstants.subclipsSettingsUpdated, callback:this.handleSubclipsSettingsNotification,parent:"Explorer"})},
      isUserTypeAdministrator(){
        return Utils.isUserTypeAdmin(this.getLoggedInUserType);
      },
     loadFusionConfigData(routeInfo,isCatalogOrBinsDisplay = false){
          this.isAssetsGetRequired = false;
          this.isReloadPanelComponentVisible = false;
          this.refreshMyspacePrivileges().then(()=>{
              this.getStartUpDataFromServer().then(()=>{
                this.updateAllUserActionstoInMem().then(()=>{
                  Promise.all([this.setUpContextMenuActions(),this.registorInstalledPlugins()]).then(() => {
                    if(isCatalogOrBinsDisplay){
                      console.log('isCatalogOrBinsDisplay',isCatalogOrBinsDisplay,' routeInfo routeInfo',routeInfo);
                      this.getBinsCatalogBrowseContext(true);
                 /*      if(this.$refs[this.getBinsCatalogBrowseContext().ref]){
                            this.getBinsCatalogBrowseContext(true);
                      } */
                      // this.changeSelectedMainComponent(routeInfo.name, Object.assign({query: routeInfo.query}, routeInfo.params))
                      this.setupContextmenuActionsOnReloadPanel();
                    }
                    return new Promise((res) => {
                       res('loaded');
                    });
                  });
                  // this.setUpContextMenuActions();
                  // this.registorInstalledPlugins()
                })
              });
            if (this.getPrivilegeFromInMem()["Basic"].length == 0 ){
              this.updateAllPrivilegetoInMem().then(()=>{
              })
            }
            if(this.$refs['quickAccessPanelRef']){
              this.$refs['quickAccessPanelRef'].getAllQuickAccessPanelEntries();
              this.$nextTick(() => {
                this.$refs['quickAccessPanelRef'].exitButtonClick();
              })
            }
          });
      },
      loadFusionExplorer(extRoutePath = {},isAssetsGetRequired){
        let promiseDeferreds = {'registorInstalledPlugins': null};
        let registerInstalledPluginPromise = new Promise(function(resolve, reject){
            promiseDeferreds.registorInstalledPlugins = {resolve: resolve, reject: reject};
        });
        this.refreshMyspacePrivileges().then(()=>{
            try {
              this.getStartUpDataFromServer().then((data)=>{
                if (data.client_ip){
                  this.setClientIp(data.client_ip)
                }
                if(data.ACTIVE_NOTIFIER_IP){
                  this.promiseNotifierIP.activeNotifierIP.resolve(data.ACTIVE_NOTIFIER_IP);
                }
                if(data.unread_status){
                  this.enableUserNotificationBadge = true;
                }
                if('DISABLE_SECURED_PASSWORD_ENFORCEMENT' in data){
                  Utils.setLocalStorageValue('enable_password_enforcement', JSON.stringify(!(data.DISABLE_SECURED_PASSWORD_ENFORCEMENT)))
                }else{
                  Utils.setLocalStorageValue('enable_password_enforcement', JSON.stringify(true))
                }
                if('enable_auto_complete_for_assets_search' in data){
                  Utils.setLocalStorageValue('enable_auto_complete_for_assets_search', JSON.stringify(data.enable_auto_complete_for_assets_search))
                }else{
                  Utils.setLocalStorageValue('enable_auto_complete_for_assets_search', JSON.stringify(true))
                }

                if('client_logo' in data && data.client_logo){
                  Utils.setLocalStorageValue('client_logo', JSON.stringify(data.client_logo));
                  this.showFusionLogo = false;
                }else{
                  Utils.setLocalStorageValue('client_logo', JSON.stringify(Utils.getLogoWithText()))
                  this.showFusionLogo = true;
                }

                if('landing_page_logo_web' in data && data.landing_page_logo_web){
                  Utils.setLocalStorageValue('landing_page_logo_web', JSON.stringify(data.landing_page_logo_web));
                  this.landingPageLogo = data.landing_page_logo_web;
                }else{
                  Utils.setLocalStorageValue('landing_page_logo_web', JSON.stringify(Utils.getLogo()))
                  this.landingPageLogo = Utils.getLogo();
                }

                if('client_branding_name' in data && data.client_branding_name){
                  Utils.setLocalStorageValue('client_branding_name', JSON.stringify(data.client_branding_name))
                }else{
                  Utils.setLocalStorageValue('client_branding_name', null)
                }

                if('pinned_bookmarks' in data){
                  this.showBookMarks = data.pinned_bookmarks;
                  if(this.showBookMarks)this.resizedHeight = `calc(100% - 50px)`;
                }

                if(data.new_updates){
                  let tempNewUpdatesArr = data.new_updates;
                  if(tempNewUpdatesArr && tempNewUpdatesArr.length){
                    for(let i = 0; i < tempNewUpdatesArr.length; i++){
                      if(tempNewUpdatesArr[i].type == 'page'){
                        this.setNewUpdatesPageData(tempNewUpdatesArr[i]);
                        this.pageNewUpdatesGuide = tempNewUpdatesArr[i];
                        setTimeout(() => {
                            if(tempNewUpdatesArr[i].page_url && window.location.href.startsWith(tempNewUpdatesArr[i].page_url)){
                              this.openNewUpdatesTour = true;
                            }
                        }, 200);
                      }
                      if(tempNewUpdatesArr[i].info && tempNewUpdatesArr[i].info.length){
                        for(let j = 0; j < tempNewUpdatesArr[i].info.length;j++){
                          tempNewUpdatesArr[i].info[j]["content"] = tempNewUpdatesArr[i].info[j].description + '<a href='+tempNewUpdatesArr[i].info[j].learn_more_url+' target="_blank" class="newUpdates-learn-more">Learn more</a>'
                          tempNewUpdatesArr[i].info[j]["target"] = tempNewUpdatesArr[i].info[j].element_id;
                          tempNewUpdatesArr[i].info[j]["_id"] = tempNewUpdatesArr[i]._id;
                          tempNewUpdatesArr[i].info[j]["header"] = {"title":tempNewUpdatesArr[i].info[j].title};
                        }
                        if(tempNewUpdatesArr[i].type == 'element'){
                          this.newUpdatesArr = tempNewUpdatesArr[i].info;
                          this.promiseNewUpdates.activeNewUpdateData.resolve(this.newUpdatesArr);
                        }
                      }
                    }
                  }
                }
               

                this.updateAllUserActionstoInMem().then(()=>{
                  this.setUpContextMenuActions();
                  this.registorInstalledPlugins().then((data) => {
                      promiseDeferreds.registorInstalledPlugins.resolve(data);
                  });
                })

                  let locationToLoad = Object.assign({}, this.getLocationinfoToLoad())

                  if (Object.keys(extRoutePath).length != 0){
                      Object.assign(locationToLoad, extRoutePath)
                  }
                   
                  /**
                   * 1. We store the window.href in App.vue when Vue_router does not resolve the path which means it is a external plugin (New method)
                   * 2. We are storing for the first time in App.vue
                   */
                  let newExternalPluginPath = this.getPathLocationInfoToLoad(); 

                  const loadRoute = () => { // loadroute function

                     console.log("[loadRoute loadRoute][loadRoute]",locationToLoad);
                      this.loadFusionParams = Object.assign({params:{},query:{}},locationToLoad);
                      // let locationL = Object.assign(this.getLocationInfoToLoad(),extRoutePath)
                      // let locationToLoad = Object.assign({},locationL)
                      this.lastPamLocationInfo = locationToLoad;
                      this.setLoadPageInfo({})
                      if (locationToLoad && locationToLoad.name && locationToLoad.name != undefined && locationToLoad.params && locationToLoad.query){
                        if (locationToLoad.matched.length && locationToLoad.matched[locationToLoad.matched.length-1] 
                            && locationToLoad.matched[locationToLoad.matched.length-1].parent 
                            && locationToLoad.matched[locationToLoad.matched.length-1].parent.name != "explorer" ){
                          let nested_parent_info = Utils.getChildRoutefromParentName("explorer", locationToLoad.matched)
                          if (nested_parent_info && Object.keys(nested_parent_info).length>0){
                            let requestedChildInfo = Utils.getChildRoutefromParentName(nested_parent_info.name, locationToLoad.matched)
                            locationToLoad = Object.assign({query:locationToLoad.query, params: Object.assign({requestedRoute:locationToLoad, subComp: requestedChildInfo.name}, locationToLoad.params)},nested_parent_info) 
                          }else{// only for tickets and for 'Client' user
                            setTimeout(() => {
                              // document.getElementById("home_page_sidemenu").childNodes[0].childNodes[0].click();
                              this.selectFirstMenu = true
                            },2000);  
                          }
                        }
                        if (locationToLoad.matched && locationToLoad.matched.length && locationToLoad.matched.length == 1 
                          && !locationToLoad.matched[locationToLoad.matched.length-1].parent){
                            setTimeout(() => {
                              // document.getElementById("home_page_sidemenu").childNodes[0].childNodes[0].click();

                              this.selectFirstMenu = true
                            },2000); 
                        }
                        if (locationToLoad.meta && locationToLoad.meta.componentType && locationToLoad.meta.componentType == "modal_component"){
                          // this.$router.push({
                          //   name: locationToLoad.name,
                          //   params: locationToLoad.params,
                          //   query: locationToLoad.query
                          // })
                          setTimeout(() => {  // On reload, SettingsSideMenu which depends on external plugins were loading before registeration. Hence added timeout
                            this.$router.push(locationToLoad)
                          },2000);
                        }else{
                          if(this.$refs[this.getBinsCatalogBrowseContext().ref] && isAssetsGetRequired){
                              this.getBinsCatalogBrowseContext(true);
                          }
                          this.changeSelectedMainComponent(locationToLoad.name, Object.assign({query: locationToLoad.query}, locationToLoad.params))
                        }
                      }else if(this.getRegisteredQuickAccessPannel().length || (this.$refs.quickAccessPanelRef && this.$refs.quickAccessPanelRef.fixedAndDynamicPanelsCombinedTogether && this.$refs.quickAccessPanelRef.fixedAndDynamicPanelsCombinedTogether.length)){
                        // this.getEventHandler(this.getRegisteredQuickAccessPannel()[0],"onClick",this.getRegisteredQuickAccessPannel()[0]["onEvents"])
                        registerInstalledPluginPromise.then(data =>{
                          let pathLocation = (locationToLoad && Object.hasOwnProperty.call(locationToLoad,'fullPath')) ? locationToLoad.fullPath : window.location.pathname;
                          let externalWorkspacePluginInfo = Utils.getCurrentMatchingRoute(pathLocation,data);
                            if(externalWorkspacePluginInfo){
                                  setTimeout(() => {
                                      this.addNewExternalPluginIframe(externalWorkspacePluginInfo);
                                      let isPluginLoaded = false;
                                      let dynamicPathObj = Utils.getCurrentMatchingRoute(pathLocation,data);
                                      if((dynamicPathObj && dynamicPathObj.route_info && dynamicPathObj.route_info.route_name)){
                                        let routedRegisteredObj = this.$router.resolve({name: dynamicPathObj.route_info.route_name});
                                        if(routedRegisteredObj && routedRegisteredObj.resolved.matched.length){
                                          this.enabledComponent = null;
                                          this.changeSelectedMainComponent(dynamicPathObj.route_info.route_name, Object.assign({query: locationToLoad.query}, locationToLoad.params), true)
                                          console.log('Route already present');
                                          isPluginLoaded = true;
                                        }
                                      }
                                      if(!isPluginLoaded){
                                          this.changeComponentToWorkspaceExternalPlugin(externalWorkspacePluginInfo);
                                      }
                                  },500);
                              }else{
                                  this.selectFirstMenu = true
                              }
                        });

                      }else{ // only for tickets and for 'Client' user
                          setTimeout(() => {
                            this.selectFirstMenu = true
                          }, 2000); 
                      }
                      /**
                       *  Load all other plugin bundles
                       */

                      /*
                      setTimeout(()=>{
                         for(let key in this.getRegisteredPluginMapper()){
                            let value = this.getRegisteredPluginMapper()[key];
                            console.log("Loading all other plugin bundles",value);
                            if(value && value.getAlldependentPluginBundles && typeof value.getAlldependentPluginBundles == 'function'){
                               if(this.loadedPluginName != value.name){
                                   console.log(`Loading....${value.name}`);
                                   value.getAlldependentPluginBundles();
                               }
                            }
                         }
                      },1200);

                      */


                  } //end of loadRoute

                if(locationToLoad && locationToLoad.name){
                    this.setLoadPageInfo(locationToLoad);
                    loadRoute(isAssetsGetRequired);
                    return;
                }else{
                  Promise.all([this.pluginsRegistryStatus,registerInstalledPluginPromise]).then(()=>{
                      console.log("Promise resolved......",this.$router.resolve({path:newExternalPluginPath}));
                      if(!this.externalPluginInstalledPromise){
                        return loadRoute(isAssetsGetRequired);
                      }
                      this.externalPluginInstalledPromise.then(()=>{
                          let rt = this.$router.resolve({path:newExternalPluginPath});
                          console.log("[External plugin][resolved route]",rt);
                          locationToLoad = rt.route;
                          this.setLoadPageInfo(rt.route);
                          loadRoute(isAssetsGetRequired);
                      });

                  });
                }
              })

              if (this.getPrivilegeFromInMem()["Basic"].length == 0 ){
                this.updateAllPrivilegetoInMem().then(()=>{
                })
              }

              /* Moved to manage version damplugin
              if(this.isEnabled('Manage Version')){
                this.getVersionPluginConfigDetails().then((data) => {
                  if(data.show_version_info)this.setVersionInfoDislayCheckDetails(data.show_version_info)
                })
              }*/
            } catch (error) {
              console.error(`[created][explorer][Error->${error}]`)
            }
            
            try {
              let payload = {};
              payload = {name:"catalog_workspace"}
              this.getConfiguredSearchActionsFromServer(payload).then((data)=>{
                this.setAdvancedSearchDataToStore(data)
              })
            }catch(error){
              console.error(`[created][explorer][Advanced search data][Error->${error}]`)
            }

            try {
              let payload = { params: { fetch_all: true } };
                this.getUsersAutoComplitionFromServer(payload).then((data) => {
                        this.setAllUsersBasicInfoIntoTheStore(data.users);
                    })
                    .catch((error) => {
                        console.error(`[getUsersAutoComplitionFromServer][Error]->${error}`);
                    });

            } catch (error) {
                console.error(`[created][explorer][Synchronous Error]->${error}`);
            }
            this.isReloadPanelComponentVisible = false;
        })
      },

      getAllProjectsList(){
          if(this.isEnabled('Projects')){
            this.getServerProjectsData().then((data) =>{
                this.allPamProjectsData = data;
                // if(this.isEnabled('Projects')){
                  // Utils.updateCookieByKeyName("pam_projects_list", this.allPamProjectsData);
                  localStorage.setItem("pam_projects_list", JSON.stringify(this.allPamProjectsData.projects));
                // }
            }); 
          }else if(this.isEnabled('Ticket') && !this.isEnabled('Projects')){
            this.getServerTicketProjectsList().then((data) =>{
                this.allPamProjectsData = data;
                // if(this.isEnabled('Ticket')){
                  // Utils.updateCookieByKeyName("pam_projects_list", this.allPamProjectsData);
                  localStorage.setItem("pam_projects_list", JSON.stringify(this.allPamProjectsData.projects));
                // }
            }); 
          }  
      },

      isClientUser(){
          if(this.getLoggedInUserType == 'Client'){
              return true;
          }else{
              return false;
          }
      },

  ...mapActions("settings", ["getLicensesListFromServer", "getlangaugesDetailsFromServer"]),
  ...mapActions("userGroups",["getUserGroupInfoFromServer"]),
  ...mapActions("pluginRepo", ["getInstalledPluginsFromServer"]),
  ...mapActions("customMetadata", ["getCustomMetadataInfoFromServer"]),
  ...mapActions("screens",["getScreenInfoFromServer"]),
  ...mapActions("metadataProfiles",["getMetadataProfileInfoFromServer"]),
  ...mapActions("users",["logOutFromServer", "updateLoggedInUserPreferences","getUsersAutoComplitionFromServer"]),
  ...mapActions("files", ["getFileInfoFromServer", "getAllFilesFromServer","getSearchKeywordAutoComplitionFromServer"]),
  ...mapActions("assets", ["getAssetInfoFromServer", "getAllAssetsFromServer"]),
  ...mapMutations("users",["setClientIp","setMetadataDockState","setAssetDetailsPanelState","setMiniplayerState","setAllUsersBasicInfoIntoTheStore"]),
  ...mapMutations("locations", ["setLocationChangeEventListenerCallback","unsetLocationHash", "setLoadPageInfo","setPathLocationInfo"]),
  ...mapActions("privileges", ["getUserSpacePrivilege","updateAllPrivilegetoInMem","updateAllUserActionstoInMem"]),
  ...mapActions("tags",["updateAllTagstoInMem"]),
  ...mapGetters("tags",["getTagsFromInMem"]),
  ...mapGetters("locations",["getLocationinfoToLoad","getPathLocationInfoToLoad"]),
  ...mapGetters("privileges",["getPrivilegeFromInMem"]),
  ...mapGetters("registry",["getRegisteredOverFlowMenu", "getRegisteredQuickAccessPannel","getLazyLoadPluginInfo","getRegisteredShareContextMenu","getRegisteredPluginMapper","getRegisteredGlobalNewButtons"]),
  ...mapMutations("registry",["unsetLazyLoadPluginInfo","removeQuickAccessPanelEntry","loadExternalPluginWorkspaceUI","registerDamPlugin","registerBinContextMenu", "updateActionCallbacks",
                              "registerBinsNewActionsContextMenu","registerBinsImportActionsContextMenu","registerBinsMoreActionsContextMenu","registerBinsShareActionsContextMenu", "registerAIToolActionsContextMenu", "registerOpenWithActionsContextMenu", "registerCatalogIconActionsContextMenu", "registerExportActionsContextMenu", "unsetAIToolActionsContextMenu",
                              "registerOverflowMenu","registerQuickAccessPanel", "unSetOverflowMenu", 
                              "unSetQuickAccessPanel","registerSystemSettingsMenu","unSetSystemSettingsMenu","registerCreateReviewButton","registerReviewTags","registerSettingsSidemenu","unSetSettingsSidemenu","registerPropertiesTopNav","unsetPropertiesTopNav",
                              "registerDialogForMediaBrowse","unsetDialogForMediaBrowse", "registerImportExportSettingsMenu", "unSetImportExportSettingsMenu","registerShareExternalPlugins","registerReportsSidemenu","registerDashboardWidgets","unsetDashboardWidgets","registerGlobalButtonExternalPlugin","registerPropertiesMetadataPlugins","registerMetadataDockPlugins","registerPropertiesTabPlugins","registerSubclipPlugins","exposeDamComponents","registerDashboardWidgetsPlugins","registerPamBrowserFromPamPlugin","registerMyApps","registerAllLinksBrowsePlugins", "registerPluginLicensePlugins","registerCustomReportsPLugins","registerPluginRouterRoutesForLoading","dontPlayOverlayScreensOverMiniplayerAssetDoc"]),
  ...mapActions("assets",["getCategoryTreefromId"]),
  ...mapGetters("categories",["getRootCategoryDetails"]),
  ...mapActions("startUpData",["getStartUpDataFromServer","updateStartUpEntry"]),
  ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener", "unsetWebsocket"]),
  ...mapActions("websocket",["connectToWebSocket"]),
  ...mapActions("actions",["triggerDownloadSupportBundleJob","updateReadStatusOfNewUpdates"]),
  ...mapGetters("privileges",["getPrivilegeFromInMem", "getOverFlowMenuFromInMem", "getQuickAccessPanelFromInMem","getActionListFromInMem"]),
  ...mapMutations("jobs", ["addToJobsDisplayList"]),
  ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
  ...mapMutations("startUpData",["updatestartupDatainfo"]),
  ...mapMutations("bins",["setPermissionOfSelectedBin"]),
  ...mapMutations("categories",["setRootCategoryDetails"]),
  ...mapMutations("miscellaneous", ["addChatStartupData",'setQuickAccessPanelEntriesData']),
  ...mapGetters("miscellaneous", ["getChatStartupData","getAIPanelState"]),
  ...mapActions('miscellaneous',['getMessagesUneadCount','getAllQuickAccessPanels','getConfiguredQuickAccessPanel']),
  ...mapActions("PAM",["getServerProjectsData","getServerTicketProjectsList"]),
  ...mapMutations("actions",["setNewUpdatesPageData"]),
  ...mapActions("pools",["getFusionPools","getPoolDevices","getQuickAccessPanelData"]),
  ...mapMutations("pools",["setPoolsInfo","setPoolDevices"]),
  ...mapMutations("pluginRepo",["setInstalledPluginsData"]),
  ...mapActions("favorites",["getAllFavoritesFromServer"]),
  ...mapMutations("favorites",["setFavourites"]),
  ...mapGetters("favorites",["getFavourites"]),
  ...mapMutations("versions",["setVersionInfoDislayCheckDetails"]),
  ...mapActions("versions",["getVersionPluginConfigDetails"]),
  ...mapMutations("search",["setAdvancedSearchState","setAdvancedSearchDataToStore"]),
  ...mapActions("search", ["getConfiguredSearchActionsFromServer"]),
},
  async created(){
     this.explorerComponentThis = this;
    try{
      await this.getUserFavListFromServer();
    }catch(e){console.log(e)}
    try{
      if(localStorage.getItem('fusion:viewtype')){
        const storedMetadataView = localStorage.getItem('fusion:metadataView');
        const storedViewType = localStorage.getItem('fusion:viewtype');
        if (storedMetadataView !== null) {
          this.isMetadataView = JSON.parse(storedMetadataView);
          if (this.isMetadataView) {
            this.gridView = false;
          } else {
            this.gridView = JSON.parse(storedViewType);
          }
        } else {
          this.gridView = JSON.parse(storedViewType);
          this.isMetadataView = false;
        }
          this.taskIssueListView = JSON.parse(localStorage.getItem('taskIssue:viewtype'));
      }
    }catch(e){console.log(e)}
    this.getLicenseErrorMessage();
    try{
      document.body.addEventListener('plugin-loaded',this.pluginMounted, false);
    }catch(e){console.log(e)}
    try{
      document.body.addEventListener('register-routes',this.registerDampluginsRoutes, false);
    }catch(e){console.log(e)}
    try{
      document.body.addEventListener('register-stores-routes',this.registerStoreAndRoutes, false);
    }catch(e){console.log(e)}
    this.promiseNewUpdates = {'activeNewUpdateData': null};
        this.newUpdatesFromStartupData = new Promise((resolve, reject) =>{
        this.promiseNewUpdates.activeNewUpdateData = {resolve: resolve, reject: reject};
    });
    this.promiseNotifierIP = {'activeNotifierIP': null};
        this.notifierIPFromStartupData = new Promise((resolve, reject) =>{
        this.promiseNotifierIP.activeNotifierIP = {resolve: resolve, reject: reject};
    });

    if('user_language' in this.getLoggedInUserInfo && this.getLoggedInUserInfo.user_language){
      this.selectedLanguage = this.getLoggedInUserInfo.user_language;
    }else if('application_language' in this.getStartUpDataFromInCache() && this.getStartUpDataFromInCache().application_language){
      this.selectedLanguage = this.getStartUpDataFromInCache().application_language;
    }
    
    this.loadFusionExplorer();
    try {
        let tempNotifierIP = Utils.getNotifierIp();
        this.notifierIPFromStartupData.then(IP =>{
          if(IP){
            tempNotifierIP = IP;
          } 
          this.connectToWebSocket({websocketurl:`wss://${tempNotifierIP}/dam_websocket`, loggedInUserId: this.getLoggedInUserId}).then(()=>{
              this.registerWebsocketNotifier();
          });
        }).catch(error => {
          console.error(`[created][explorer][Error in fetching Notifier IP->${error}`);
          this.connectToWebSocket({websocketurl:`wss://${tempNotifierIP}/dam_websocket`, loggedInUserId: this.getLoggedInUserId}).then(()=>{
              this.registerWebsocketNotifier();
          });
        });       
        this.updatePools()
        this.updatePoolDevices()
      } catch (error){
        console.error(`[created][explorer][Error->${error}`);
      }
    // if(this.isEnabled('Projects')){
      /**
       *  Below function this.getAllProjectsList();  moved to  PAM plugin
         this.getAllProjectsList(); 
      */
      if(Utils.getLocalStorageValue('client_logo')){
          this.logo = JSON.parse(Utils.getLocalStorageValue('client_logo'));
      }else{
          if(this.logo){
              this.logo = this.fusionlogo;
          }
      }

      if(Utils.getLocalStorageValue('landing_page_logo_web') && JSON.parse(Utils.getLocalStorageValue('landing_page_logo_web')).length > 0){
          this.landingPageLogo = JSON.parse(Utils.getLocalStorageValue('landing_page_logo_web'));
      }else{
          this.landingPageLogo = Utils.getLogo();
      }
    // }
  },
  mounted(){
    document.addEventListener("click", this.handleCatalogViewOutsideClick, true);
    window.addEventListener("keydown", this.handleGlobalKey);

     try{
        this.getActiveLanguagesList();
    }catch(e){console.log(e)}
    
    if(this.newUpdatesFromStartupData){
      this.newUpdatesFromStartupData.then(() =>{
        this.startVueTour()
      });
    }

    this.getCookieValueOfJobPanel = Utils.getCookieValue('jobPanelState');

     try{
        this.$off('playSubclipMarkinMarkout',this.playeSubclipPreview);
        this.$on('playSubclipMarkinMarkout',this.playeSubclipPreview);
     }catch(e){console.log(e)}
     this.isNLPSearchMode = Utils.getLocalStorageValue('fusion:isNLPSearchMode') ? JSON.parse(Utils.getLocalStorageValue('fusion:isNLPSearchMode')) : false;
     this.exposeDamComponents({explorer:()=>{return this}});
  },
  beforeDestroy(){
    document.removeEventListener("click", this.handleCatalogViewOutsideClick, true);
    window.removeEventListener("keydown", this.handleGlobalKey);
    try{
      document.body.removeEventListener('plugin-loaded',this.pluginMounted, false);
    }catch(e){console.log(e)}
    try{
      document.body.removeEventListener('register-routes',this.registerDampluginsRoutes, false);
    }catch(e){console.log(e)}
    try{
      document.body.removeEventListener('register-stores-routes',this.registerStoreAndRoutes, false);
    }catch(e){console.log(e)}
      /** 
      * As Explorer component destroys when user lands into login page otherwise it will stay throughout the application
      * we need to unset some of the state of vuex upon logout which is destory of this component.
      * to fix DAM-693  we need to adapt this approach can be improved.
      */
      this.unRegisterWebsocketNotifier()
      this.unsetWebsocket()
      this.$store.commit('privileges/resetPrivileges');
      let registryUnsetList = ['unSetOverflowMenu','unSetQuickAccessPanel','unSetSettingsSidemenu','unSetFloatingMenu','unSetBinContextMenu','unSetBinsMoreActionsContextMenu','unsetBinsNewActionsContextMenu','unSetPreferencesSidemenu','unSetReportsSideMenu','unSetSystemSettingsMenu','unsetPropertiesTopNav','unSetImportExportSettingsMenu'];
      for(let i = 0; i < registryUnsetList.length; i++){
          try{
              this.$store.commit(`registry/${registryUnsetList[i]}`);
          }catch(e){console.log(e)}
      }
      this.resizeObservor.disconnect();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
.catalog-view-selector { position: relative; }
.catalog-view-trigger { display: inline-flex; align-items: center; justify-content: center; gap: 5px; padding: 11px; color: #c5c0c0; background: transparent; border: 0; height: 100%; cursor: pointer; }
.catalog-view-trigger > svg:not(.catalog-view-chevron) { width: 22px; height: 22px; fill: currentColor; flex: 0 0 22px; }
.catalog-view-options svg { width: 18px; height: 18px; fill: currentColor; }
.catalog-view-trigger .catalog-view-chevron { width: 12px; height: 12px; fill: none; }
.catalog-view-options.view-icons button { display: flex; justify-content: center; align-items: center; min-height: 34px; }
.ratio-icon { display: block; border: 1.5px solid currentColor; border-radius: 2px; }
.ratio-icon.landscape { width: 18px; height: 10px; }
.ratio-icon.square { width: 13px; height: 13px; }
.ratio-icon.portrait { width: 10px; height: 18px; }
.catalog-view-trigger:hover { color: white; background: transparent; }
.catalog-view-trigger:focus-visible { outline: 2px solid #80bdff; outline-offset: -2px; }
.catalog-view-menu { position: absolute; top: 100%; right: 0; z-index: 10000; max-height: calc(100vh - 80px); overflow-y: auto; padding: 14px; width: min(270px, calc(100vw - 16px)); color: #eee; background: #1a1e21; border: 1px solid #454a4e; border-radius: 8px; box-shadow: 0 8px 24px rgba(0,0,0,.3); }
.catalog-view-menu-label { font-size: 12px; color: #aeb7bb; margin-bottom: 8px; text-align: start; }
.catalog-view-menu-label.size-label { margin-top: 16px; }
.thumbnail-size-slider { appearance: none; -webkit-appearance: none; display: block; width: 100%; height: 16px; margin: 2px 0; padding: 0; border: 0; background: transparent; cursor: pointer; outline: none; }
.thumbnail-size-slider::-webkit-slider-runnable-track { height: 4px; border-radius: 4px; background: linear-gradient(to right, #2dbad4 0%, #2dbad4 var(--slider-progress), #596168 var(--slider-progress), #596168 100%); }
.thumbnail-size-slider::-webkit-slider-thumb { -webkit-appearance: none; width: 14px; height: 14px; margin-top: -5px; border: 0; border-radius: 50%; background: #2dbad4; }
.thumbnail-size-slider::-moz-range-track { height: 4px; border-radius: 4px; background: #596168; }
.thumbnail-size-slider::-moz-range-progress { height: 4px; border-radius: 4px; background: #2dbad4; }
.thumbnail-size-slider::-moz-range-thumb { width: 14px; height: 14px; border: 0; border-radius: 50%; background: #2dbad4; }
.thumbnail-size-slider:focus-visible::-webkit-slider-thumb { box-shadow: 0 0 0 3px rgba(45,186,212,.35); }
.thumbnail-size-slider:focus-visible::-moz-range-thumb { box-shadow: 0 0 0 3px rgba(45,186,212,.35); }
.catalog-view-options { display: flex; gap: 5px; }
.catalog-view-options button { flex: 1; padding: 7px 8px; border: 1px solid #454b50; border-radius: 5px; color: #dedede; background: #252b30; font-size: 12px; }
.catalog-view-options button:hover { background: #343c42; }
.catalog-view-options button.selected { background: #17667c; border-color: #35b8d4; color: white; }
.catalog-view-options button:focus-visible { outline: 2px solid white; outline-offset: 2px; }


  $border-color: 1px solid #4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $secondary-border-hover-color:#767676;

  .sidebar-main{
    background: $secondary-background-color;
  }

  .activePanel{
    color:$active-blue !important;
    background: $primary-background !important;
    svg{
      color:$active-blue !important;
      fill:$active-blue !important;
    }
  }
    .showSettings{
      display:block;
    }
  .sidenav{
      height: calc(100% - 65px);
      border-top: none;
      padding:0px !important;
      .sidebar{
        background: $secondary-background-color;
        color: $secondary-text-color;
        min-height:70px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-radius: 10px;
        margin-bottom:4px;
      }
      .sidebar:hover{
        color: $text-color;
        background: $primary-background !important;
      }
    }

    .dropdown-menu{
      background-color:$secondary-background-color !important;
      border: $border-color;
      .dropdown-item{
        color:$text-color;
        font-size:14px !important; 
        word-break: break-word;
      }
  }

  .dropdown-item:hover{
      background-color:$bg-color-on-hover !important;
  }
  .nav-item{
      color: $secondary-text-color !important;
  }

  .profile-img-option:hover{
    background:$bg-color-on-hover !important;
    border-radius: 50%;
  }

  .dropdown-toggle:after{
    display:none !important;
  }
  
  header, footer{
      background: $secondary-background-color;
  }


  .border{
      border: $border-color !important;
  }

  // svg{
  //     color: #939393;
  // }

  /* width */

  #home_page_sidemenu::-webkit-scrollbar {
    width: 5px;
  }

  .tooltip-box {
        background-color: #6c757d;
        color: #fff;
        padding: 6px 10px;
        border-radius: 4px;
        font-size: 12px;
        // position: fixed;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        z-index: 1000;
        margin: 0; /* important */
        margin: 0;
        inset-inline-start: 24px;
        top: 40px;
        position:absolute
    }

    /* Arrow centered horizontally at bottom of tooltip */
    .tooltip-arrow {
        position: absolute;
        top: -10px;
        inset-inline-start: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-inline-start: 8px solid transparent;
        border-inline-end: 8px solid transparent;
        border-bottom: 10px solid #6c757d;
    }

  ::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $secondary-background-color;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $primary-background;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover;
  }

  .assets-details-wrapper{
      padding: 0px;
      border-inline-start: $border-color;
      border-inline-end: $border-color;
      height: 100%;
  }

  .search-bar{
    border:$border-color !important;
    background: $primary-background !important;
    width:100%;
    height:30px;
    margin-inline-start:2%;
    pointer-events: all;
    color: $text-color !important;
    padding-inline-start: 14px;
  }

  .row{
      margin-inline-end: -12px;
      margin-inline-start: -12px;
      margin:0px;
  }

  a#bd-versions:hover {
      background: $bg-color-on-hover;
      border-radius: 32px;
  }

  .help-menu{
      position: absolute;
      top: 0px;
      inset-inline-end: 100%;
      background: $secondary-background-color;
      border-radius: 4px;
      border:$border-color;
      overflow: auto;
      max-height: 400px;
  }

  .slider-icon{
    fill: #a1a1a1;
    position: absolute;
    inset-inline-end: -39px;
    bottom: 6px;
  }

  .slider-icon:hover{
    fill: #fff;
  }
  .user-name-or-image{
      height: 30px;
      width: 30px;
      border: $border-color;
      border-radius: 10px;
      text-align: center;
      line-height: unset;
      text-transform: uppercase;
      // margin-top: 3px;
      top:0px;
  }

  .user-name{
      // margin-inline-end: 10px;
      position: relative;
      // bottom: 7px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
  }
  [v-cloak] .hide-element-util-mount{ //sometimes un-necessary preview dialog was showing to hide code is required
    display: none;
  }
  .hide{display:none;}

  .new-tag-styles{
    border:$border-color;
    border-radius: 10px;
    background: #2f839e;
    position:absolute;
    top:0px;
    inset-inline-end:0px;
    padding:4px;
    font-size:10px;
    color:$text-color;
    font-weight: 700;
  }

  ::v-deep {
    .search-bar-autocomplete-wrapper{
      .multiselect--active{
        --saf-0: rgba(var(--sk_highlight,18,100,163),1) !important; 
        box-shadow: 0 0 0 1px var(--saf-0), 0 0 0 5px #00254e !important;
      }
      .multiselect__tags input{
        padding-inline-end:20px !important;
      }

      .multiselect__single{
        white-space: nowrap;
        // direction: rtl;
        padding-inline-end: 20px;
        overflow: hidden;
        width:96% !important;
      }
      .multiselect__content-wrapper{
            display:none;
          }
          .multiselect__tag {
            background-color: $primary-background !important;
          }
          .multiselect__tags{
              border: none !important;
          }
          .multiselect__option--highlight {
              background: $bg-color-on-hover !important;
          }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
          outline:none;
          box-shadow: none;
        }
        .multiselect__tag-icon{
          color:$text-color !important;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
          color:$secondary-text-color !important;
          font-size: 23px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size !important;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__placeholder {
          padding-top: 0px;
          padding-inline-start: 5px !important;
        }
        .multiselect{
          color:$text-color !important;
          font-size: $input-field-and-label-font-size !important;
          width:100%;
          min-height: 38px;
          height: 38px;
          margin:0px !important;
          padding: 0px !important;
      }
      .multiselect__option--selected{
          background: $bg-color-on-hover !important;
          color: $text-color;
      }
      .multiselect__content-wrapper{
          border: $border-color !important;
          position: relative;
          display: block;
          background: $secondary-background-color !important;
          width: 100%;
          max-height: 240px;
          overflow: auto;
          border: 1px solid $text-color;
          border-top: none;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          z-index: 50;
          -webkit-overflow-scrolling: touch;
      }
      .multiselect__select,.multiselect__current,.multiselect__option{
          line-height: 12px !important;
      }

      .multiselect__select{
        display: none !important;
      }
      .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
      }
      .multiselect__tags {
          background: $primary-background!important;
          height: $input-field-height;
          min-height: 38px;
      }
    }

    .search-bar-autocomplete-wrapper.has-sparkle{
      .multiselect__tags {
        padding-inline-start: 48px;
      }
    }
    #dam_explorer_global_language_button{
      width:120px;
       .multiselect__tags {
            background: transparent !important;
            padding-inline-start: 0px !important;
            height: 36px !important;
            // width: 142px;
            min-height: 36px;
            display: flex;
            align-items: center;
            margin:0px !important;
            height: 100%;
            padding-inline-start: 8px !important;
            border:$border-color !important;
            //padding: 8px 40px 0 8px;
        }

        .multiselect:hover .multiselect__tags{
          border: 1px solid $secondary-border-hover-color !important;
        }

         .multiselect__content-wrapper{
            display:none;
          }
         
          .multiselect__option--highlight {
              background: $bg-color-on-hover !important;
          }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
          outline:none;
          box-shadow: none;
        }
        .multiselect__tag-icon{
          color:$text-color !important;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
          color:$secondary-text-color !important;
          font-size: 23px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size !important;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__placeholder {
          padding-top: 0px;
          padding-inline-start: 5px !important;
        }
        .multiselect{
          color:$text-color !important;
          font-size: $input-field-and-label-font-size !important;
          width:100%;
          min-height: 38px;
          height: 38px;
          margin:0px !important;
          padding: 0px !important;
      }
      .multiselect__option--selected{
          background: $bg-color-on-hover !important;
          color: $text-color;
      }
      .multiselect__content-wrapper{
          border: $border-color !important;
          position: relative;
          display: block;
          background: $secondary-background-color !important;
          width: 100%;
          max-height: 240px;
          overflow: auto;
          border: 1px solid $text-color;
          border-top: none;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          z-index: 50;
          -webkit-overflow-scrolling: touch;
      }
      .multiselect__select,.multiselect__current,.multiselect__option{
          line-height: 12px !important;
      }

      .multiselect__select:before{
        top:60% !important;
      }
      .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
      }
    }    

    .v-step__buttons{
      display: flex;
      justify-content: end;
    }

    .v-step,.v-step__header{
      background: #279385 !important;
    }
    .v-step__header{
      font-size:21px;
      text-align: initial;
      margin-bottom:0px !important;
    }

    .v-step__arrow--dark[data-v-54f9a632]:before {
      background: #279385 !important;
    }

    .v-step__content{
       position: relative;
       inset-inline-start: -7px;
       display: flex !important;
       text-align: initial !important;
       a{
          margin-inline-start: 3px;
          color: #ffe22e;
          display: flex;
          align-items: end;
          position: relative;
          inset-inline-start: -3px;
       }
       a:hover{
          margin-inline-start: 3px;
          color: #ffe22e;
          display: flex;
          align-items: end;
          position: relative;
          inset-inline-start: -3px;
          text-decoration: underline;
       }
    }

    .btn-warning,  .v-step__button-stop{
      background: #ab9300 !important;
      border:1px solid  #21665d !important;
      border-radius:3px !important;
      color:#fff;
    }

    .v-tour__target--highlighted {
        box-shadow: 0 0 0 9999px rgba(0,0,0,.5);
    }

    .disable-parent:before{
      content: "";
      display: inline-block;
      height: 100vh;
      vertical-align: middle;
      margin-inline-end: -4px;
      position: fixed;
      width: 100vw;
      inset-inline-start: 0;
      top: 0;
      background: #13131394 !important;
    }

    .disable-modal-parent{
      filter: brightness(0.5);
      pointer-events: none;
      .modal-content{
        pointer-events: none;
      }
    }
  }

  .notification-badge{
    position: absolute;
    height: 12px;
    width: 12px;
    background: red;
    border-radius: 20px;
    top: 3px;
    inset-inline-end: 6px;
    border: $border-color;
  }

  .has-sparkle.sparkle-multiselect-adjust .multiselect__tags {
    padding-inline-start: 40px !important;
}

.is-smart-active .sparkle-btn-inner {
    color: #0779fb !important;
}

/* 1. Ensure the sparkle button is always on top of the multiselect */
.sparkle-btn-inner {
  position: absolute;
  inset-inline-start: 9px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000 !important;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  height: 24px;
  width: 24px;
  justify-content: center;
  color: #a1a1a1;
}

.sparkle-btn-inner:hover{
  background: #393939a3;
  border-radius: 4px;
  color: #ddd;
}

/* 2. The divider also needs a high z-index */
.sparkle-v-divider {
  position: absolute;
  inset-inline-start: 42px;
  top: 25%;
  height: 50%;
  width: 1px;
  background: $dull-text-color;
  z-index: 1000 !important;
}

/* 3. Push the Multiselect Placeholder/Input to the right */
/* This targets the internal container of the Vue-Multiselect */
.sparkle-multiselect-adjust .multiselect__tags {
  padding-inline-start: 45px !important; 
}

.sparkle-multiselect-adjust .multiselect__placeholder {
  padding-inline-start: 35px !important; /* Specifically moves the placeholder text */
  margin-bottom: 0px !important;
}

.sparkle-multiselect-adjust .multiselect__input {
  padding-inline-start: 35px !important; /* Moves the typing cursor/text */
  background: transparent !important;
}
</style>